var _style, _path, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _defs37, _defs38, _polygon, _defs39, _defs40, _defs41, _defs42, _defs43, _defs44, _defs45, _defs46, _defs47, _defs48, _defs49, _defs50, _defs51, _defs52, _defs53, _defs54, _defs55, _defs56, _defs57, _defs58, _defs59, _defs60, _defs61, _defs62, _defs63, _defs64, _defs65, _defs66, _defs67, _defs68, _defs69, _defs70, _defs71, _defs72, _defs73, _defs74, _defs75, _defs76, _polygon2, _defs77, _defs78, _defs79, _defs80, _defs81, _defs82, _defs83, _defs84, _defs85, _defs86, _defs87, _defs88, _defs89, _defs90, _defs91, _defs92, _defs93, _defs94, _defs95, _defs96, _defs97, _defs98, _defs99, _defs100, _defs101, _defs102, _defs103, _defs104, _defs105, _defs106, _defs107, _defs108, _defs109, _defs110, _defs111, _defs112, _defs113, _defs114, _defs115, _defs116, _defs117, _defs118, _defs119, _defs120, _defs121, _defs122, _defs123, _defs124, _defs125, _defs126, _defs127, _defs128, _defs129, _defs130, _defs131, _defs132, _defs133, _defs134, _defs135, _defs136, _defs137, _defs138, _defs139, _defs140, _defs141, _defs142, _defs143, _defs144, _defs145, _defs146, _defs147, _defs148, _defs149, _defs150, _defs151, _defs152, _path2, _defs153, _defs154, _defs155, _defs156, _defs157, _defs158, _defs159, _defs160, _defs161, _defs162, _defs163, _defs164, _defs165, _defs166, _defs167, _defs168, _defs169, _defs170, _defs171, _defs172, _defs173, _defs174, _defs175, _defs176, _defs177, _defs178, _defs179, _defs180, _defs181, _defs182, _defs183, _defs184, _defs185, _defs186, _defs187, _defs188, _defs189, _defs190, _defs191, _defs192, _defs193, _defs194, _defs195, _defs196, _defs197, _defs198, _defs199, _defs200, _defs201, _defs202, _defs203, _defs204, _defs205, _defs206, _defs207, _defs208, _defs209, _defs210, _defs211, _defs212, _defs213, _defs214, _defs215, _defs216, _defs217, _defs218, _defs219, _defs220, _defs221, _defs222, _defs223, _defs224, _defs225, _defs226, _defs227, _defs228, _defs229, _defs230, _defs231, _defs232, _defs233, _defs234, _defs235, _defs236, _defs237, _defs238, _defs239, _defs240, _defs241, _defs242, _defs243, _defs244, _defs245, _defs246, _defs247, _defs248, _defs249, _defs250, _defs251, _defs252, _defs253, _defs254, _defs255, _defs256, _defs257, _defs258, _defs259, _defs260, _defs261, _defs262, _defs263, _defs264, _defs265, _defs266, _defs267, _defs268, _defs269, _defs270, _defs271, _defs272, _defs273, _defs274, _defs275, _defs276, _defs277, _defs278, _defs279, _defs280, _defs281, _defs282, _defs283, _defs284, _defs285, _defs286, _defs287, _defs288, _defs289, _defs290, _defs291, _defs292, _defs293, _defs294, _defs295, _defs296, _defs297, _defs298, _defs299, _defs300, _defs301, _defs302, _defs303, _defs304, _defs305, _defs306, _defs307, _defs308, _defs309, _defs310, _defs311, _defs312, _defs313, _defs314, _defs315, _defs316, _defs317, _defs318, _defs319, _defs320, _defs321, _defs322, _defs323, _defs324, _defs325, _defs326, _defs327, _defs328, _defs329, _defs330, _defs331, _defs332, _defs333, _defs334, _defs335, _defs336, _defs337, _defs338, _defs339, _defs340, _defs341, _defs342, _polygon3, _defs343, _defs344, _defs345, _defs346, _defs347, _defs348, _defs349, _defs350, _defs351, _defs352, _defs353, _defs354, _defs355, _defs356, _defs357, _defs358, _defs359, _defs360, _defs361, _defs362, _defs363, _defs364, _defs365, _defs366, _defs367, _defs368, _defs369, _defs370, _defs371, _defs372, _defs373, _defs374, _defs375, _defs376, _defs377, _defs378, _defs379, _defs380, _polygon4, _defs381, _defs382, _defs383, _defs384, _defs385, _defs386, _defs387, _defs388, _defs389, _defs390, _defs391, _defs392, _defs393, _defs394, _defs395, _defs396, _defs397, _defs398, _defs399, _defs400, _defs401, _defs402, _defs403, _defs404, _defs405, _defs406, _defs407, _defs408, _defs409, _defs410, _defs411, _defs412, _defs413, _defs414, _defs415, _defs416, _defs417, _defs418, _defs419, _defs420, _defs421, _defs422, _defs423, _defs424, _defs425, _defs426, _defs427, _defs428, _defs429, _defs430, _defs431, _defs432, _defs433, _defs434, _defs435, _defs436, _defs437, _defs438, _defs439, _defs440, _defs441, _defs442, _defs443, _defs444, _defs445, _defs446, _defs447, _defs448, _defs449, _defs450, _defs451, _defs452, _defs453, _defs454, _defs455, _defs456, _path3, _defs457, _defs458, _defs459, _defs460, _defs461, _defs462, _defs463, _defs464, _defs465, _defs466, _defs467, _defs468, _defs469, _defs470, _defs471, _defs472, _defs473, _defs474, _defs475, _defs476, _defs477, _defs478, _defs479, _defs480, _defs481, _defs482, _defs483, _defs484, _defs485, _defs486, _defs487, _defs488, _defs489, _defs490, _defs491, _defs492, _defs493, _defs494, _defs495, _defs496, _defs497, _defs498, _defs499, _defs500, _defs501, _defs502, _defs503, _defs504, _defs505, _defs506, _defs507, _defs508, _defs509, _defs510, _defs511, _defs512, _defs513, _defs514, _defs515, _defs516, _defs517, _defs518, _defs519, _defs520, _defs521, _defs522, _defs523, _defs524, _defs525, _defs526, _defs527, _defs528, _defs529, _defs530, _defs531, _defs532, _defs533, _defs534, _defs535, _defs536, _defs537, _defs538, _defs539, _defs540, _defs541, _defs542, _defs543, _defs544, _defs545, _defs546, _defs547, _defs548, _defs549, _defs550, _defs551, _defs552, _defs553, _defs554, _defs555, _defs556, _defs557, _defs558, _defs559, _defs560, _defs561, _defs562, _defs563, _defs564, _defs565, _defs566, _defs567, _defs568, _defs569, _defs570, _defs571, _defs572, _defs573, _defs574, _defs575, _defs576, _defs577, _defs578, _defs579, _defs580, _defs581, _defs582, _defs583, _defs584, _defs585, _defs586, _defs587, _defs588, _defs589, _defs590, _defs591, _defs592, _defs593, _defs594, _defs595, _defs596, _defs597, _defs598, _defs599, _defs600, _defs601, _defs602, _defs603, _defs604, _defs605, _defs606, _defs607, _defs608;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeWidget1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1_kopie",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.9 243.3",
    style: {
      enableBackground: "new 0 0 115.9 243.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000037672464204453615760000014044720655163527834_);}\r\n\t.st2{fill:url(#SVGID_00000128446797956596272860000008132934659944779957_);}\r\n\t.st3{fill:url(#SVGID_00000139272749008356931860000016532815382457375150_);}\r\n\t.st4{clip-path:url(#SVGID_00000115488137924175527420000013907820617723778461_);}\r\n\t.st5{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st6{clip-path:url(#SVGID_00000017493659224666534740000004126449313136446858_);}\r\n\t.st7{clip-path:url(#SVGID_00000150082511993612676310000017301950116191234718_);}\r\n\t.st8{clip-path:url(#SVGID_00000051381116973861689750000006276414455952494998_);}\r\n\t.st9{clip-path:url(#SVGID_00000174584653929672611360000008853554997406301322_);}\r\n\t.st10{clip-path:url(#SVGID_00000161623428459350820020000000797660186690068874_);}\r\n\t.st11{clip-path:url(#SVGID_00000127037837261536021010000001138012518155375278_);}\r\n\t.st12{clip-path:url(#SVGID_00000086680172558241806860000000763415513416178567_);}\r\n\t.st13{clip-path:url(#SVGID_00000098941438295859807430000006453307507502792107_);}\r\n\t.st14{clip-path:url(#SVGID_00000060027924840347226540000010510365412218134656_);}\r\n\t.st15{clip-path:url(#SVGID_00000088122505071514579990000006000919099996088967_);}\r\n\t.st16{clip-path:url(#SVGID_00000078020451046681675100000004544996073168668597_);}\r\n\t.st17{clip-path:url(#SVGID_00000067930401148580293120000007844412111397862550_);}\r\n\t.st18{clip-path:url(#SVGID_00000136407910433882875850000018126862421088557485_);}\r\n\t.st19{clip-path:url(#SVGID_00000128474601237925145950000014848263862296223129_);}\r\n\t.st20{clip-path:url(#SVGID_00000097476145180737055320000002136297132455152297_);}\r\n\t.st21{clip-path:url(#SVGID_00000013169038135701458760000017324208658224702084_);}\r\n\t.st22{clip-path:url(#SVGID_00000058588225755499592990000003139018848758675640_);}\r\n\t.st23{clip-path:url(#SVGID_00000008837743874194198610000001855671936410987435_);}\r\n\t.st24{clip-path:url(#SVGID_00000052785156932683069780000002981419015008369845_);}\r\n\t.st25{clip-path:url(#SVGID_00000168838525373815780220000012469629284188909754_);}\r\n\t.st26{clip-path:url(#SVGID_00000106132367153700585050000013393472970432753815_);}\r\n\t.st27{clip-path:url(#SVGID_00000125598385639392925430000017791784940779591829_);}\r\n\t.st28{clip-path:url(#SVGID_00000111911679150488793870000016625131864909825168_);}\r\n\t.st29{clip-path:url(#SVGID_00000124855898024445226960000010088951509913215141_);}\r\n\t.st30{clip-path:url(#SVGID_00000155147958513093622320000018354407854791727494_);}\r\n\t\r\n\t\t.st31{clip-path:url(#SVGID_00000073685683536141424660000014586674891583970696_);fill:url(#SVGID_00000142139860678925967220000009370183105783646377_);}\r\n\t\r\n\t\t.st32{clip-path:url(#SVGID_00000017493659224666534740000004126449313136446858_);mask:url(#SVGID_00000155864389099146695010000010258589812684560829_);fill:url(#SVGID_00000044880581767749936110000010708930104390686367_);}\r\n\t.st33{fill:#1E110E;}\r\n\t.st34{clip-path:url(#SVGID_00000138574552272515304310000006105042677519583620_);}\r\n\t.st35{filter:url(#Adobe_OpacityMaskFilter_00000107575025520909211130000018252982147752017304_);}\r\n\t.st36{clip-path:url(#SVGID_00000140710380274311199370000011970859405648588949_);}\r\n\t.st37{clip-path:url(#SVGID_00000037672034119296006370000011149614425099105705_);}\r\n\t.st38{clip-path:url(#SVGID_00000054978788934454609500000000127157041771511223_);}\r\n\t.st39{clip-path:url(#SVGID_00000087394324958474470880000001214712892125929897_);}\r\n\t.st40{clip-path:url(#SVGID_00000118357113705809868110000010891156770231956363_);}\r\n\t.st41{clip-path:url(#SVGID_00000158004502903070452430000002013324982479014296_);}\r\n\t.st42{clip-path:url(#SVGID_00000042014315728049275180000000790212501811101851_);}\r\n\t.st43{clip-path:url(#SVGID_00000088097100666387661170000000243865975180021633_);}\r\n\t.st44{clip-path:url(#SVGID_00000085966001639819330410000010103766382446200193_);}\r\n\t.st45{clip-path:url(#SVGID_00000150075007749268367590000005207178498870294410_);}\r\n\t.st46{clip-path:url(#SVGID_00000069368541325010721150000016270766939912689063_);}\r\n\t.st47{clip-path:url(#SVGID_00000168093985353130242880000013531373941037095342_);}\r\n\t.st48{clip-path:url(#SVGID_00000144330951792945402910000001753368447825736354_);}\r\n\t.st49{clip-path:url(#SVGID_00000040550810587869183970000007053421464782475153_);}\r\n\t.st50{clip-path:url(#SVGID_00000148651983215600827840000011033542129424085909_);}\r\n\t.st51{clip-path:url(#SVGID_00000042709418577875888920000013990622434929378981_);}\r\n\t.st52{clip-path:url(#SVGID_00000148625477298618204790000011503116312379954103_);}\r\n\t.st53{clip-path:url(#SVGID_00000152944967544158214090000008088730404551799936_);}\r\n\t.st54{clip-path:url(#SVGID_00000159448213632510349390000015272949906606941079_);}\r\n\t.st55{clip-path:url(#SVGID_00000098212460516422173080000009636322006597393057_);}\r\n\t.st56{clip-path:url(#SVGID_00000139291524565632943950000016057366620345634734_);}\r\n\t.st57{clip-path:url(#SVGID_00000174590025911257839230000000934546656939265454_);}\r\n\t.st58{clip-path:url(#SVGID_00000102525142921133455840000008833460960193151891_);}\r\n\t.st59{clip-path:url(#SVGID_00000047779707417296542270000016506261087308918176_);}\r\n\t.st60{clip-path:url(#SVGID_00000096756612822756257700000002967754357156660655_);}\r\n\t\r\n\t\t.st61{clip-path:url(#SVGID_00000122687210849822290760000008590581972750702253_);fill:url(#SVGID_00000064319366084454070050000015441709959532570799_);}\r\n\t\r\n\t\t.st62{clip-path:url(#SVGID_00000140710380274311199370000011970859405648588949_);mask:url(#SVGID_00000098934027997011458060000011905611488815384453_);fill:url(#SVGID_00000013896804267949227220000010933113543126171281_);}\r\n\t.st63{fill:url(#SVGID_00000083800629383833102990000012916924691540169137_);}\r\n\t.st64{clip-path:url(#SVGID_00000077292649842840599460000010309579290856615611_);}\r\n\t.st65{filter:url(#Adobe_OpacityMaskFilter_00000151526792927008331130000006125249753098504348_);}\r\n\t.st66{clip-path:url(#SVGID_00000000938420876952864410000016312580530605704076_);}\r\n\t.st67{clip-path:url(#SVGID_00000016051902643010770220000011168370297961809598_);}\r\n\t.st68{clip-path:url(#SVGID_00000020399407311396393510000017779496602270177936_);}\r\n\t.st69{clip-path:url(#SVGID_00000124861072480434113870000010441581614743132598_);}\r\n\t.st70{clip-path:url(#SVGID_00000049192521380886659580000009167130675831876005_);}\r\n\t.st71{clip-path:url(#SVGID_00000086669903137979348510000001764005112448855999_);}\r\n\t.st72{clip-path:url(#SVGID_00000125598536563204585190000000938000300417742488_);}\r\n\t.st73{clip-path:url(#SVGID_00000153662904534276123790000018384323826564160171_);}\r\n\t.st74{clip-path:url(#SVGID_00000124139164592515749290000006663694207046253996_);}\r\n\t.st75{clip-path:url(#SVGID_00000035497146637046176780000014523205772684417972_);}\r\n\t.st76{clip-path:url(#SVGID_00000137831013948601188970000007619333476628774025_);}\r\n\t.st77{clip-path:url(#SVGID_00000137824329518949667740000012609239210083979692_);}\r\n\t.st78{clip-path:url(#SVGID_00000158743220921731238690000010865511136443714220_);}\r\n\t.st79{clip-path:url(#SVGID_00000031205463937230429460000009932839070833213111_);}\r\n\t.st80{clip-path:url(#SVGID_00000029732733233308994920000010714339683325828024_);}\r\n\t.st81{clip-path:url(#SVGID_00000135662416005951572200000006896747346750795196_);}\r\n\t.st82{clip-path:url(#SVGID_00000056390212339746773220000009388729186605856688_);}\r\n\t.st83{clip-path:url(#SVGID_00000029754426714085299210000004765017473946458787_);}\r\n\t.st84{clip-path:url(#SVGID_00000111192494474412155440000001492299863850477991_);}\r\n\t.st85{clip-path:url(#SVGID_00000084514666443579162800000017483256485035454891_);}\r\n\t.st86{clip-path:url(#SVGID_00000140726139284781727450000004196278249254961327_);}\r\n\t.st87{clip-path:url(#SVGID_00000008848307288416351330000009797360297321188031_);}\r\n\t.st88{clip-path:url(#SVGID_00000023961416047075908480000004501407083659773336_);}\r\n\t.st89{clip-path:url(#SVGID_00000048469064581984170670000014517578199060736426_);}\r\n\t.st90{clip-path:url(#SVGID_00000091702202234242682110000005926641121238374816_);}\r\n\t\r\n\t\t.st91{clip-path:url(#SVGID_00000116195403084123069820000001588721571862291613_);fill:url(#SVGID_00000071546905521921845870000015503172312265273521_);}\r\n\t\r\n\t\t.st92{clip-path:url(#SVGID_00000000938420876952864410000016312580530605704076_);mask:url(#SVGID_00000011715747011461143480000018083028915282923952_);fill:url(#SVGID_00000045582579927469456740000017916517713760659346_);}\r\n\t.st93{fill:url(#SVGID_00000083779655640901183420000014498959247012539537_);}\r\n\t.st94{fill:url(#SVGID_00000106863019087333177430000009732002617079764352_);}\r\n\t.st95{fill:url(#SVGID_00000165227413296482942190000017424027076119195801_);}\r\n\t.st96{fill:url(#SVGID_00000161605875183146390180000000652576528947321729_);}\r\n\t.st97{clip-path:url(#SVGID_00000150094100980454750650000010874417365543356067_);}\r\n\t.st98{filter:url(#Adobe_OpacityMaskFilter_00000018942696999460147450000017242424828610074795_);}\r\n\t.st99{clip-path:url(#SVGID_00000056417169346930307780000012520470966096653977_);}\r\n\t.st100{clip-path:url(#SVGID_00000049943368040768888250000002022373878463121590_);}\r\n\t.st101{clip-path:url(#SVGID_00000174568525609963493440000004002918094856872332_);}\r\n\t.st102{clip-path:url(#SVGID_00000051373936917176658150000016623929512412127907_);}\r\n\t.st103{clip-path:url(#SVGID_00000040571570084758463100000004100671348187932821_);}\r\n\t.st104{clip-path:url(#SVGID_00000047767765162540662780000014740997618311156141_);}\r\n\t.st105{clip-path:url(#SVGID_00000093869053278724104760000009999128051521181851_);}\r\n\t.st106{clip-path:url(#SVGID_00000054256066463269657940000010150220211283055260_);}\r\n\t.st107{clip-path:url(#SVGID_00000144314991342558960630000007762983084124712097_);}\r\n\t.st108{clip-path:url(#SVGID_00000145058439374671227670000010403127315190800827_);}\r\n\t.st109{clip-path:url(#SVGID_00000088837789695068176670000000066669808786630798_);}\r\n\t.st110{clip-path:url(#SVGID_00000168090108291280130320000010354885811289279408_);}\r\n\t.st111{clip-path:url(#SVGID_00000176023658963753310390000008225633609045692831_);}\r\n\t.st112{clip-path:url(#SVGID_00000088842244065450760610000010088715881243917750_);}\r\n\t.st113{clip-path:url(#SVGID_00000055670687177041358840000010683616363267519112_);}\r\n\t.st114{clip-path:url(#SVGID_00000137124364585101246190000004262760409750125206_);}\r\n\t.st115{clip-path:url(#SVGID_00000104693212192823355470000015852633605024971438_);}\r\n\t.st116{clip-path:url(#SVGID_00000006666942500970689380000014546047520551856296_);}\r\n\t.st117{clip-path:url(#SVGID_00000031190041435607509480000000452900449707174549_);}\r\n\t.st118{clip-path:url(#SVGID_00000015314434837788312700000000228305379530568361_);}\r\n\t.st119{clip-path:url(#SVGID_00000015332851369933984460000002042275293581402803_);}\r\n\t.st120{clip-path:url(#SVGID_00000111902268615286572460000010740527745666185625_);}\r\n\t.st121{clip-path:url(#SVGID_00000037660443287261210880000013050619863853034640_);}\r\n\t.st122{clip-path:url(#SVGID_00000135688215997380802970000017471865090818351022_);}\r\n\t.st123{clip-path:url(#SVGID_00000134958262383405189550000001028716970654770310_);}\r\n\t\r\n\t\t.st124{clip-path:url(#SVGID_00000079461031785021425500000007985595453286929563_);fill:url(#SVGID_00000018924046630730497170000012688781651258724508_);}\r\n\t\r\n\t\t.st125{clip-path:url(#SVGID_00000056417169346930307780000012520470966096653977_);mask:url(#SVGID_00000104693901887507485390000004424371879515449267_);fill:url(#SVGID_00000157308565864961794030000009968476324317115303_);}\r\n\t.st126{clip-path:url(#SVGID_00000059297523517829735920000003971988367799406234_);}\r\n\t.st127{filter:url(#Adobe_OpacityMaskFilter_00000070803747281603576020000014066753495443081627_);}\r\n\t.st128{clip-path:url(#SVGID_00000040553376788003687460000015352563224696277120_);}\r\n\t.st129{clip-path:url(#SVGID_00000087378889192468319070000000776419917061702298_);}\r\n\t.st130{clip-path:url(#SVGID_00000096053130030437898270000005445536616639349170_);}\r\n\t.st131{clip-path:url(#SVGID_00000096742010162150460190000009146903622927199113_);}\r\n\t.st132{clip-path:url(#SVGID_00000000910683506717341440000008180060589170334610_);}\r\n\t.st133{clip-path:url(#SVGID_00000163771194003141533070000006969533549430418089_);}\r\n\t.st134{clip-path:url(#SVGID_00000077318404087644141330000010252415569379659944_);}\r\n\t.st135{clip-path:url(#SVGID_00000000940406039462214260000018162717773984051588_);}\r\n\t.st136{clip-path:url(#SVGID_00000026868772945528715230000016305380029869109949_);}\r\n\t.st137{clip-path:url(#SVGID_00000064356281590642424520000014881125843047255424_);}\r\n\t.st138{clip-path:url(#SVGID_00000077325027457730178360000008510550057461972123_);}\r\n\t.st139{clip-path:url(#SVGID_00000165192707090054552300000016959485060225121960_);}\r\n\t.st140{clip-path:url(#SVGID_00000148625263177619386310000017042533146876131223_);}\r\n\t.st141{clip-path:url(#SVGID_00000051381197178848422930000004044958048776263319_);}\r\n\t.st142{clip-path:url(#SVGID_00000143611819131901795730000009656838665434682782_);}\r\n\t.st143{clip-path:url(#SVGID_00000154423749046396440750000016252783805001556627_);}\r\n\t.st144{clip-path:url(#SVGID_00000092438324934393763620000003431745935623120825_);}\r\n\t.st145{clip-path:url(#SVGID_00000060726605595709874050000005146382524393473459_);}\r\n\t.st146{clip-path:url(#SVGID_00000001625631672990432390000000643459448330500778_);}\r\n\t.st147{clip-path:url(#SVGID_00000020395508143636108300000007082071339953163671_);}\r\n\t.st148{clip-path:url(#SVGID_00000031179058096282057150000014220750637115833278_);}\r\n\t.st149{clip-path:url(#SVGID_00000074432029053035164260000015060891752382329495_);}\r\n\t.st150{clip-path:url(#SVGID_00000024684529146634646020000013377765743825480846_);}\r\n\t.st151{clip-path:url(#SVGID_00000158005977290652105580000015459077682148553374_);}\r\n\t.st152{clip-path:url(#SVGID_00000141429188282531180220000001068609272177255071_);}\r\n\t\r\n\t\t.st153{clip-path:url(#SVGID_00000085964694262243672030000004356501502703203985_);fill:url(#SVGID_00000053525815627760540610000018223397673059802539_);}\r\n\t\r\n\t\t.st154{clip-path:url(#SVGID_00000040553376788003687460000015352563224696277120_);mask:url(#SVGID_00000156550305465845534640000001983637026585783710_);fill:url(#SVGID_00000159436024377173592510000005155366236401346193_);}\r\n\t.st155{opacity:0.48;fill:url(#SVGID_00000086669687797405215290000014663591342571483048_);enable-background:new    ;}\r\n\t.st156{fill:url(#SVGID_00000127765547562456982050000011709025499541173179_);}\r\n\t.st157{fill:url(#SVGID_00000038409336544620051140000008373294184968699531_);}\r\n\t.st158{clip-path:url(#SVGID_00000158000942499149048190000017049624826010313916_);}\r\n\t.st159{filter:url(#Adobe_OpacityMaskFilter_00000061460935595170185750000005130090490987826837_);}\r\n\t.st160{clip-path:url(#SVGID_00000027600043470673078310000008470628626966673303_);}\r\n\t.st161{clip-path:url(#SVGID_00000019639110062698019170000007304680210001784247_);}\r\n\t.st162{clip-path:url(#SVGID_00000124862314634272914350000011827412212011438765_);}\r\n\t.st163{clip-path:url(#SVGID_00000109746212048733838850000011599841685199265174_);}\r\n\t.st164{clip-path:url(#SVGID_00000008864836989522874070000011400030756313028260_);}\r\n\t.st165{clip-path:url(#SVGID_00000164512383718664407290000011081746696240534919_);}\r\n\t.st166{clip-path:url(#SVGID_00000019645227715412258600000004063761873247292838_);}\r\n\t.st167{clip-path:url(#SVGID_00000059293825585167564490000006388448510798518938_);}\r\n\t.st168{clip-path:url(#SVGID_00000035513819051325917610000011240406671766774175_);}\r\n\t.st169{clip-path:url(#SVGID_00000030448439013062578350000012038875177158559647_);}\r\n\t.st170{clip-path:url(#SVGID_00000145759455820470376890000010294289702288068008_);}\r\n\t.st171{clip-path:url(#SVGID_00000047055047110654862820000015166952941102168989_);}\r\n\t.st172{clip-path:url(#SVGID_00000131340151378178176710000001697225126120663998_);}\r\n\t.st173{clip-path:url(#SVGID_00000003789979565030402370000005206269737084763835_);}\r\n\t.st174{clip-path:url(#SVGID_00000082351653018110808220000014475817941610115775_);}\r\n\t.st175{clip-path:url(#SVGID_00000053544045946639739280000004484339898413784246_);}\r\n\t.st176{clip-path:url(#SVGID_00000043439156803033478990000016605987239180368260_);}\r\n\t.st177{clip-path:url(#SVGID_00000115474223604952144200000001453078954094342537_);}\r\n\t.st178{clip-path:url(#SVGID_00000015337904463325549840000006844585753428079503_);}\r\n\t.st179{clip-path:url(#SVGID_00000006700694695822273170000012729219275700647857_);}\r\n\t.st180{clip-path:url(#SVGID_00000081617369160469459720000002372153951795839874_);}\r\n\t.st181{clip-path:url(#SVGID_00000011003199203159854800000017195973375234989708_);}\r\n\t.st182{clip-path:url(#SVGID_00000138560576774500525190000009412763814901433217_);}\r\n\t.st183{clip-path:url(#SVGID_00000094614681320435635170000003781692397064072629_);}\r\n\t.st184{clip-path:url(#SVGID_00000137843400370530162210000001789783022727873968_);}\r\n\t\r\n\t\t.st185{clip-path:url(#SVGID_00000135661360731385235400000014553665607586506399_);fill:url(#SVGID_00000093886069152614482830000017448265802825479554_);}\r\n\t\r\n\t\t.st186{clip-path:url(#SVGID_00000027600043470673078310000008470628626966673303_);mask:url(#SVGID_00000153681912159676113710000007698021000927925658_);fill:url(#SVGID_00000149379845924446996060000013292294936277883046_);}\r\n\t.st187{fill:url(#SVGID_00000119081269100518466550000014365501875234868874_);}\r\n\t.st188{fill:url(#SVGID_00000124848539094420887620000018228928348286639784_);}\r\n\t.st189{fill:url(#SVGID_00000178911403443328523150000011941360188456344476_);}\r\n\t.st190{clip-path:url(#SVGID_00000170999761833093863060000016751526519887023497_);}\r\n\t.st191{filter:url(#Adobe_OpacityMaskFilter_00000091714135347625546100000005009418104328382102_);}\r\n\t.st192{clip-path:url(#SVGID_00000026123345600149915790000011879813471881008263_);}\r\n\t.st193{clip-path:url(#SVGID_00000144335633782765649440000011337220229318946462_);}\r\n\t.st194{clip-path:url(#SVGID_00000139990082429410478180000005609934736508417972_);}\r\n\t.st195{clip-path:url(#SVGID_00000013894781040738109620000009285212424129736104_);}\r\n\t.st196{clip-path:url(#SVGID_00000062149711184167454750000012362262468930677682_);}\r\n\t.st197{clip-path:url(#SVGID_00000154398012201380337900000010386679966358711482_);}\r\n\t.st198{clip-path:url(#SVGID_00000069372725683304696430000015404541611713255597_);}\r\n\t.st199{clip-path:url(#SVGID_00000004519785803268746500000001273496987571423152_);}\r\n\t.st200{clip-path:url(#SVGID_00000011745688718810327780000002892143159364581302_);}\r\n\t.st201{clip-path:url(#SVGID_00000141416388558098605460000006466346522895299463_);}\r\n\t.st202{clip-path:url(#SVGID_00000022555531723081529250000001290127928589849503_);}\r\n\t.st203{clip-path:url(#SVGID_00000177454787630304975520000000266012582868311180_);}\r\n\t.st204{clip-path:url(#SVGID_00000000913842268483463430000015812478070946200978_);}\r\n\t.st205{clip-path:url(#SVGID_00000037655918831742770480000005669016760952000393_);}\r\n\t.st206{clip-path:url(#SVGID_00000094596612408556938310000015858693730438548157_);}\r\n\t.st207{clip-path:url(#SVGID_00000086693434292983580990000005236583832024588432_);}\r\n\t.st208{clip-path:url(#SVGID_00000098209377501678243210000009264118931133085368_);}\r\n\t.st209{clip-path:url(#SVGID_00000183971382219044772030000004396052064892951464_);}\r\n\t.st210{clip-path:url(#SVGID_00000169554158977549097350000007414920351545585315_);}\r\n\t.st211{clip-path:url(#SVGID_00000051368983895770980110000000728756864747034557_);}\r\n\t.st212{clip-path:url(#SVGID_00000071518715026289756800000005075182512453832343_);}\r\n\t.st213{clip-path:url(#SVGID_00000083089644681815276610000011666633970814948761_);}\r\n\t.st214{clip-path:url(#SVGID_00000044150595953252324350000011806042610571241912_);}\r\n\t.st215{clip-path:url(#SVGID_00000111175127786063975500000008322172244176592058_);}\r\n\t.st216{clip-path:url(#SVGID_00000128476991902176307980000002067431365484885680_);}\r\n\t\r\n\t\t.st217{clip-path:url(#SVGID_00000042701014971843711020000000119432749611839166_);fill:url(#SVGID_00000147904415721699302100000004682742646022011574_);}\r\n\t\r\n\t\t.st218{clip-path:url(#SVGID_00000026123345600149915790000011879813471881008263_);mask:url(#SVGID_00000098199997547800096570000018231079392689272997_);fill:url(#SVGID_00000064350010868677774040000002048497499774304677_);}\r\n\t.st219{opacity:0.48;fill:url(#SVGID_00000114754057888777718190000000178293858678764717_);enable-background:new    ;}\r\n\t.st220{clip-path:url(#SVGID_00000118385762387026492830000004230426014958931083_);}\r\n\t.st221{filter:url(#Adobe_OpacityMaskFilter_00000028325406767918350890000018208784301535010732_);}\r\n\t.st222{clip-path:url(#SVGID_00000016783495146177348030000014112697132857521071_);}\r\n\t.st223{clip-path:url(#SVGID_00000056407423851414046490000017713935661071265675_);}\r\n\t.st224{clip-path:url(#SVGID_00000021117785904820308530000002944027019452555664_);}\r\n\t.st225{clip-path:url(#SVGID_00000145036337647980558110000010742836348958432397_);}\r\n\t.st226{clip-path:url(#SVGID_00000144307761706809907770000007264275382135419834_);}\r\n\t.st227{clip-path:url(#SVGID_00000159444526196222980300000012963836702595512451_);}\r\n\t.st228{clip-path:url(#SVGID_00000131343449251052348270000004350632471839612590_);}\r\n\t.st229{clip-path:url(#SVGID_00000072997806362795191720000010615480114358615464_);}\r\n\t.st230{clip-path:url(#SVGID_00000036245096615806276890000010375387928153395377_);}\r\n\t.st231{clip-path:url(#SVGID_00000172410397748525014290000008576891581617740472_);}\r\n\t.st232{clip-path:url(#SVGID_00000066479502588116129220000000349482903265112199_);}\r\n\t.st233{clip-path:url(#SVGID_00000147218330904215160920000013780309623995472024_);}\r\n\t.st234{clip-path:url(#SVGID_00000182520939422529151660000004016474206731422627_);}\r\n\t.st235{clip-path:url(#SVGID_00000085960416288156270420000006333831706077584062_);}\r\n\t.st236{clip-path:url(#SVGID_00000064334386493040820020000004198508988140161438_);}\r\n\t.st237{clip-path:url(#SVGID_00000035501531202525559720000000703484340618594176_);}\r\n\t.st238{clip-path:url(#SVGID_00000011717224670010978510000003881095122713888664_);}\r\n\t.st239{clip-path:url(#SVGID_00000179645337729715477470000011257496251323779983_);}\r\n\t.st240{clip-path:url(#SVGID_00000036956956048962631040000009647137395395983508_);}\r\n\t.st241{clip-path:url(#SVGID_00000018947008576244001940000009489531693802069384_);}\r\n\t.st242{clip-path:url(#SVGID_00000072976988160336714770000002511989392550071176_);}\r\n\t.st243{clip-path:url(#SVGID_00000160151649072374572320000017224685205702479260_);}\r\n\t.st244{clip-path:url(#SVGID_00000145767605393824235720000000438810481616938663_);}\r\n\t.st245{clip-path:url(#SVGID_00000089537974435760143160000016726501120391647872_);}\r\n\t.st246{clip-path:url(#SVGID_00000003791288218614243050000003168719722460966796_);}\r\n\t\r\n\t\t.st247{clip-path:url(#SVGID_00000070096672983740494390000001761771577705028020_);fill:url(#SVGID_00000003095519741145111530000000047597623249483904_);}\r\n\t\r\n\t\t.st248{clip-path:url(#SVGID_00000016783495146177348030000014112697132857521071_);mask:url(#SVGID_00000130613883181478670430000004946521245461151376_);fill:url(#SVGID_00000060003712136950962790000010018582026569631366_);}\r\n\t.st249{opacity:0.48;fill:url(#SVGID_00000150807714863569012290000005849529754524568463_);enable-background:new    ;}\r\n\t.st250{fill:url(#SVGID_00000016778897817246980070000013955756707849393075_);}\r\n\t.st251{fill:url(#SVGID_00000138532642372485749420000006049294674733782685_);}\r\n\t.st252{fill:url(#SVGID_00000042738260474409077100000009101147447126581425_);}\r\n\t.st253{fill:url(#SVGID_00000026870864413126158750000001638303151319521201_);}\r\n\t.st254{clip-path:url(#SVGID_00000165952794775072501500000014736385207724251325_);}\r\n\t.st255{filter:url(#Adobe_OpacityMaskFilter_00000012434615380803706560000004294453687013021070_);}\r\n\t.st256{clip-path:url(#SVGID_00000090986520332038330470000002693327240220239746_);}\r\n\t.st257{clip-path:url(#SVGID_00000030465336802200960370000005422872588857549225_);}\r\n\t.st258{clip-path:url(#SVGID_00000100366918602782665390000015484339655700073861_);}\r\n\t.st259{clip-path:url(#SVGID_00000062897941568833872610000017454510645423392950_);}\r\n\t.st260{clip-path:url(#SVGID_00000097474812175912212400000007464343726379220401_);}\r\n\t.st261{clip-path:url(#SVGID_00000096030148447399847300000008601270557788246443_);}\r\n\t.st262{clip-path:url(#SVGID_00000017477919250297392360000000605156282416753849_);}\r\n\t.st263{clip-path:url(#SVGID_00000158745755020942686590000008202950293569473455_);}\r\n\t.st264{clip-path:url(#SVGID_00000155105103578311174680000006614888317099193231_);}\r\n\t.st265{clip-path:url(#SVGID_00000106839677013086089140000006707974243581236892_);}\r\n\t.st266{clip-path:url(#SVGID_00000174570284153277834000000002609457567511922825_);}\r\n\t.st267{clip-path:url(#SVGID_00000067214061191220977390000009369949860126902455_);}\r\n\t.st268{clip-path:url(#SVGID_00000145042231494413846900000003956916857701679243_);}\r\n\t.st269{clip-path:url(#SVGID_00000104699669412386026870000003671916173275526542_);}\r\n\t.st270{clip-path:url(#SVGID_00000124869927672485395890000003105817831363200426_);}\r\n\t.st271{clip-path:url(#SVGID_00000081623803643307606900000018246966108042862521_);}\r\n\t.st272{clip-path:url(#SVGID_00000066499266915028329290000008521187381367809444_);}\r\n\t.st273{clip-path:url(#SVGID_00000031188764788815490060000013884118060332831655_);}\r\n\t.st274{clip-path:url(#SVGID_00000163065193345208611780000012460908103085757332_);}\r\n\t.st275{clip-path:url(#SVGID_00000018924334524562824320000009197432237945465755_);}\r\n\t.st276{clip-path:url(#SVGID_00000017515570903335782550000010264801654473528978_);}\r\n\t.st277{clip-path:url(#SVGID_00000004540794043011159970000017914983526214323842_);}\r\n\t.st278{clip-path:url(#SVGID_00000172413897815046656020000013061644711529365662_);}\r\n\t.st279{clip-path:url(#SVGID_00000082335987878653491230000007930146686199199916_);}\r\n\t.st280{clip-path:url(#SVGID_00000118386475513456807080000007435807959491645568_);}\r\n\t\r\n\t\t.st281{clip-path:url(#SVGID_00000009560922409735381430000006256539649657029566_);fill:url(#SVGID_00000016789904537814399070000016685858042525568922_);}\r\n\t\r\n\t\t.st282{clip-path:url(#SVGID_00000090986520332038330470000002693327240220239746_);mask:url(#SVGID_00000002369941424631335940000013350243553805384086_);fill:url(#SVGID_00000041280643507088523610000017092211825798131075_);}\r\n\t.st283{clip-path:url(#SVGID_00000163784106750462938440000017762527277396829613_);}\r\n\t.st284{filter:url(#Adobe_OpacityMaskFilter_00000119084669062257426160000002763620951275734405_);}\r\n\t.st285{clip-path:url(#SVGID_00000092448295371546807400000009943828314614080161_);}\r\n\t.st286{clip-path:url(#SVGID_00000089539297172948466410000015535572026639459222_);}\r\n\t.st287{clip-path:url(#SVGID_00000163057797676062806350000004631265908587390096_);}\r\n\t.st288{clip-path:url(#SVGID_00000016045455514090817810000002160895142750990727_);}\r\n\t.st289{clip-path:url(#SVGID_00000042708565822668299290000004042502217047667902_);}\r\n\t.st290{clip-path:url(#SVGID_00000065048104619997899010000012988461343213374121_);}\r\n\t.st291{clip-path:url(#SVGID_00000059268381281929825360000006242406340551246751_);}\r\n\t.st292{clip-path:url(#SVGID_00000082368726146161942500000004258100731782216369_);}\r\n\t.st293{clip-path:url(#SVGID_00000052085646213602389890000006905937881685756063_);}\r\n\t.st294{clip-path:url(#SVGID_00000005951105515107180660000013010880119575028392_);}\r\n\t.st295{clip-path:url(#SVGID_00000124129147849653040430000004793353164585666205_);}\r\n\t.st296{clip-path:url(#SVGID_00000136394751700468210230000007656374913595075972_);}\r\n\t.st297{clip-path:url(#SVGID_00000109733538781032304340000014607052098734637483_);}\r\n\t.st298{clip-path:url(#SVGID_00000081616449919659746230000014335687344882948267_);}\r\n\t.st299{clip-path:url(#SVGID_00000138531993530154579290000007598605074835086516_);}\r\n\t.st300{clip-path:url(#SVGID_00000123411201810853857560000002943096058654249856_);}\r\n\t.st301{clip-path:url(#SVGID_00000013888253607357787920000017429602977444561337_);}\r\n\t.st302{clip-path:url(#SVGID_00000172423656843205951470000009917006862892299164_);}\r\n\t.st303{clip-path:url(#SVGID_00000159441362315161513360000001844686018674860444_);}\r\n\t.st304{clip-path:url(#SVGID_00000011017598587262401490000002948484152973791147_);}\r\n\t.st305{clip-path:url(#SVGID_00000025428842912118912710000003401665465700468868_);}\r\n\t.st306{clip-path:url(#SVGID_00000175323600995651221800000005090398114752347804_);}\r\n\t.st307{clip-path:url(#SVGID_00000080202067872684262260000005611341153812038819_);}\r\n\t.st308{clip-path:url(#SVGID_00000083065085400838457950000007788701916273034881_);}\r\n\t.st309{clip-path:url(#SVGID_00000008115957032513121260000008579897209248501134_);}\r\n\t\r\n\t\t.st310{clip-path:url(#SVGID_00000073706167447404451280000017201017266780288415_);fill:url(#SVGID_00000044857850018621541020000009632045963655994302_);}\r\n\t\r\n\t\t.st311{clip-path:url(#SVGID_00000092448295371546807400000009943828314614080161_);mask:url(#SVGID_00000048481163058850548400000004791441506120399253_);fill:url(#SVGID_00000072984777746528979070000000407738995837167543_);}\r\n\t.st312{fill:url(#SVGID_00000095323215449357435360000013123498060258324382_);}\r\n\t.st313{clip-path:url(#SVGID_00000059307157718316135200000014262655435304898978_);}\r\n\t.st314{filter:url(#Adobe_OpacityMaskFilter_00000095315106637075751640000015343871969507146419_);}\r\n\t.st315{clip-path:url(#SVGID_00000036956172063783934030000000645126012755672255_);}\r\n\t.st316{clip-path:url(#SVGID_00000044177734054076985660000000115432317233184156_);}\r\n\t.st317{clip-path:url(#SVGID_00000055675488444156354470000016762392312358412722_);}\r\n\t.st318{clip-path:url(#SVGID_00000167359368812938415160000005460450143797904276_);}\r\n\t.st319{clip-path:url(#SVGID_00000137093543082803067460000010013947159762271371_);}\r\n\t.st320{clip-path:url(#SVGID_00000067957497827128978980000010342012418023727246_);}\r\n\t.st321{clip-path:url(#SVGID_00000116197959046196482070000007426606796108534165_);}\r\n\t.st322{clip-path:url(#SVGID_00000024705285202708525070000014335818057234120071_);}\r\n\t.st323{clip-path:url(#SVGID_00000131354725720636790150000012262490610495081919_);}\r\n\t.st324{clip-path:url(#SVGID_00000025432954458969455000000014053198783260494230_);}\r\n\t.st325{clip-path:url(#SVGID_00000178903340380505359600000013492337659884817078_);}\r\n\t.st326{clip-path:url(#SVGID_00000035505845456654023290000012482020710993505451_);}\r\n\t.st327{clip-path:url(#SVGID_00000121982126490674634740000006289742671544124094_);}\r\n\t.st328{clip-path:url(#SVGID_00000172404001723421581630000013884169449179715466_);}\r\n\t.st329{clip-path:url(#SVGID_00000059298300579695263040000004598992310490920108_);}\r\n\t.st330{clip-path:url(#SVGID_00000033347881173137370850000017981043088498607003_);}\r\n\t.st331{clip-path:url(#SVGID_00000014608129856986041980000003787361746868872343_);}\r\n\t.st332{clip-path:url(#SVGID_00000000909696755971267980000004163212534158169219_);}\r\n\t.st333{clip-path:url(#SVGID_00000062161377370344059230000003811692785112338092_);}\r\n\t.st334{clip-path:url(#SVGID_00000164486528004057422430000015471608697169485442_);}\r\n\t.st335{clip-path:url(#SVGID_00000106138059647735057500000004616283860834608311_);}\r\n\t.st336{clip-path:url(#SVGID_00000139998067204824873070000007231219574800936597_);}\r\n\t.st337{clip-path:url(#SVGID_00000111871262679066523900000000596089110573901704_);}\r\n\t.st338{clip-path:url(#SVGID_00000004508438950509710440000002391656301517718916_);}\r\n\t.st339{clip-path:url(#SVGID_00000122693961466159613040000004559364147295038597_);}\r\n\t\r\n\t\t.st340{clip-path:url(#SVGID_00000165956739717863836170000003820431828086344581_);fill:url(#SVGID_00000177475587275516396190000006796678446548186557_);}\r\n\t\r\n\t\t.st341{clip-path:url(#SVGID_00000036956172063783934030000000645126012755672255_);mask:url(#SVGID_00000128472331744325682430000005425003044528915878_);fill:url(#SVGID_00000176759756631615969630000012180034166680701570_);}\r\n\t.st342{fill:url(#SVGID_00000038406704404006929670000012968394912238818718_);}\r\n\t.st343{fill:url(#SVGID_00000111901485227114924080000001630195330853731233_);}\r\n\t.st344{fill:url(#SVGID_00000145748676077655604670000007714557351535461250_);}\r\n\t.st345{fill:url(#SVGID_00000096060108255084891170000005232851550552747904_);}\r\n\t.st346{clip-path:url(#SVGID_00000174566071153580312630000012592337834372239012_);}\r\n\t.st347{filter:url(#Adobe_OpacityMaskFilter_00000091705872939390872370000014855162031393308560_);}\r\n\t.st348{clip-path:url(#SVGID_00000095334338379374993030000017067861880616093859_);}\r\n\t.st349{clip-path:url(#SVGID_00000168832511328675852320000004206806126505522088_);}\r\n\t.st350{clip-path:url(#SVGID_00000097473668511272327730000003055690446514401200_);}\r\n\t.st351{clip-path:url(#SVGID_00000163065259360069502420000008793508023279182977_);}\r\n\t.st352{clip-path:url(#SVGID_00000001635721635684148040000001915478186094189221_);}\r\n\t.st353{clip-path:url(#SVGID_00000078038083813543491500000000233781021592520109_);}\r\n\t.st354{clip-path:url(#SVGID_00000020400922733952370740000012798951719957126281_);}\r\n\t.st355{clip-path:url(#SVGID_00000043445978436443093600000003989795441309289636_);}\r\n\t.st356{clip-path:url(#SVGID_00000072267585819455542700000011418132239056874898_);}\r\n\t.st357{clip-path:url(#SVGID_00000085208461832981622970000009412951591636932279_);}\r\n\t.st358{clip-path:url(#SVGID_00000111896655075461674190000001597702001300069802_);}\r\n\t.st359{clip-path:url(#SVGID_00000072964887523542694440000007386829743510527373_);}\r\n\t.st360{clip-path:url(#SVGID_00000065035513328592285090000006909030397232363931_);}\r\n\t.st361{clip-path:url(#SVGID_00000077289262383264524580000017065863511758303910_);}\r\n\t.st362{clip-path:url(#SVGID_00000046308278109861188280000010736781655705181825_);}\r\n\t.st363{clip-path:url(#SVGID_00000138540530774952044930000006948591333262923187_);}\r\n\t.st364{clip-path:url(#SVGID_00000142134396189455200020000014832548317214060958_);}\r\n\t.st365{clip-path:url(#SVGID_00000081616345166430338740000008188999882050163099_);}\r\n\t.st366{clip-path:url(#SVGID_00000016777220590111094220000014455584055736650644_);}\r\n\t.st367{clip-path:url(#SVGID_00000141425811375192684200000016265369654059602833_);}\r\n\t.st368{clip-path:url(#SVGID_00000003100693496815733910000007926739712466572735_);}\r\n\t.st369{clip-path:url(#SVGID_00000005256700057265445280000006803628043743685020_);}\r\n\t.st370{clip-path:url(#SVGID_00000049929832717693062760000004709937172711158916_);}\r\n\t.st371{clip-path:url(#SVGID_00000062884950424735348060000012216090917733370766_);}\r\n\t.st372{clip-path:url(#SVGID_00000122716520073467494610000003397955689352922503_);}\r\n\t\r\n\t\t.st373{clip-path:url(#SVGID_00000044868631360503694060000016737040547759051414_);fill:url(#SVGID_00000027562414535799038330000014051366280090935690_);}\r\n\t\r\n\t\t.st374{clip-path:url(#SVGID_00000095334338379374993030000017067861880616093859_);mask:url(#SVGID_00000021104860421671030910000015996740854946434979_);fill:url(#SVGID_00000016780929174495661250000005507054484531558543_);}\r\n\t.st375{clip-path:url(#SVGID_00000137852994579090988420000003550661104293585808_);}\r\n\t.st376{filter:url(#Adobe_OpacityMaskFilter_00000126289935610031488290000012130788656762781370_);}\r\n\t.st377{clip-path:url(#SVGID_00000068667648801468236810000000697953353474570401_);}\r\n\t.st378{clip-path:url(#SVGID_00000083780065643289591750000014405537206385994399_);}\r\n\t.st379{clip-path:url(#SVGID_00000158728866908126842720000010996758942947861636_);}\r\n\t.st380{clip-path:url(#SVGID_00000057108478171794141430000009661696842800205213_);}\r\n\t.st381{clip-path:url(#SVGID_00000160167832361934242570000016443000138233102762_);}\r\n\t.st382{clip-path:url(#SVGID_00000132065221959171177200000016532922964510911369_);}\r\n\t.st383{clip-path:url(#SVGID_00000109026672323415591150000002452717163609016723_);}\r\n\t.st384{clip-path:url(#SVGID_00000088846415387159208900000007467644529886064813_);}\r\n\t.st385{clip-path:url(#SVGID_00000147211230154710383580000010417437518556626336_);}\r\n\t.st386{clip-path:url(#SVGID_00000024713351486882889640000015075998720936771256_);}\r\n\t.st387{clip-path:url(#SVGID_00000078726717991340287370000006169158944346325917_);}\r\n\t.st388{clip-path:url(#SVGID_00000102544336463771057040000009276866999540712110_);}\r\n\t.st389{clip-path:url(#SVGID_00000016797759416437808960000000493720368754855866_);}\r\n\t.st390{clip-path:url(#SVGID_00000090997483829599791490000007849322568159034039_);}\r\n\t.st391{clip-path:url(#SVGID_00000168835005877401100530000004407012496000077237_);}\r\n\t.st392{clip-path:url(#SVGID_00000062889719998650130520000011346731626967128996_);}\r\n\t.st393{clip-path:url(#SVGID_00000083062723417448354250000007341343600978637453_);}\r\n\t.st394{clip-path:url(#SVGID_00000109724277033714108700000016952452857841009320_);}\r\n\t.st395{clip-path:url(#SVGID_00000052825249902455674910000002984987732714996888_);}\r\n\t.st396{clip-path:url(#SVGID_00000092441118416741461720000012561425847542663565_);}\r\n\t.st397{clip-path:url(#SVGID_00000077312639607088524230000010215993175663143603_);}\r\n\t.st398{clip-path:url(#SVGID_00000013179014780680172160000006721523724644710060_);}\r\n\t.st399{clip-path:url(#SVGID_00000148655375501322381060000001466059894416263603_);}\r\n\t.st400{clip-path:url(#SVGID_00000014618227436420356880000010048635753392513184_);}\r\n\t.st401{clip-path:url(#SVGID_00000181075171446050291540000006229975667745660312_);}\r\n\t\r\n\t\t.st402{clip-path:url(#SVGID_00000155841059238474797090000011318990765892970886_);fill:url(#SVGID_00000139277275391613060520000015893961600360172434_);}\r\n\t\r\n\t\t.st403{clip-path:url(#SVGID_00000068667648801468236810000000697953353474570401_);mask:url(#SVGID_00000150786087879712872890000004512831242216644746_);fill:url(#SVGID_00000109012327400636366530000018190853537948816549_);}\r\n\t.st404{opacity:0.48;fill:url(#SVGID_00000068662044097436858100000008096171959782703761_);enable-background:new    ;}\r\n\t.st405{fill:url(#SVGID_00000063604163277042395200000004039850169119078575_);}\r\n\t.st406{fill:url(#SVGID_00000136373844292604124240000002361650896177618312_);}\r\n\t.st407{clip-path:url(#SVGID_00000031887458197472057740000005026921355378021293_);}\r\n\t.st408{filter:url(#Adobe_OpacityMaskFilter_00000032634829692707292510000002251055657455204494_);}\r\n\t.st409{clip-path:url(#SVGID_00000072998755562794144590000017411067194840048825_);}\r\n\t.st410{clip-path:url(#SVGID_00000060752044540935113390000002423853363769028281_);}\r\n\t.st411{clip-path:url(#SVGID_00000079461959085654893570000015036865702317942446_);}\r\n\t.st412{clip-path:url(#SVGID_00000121277026615230592880000007812487103214719638_);}\r\n\t.st413{clip-path:url(#SVGID_00000060748650646080519200000016694218271226900117_);}\r\n\t.st414{clip-path:url(#SVGID_00000069374439519366072040000017130309000506860735_);}\r\n\t.st415{clip-path:url(#SVGID_00000168826767753349266460000003739681972830098575_);}\r\n\t.st416{clip-path:url(#SVGID_00000080207349772260667180000002871113676956711086_);}\r\n\t.st417{clip-path:url(#SVGID_00000156545482769692914270000009154166599264016807_);}\r\n\t.st418{clip-path:url(#SVGID_00000025432238542156565070000011192569820033763752_);}\r\n\t.st419{clip-path:url(#SVGID_00000122002498047669702940000017269558338287780026_);}\r\n\t.st420{clip-path:url(#SVGID_00000079473531227279866950000003057044884056072584_);}\r\n\t.st421{clip-path:url(#SVGID_00000085942805645213161600000007849517630325492615_);}\r\n\t.st422{clip-path:url(#SVGID_00000103246702130501641100000009414087495638642866_);}\r\n\t.st423{clip-path:url(#SVGID_00000083075546702369886390000013059114383183174591_);}\r\n\t.st424{clip-path:url(#SVGID_00000145776603612201524070000012609899198018100909_);}\r\n\t.st425{clip-path:url(#SVGID_00000152232177988381854840000015916017229684137639_);}\r\n\t.st426{clip-path:url(#SVGID_00000145018092988600015790000009210978357716113541_);}\r\n\t.st427{clip-path:url(#SVGID_00000036242928082027934660000008143946869925855406_);}\r\n\t.st428{clip-path:url(#SVGID_00000098917436026729794190000011445720909119882902_);}\r\n\t.st429{clip-path:url(#SVGID_00000096741977003819602110000012899339750056002706_);}\r\n\t.st430{clip-path:url(#SVGID_00000060722457935844275930000010613391889013759634_);}\r\n\t.st431{clip-path:url(#SVGID_00000072278157625685200070000009252111053628645018_);}\r\n\t.st432{clip-path:url(#SVGID_00000021824174771830119810000016577784114918629764_);}\r\n\t.st433{clip-path:url(#SVGID_00000037691227268312490770000002034314994775468213_);}\r\n\t\r\n\t\t.st434{clip-path:url(#SVGID_00000072258000964165807220000002402511290856397447_);fill:url(#SVGID_00000033336279478771190710000007245520941110942351_);}\r\n\t\r\n\t\t.st435{clip-path:url(#SVGID_00000072998755562794144590000017411067194840048825_);mask:url(#SVGID_00000078015630252786408590000006899207005368762791_);fill:url(#SVGID_00000091001415372745427450000006298626685455746947_);}\r\n\t.st436{fill:url(#SVGID_00000151537966608574598020000013155511629901359795_);}\r\n\t.st437{fill:url(#SVGID_00000063623400909011530950000008401176612296285843_);}\r\n\t.st438{fill:url(#SVGID_00000135689256457389289770000018151275580610636965_);}\r\n\t.st439{clip-path:url(#SVGID_00000151509502938834491760000005249286287523815348_);}\r\n\t.st440{filter:url(#Adobe_OpacityMaskFilter_00000124120923419196549840000009095771910105227172_);}\r\n\t.st441{clip-path:url(#SVGID_00000000914524143288224950000013118254051293543340_);}\r\n\t.st442{clip-path:url(#SVGID_00000121265801102120582030000004047422458508863385_);}\r\n\t.st443{clip-path:url(#SVGID_00000078022820880056238820000011954699200248704419_);}\r\n\t.st444{clip-path:url(#SVGID_00000071544715272074337370000017069371888892005815_);}\r\n\t.st445{clip-path:url(#SVGID_00000130641070363220481420000011397467376647804091_);}\r\n\t.st446{clip-path:url(#SVGID_00000104667442259174561840000002164525997884800425_);}\r\n\t.st447{clip-path:url(#SVGID_00000051352816910245673210000015576185651127320979_);}\r\n\t.st448{clip-path:url(#SVGID_00000169524302725468016290000017212515558801532550_);}\r\n\t.st449{clip-path:url(#SVGID_00000098202419383618440760000003115806615379884961_);}\r\n\t.st450{clip-path:url(#SVGID_00000034788585160717555000000017149936900031629721_);}\r\n\t.st451{clip-path:url(#SVGID_00000127726619302117790790000002849275095185353621_);}\r\n\t.st452{clip-path:url(#SVGID_00000114035610553609009980000006400533678150712964_);}\r\n\t.st453{clip-path:url(#SVGID_00000013882823515376449760000018400143678117712533_);}\r\n\t.st454{clip-path:url(#SVGID_00000023256561472042079010000003064854903169786269_);}\r\n\t.st455{clip-path:url(#SVGID_00000115493577428149058790000001615752780636399525_);}\r\n\t.st456{clip-path:url(#SVGID_00000160183663763322599820000003709218216435594418_);}\r\n\t.st457{clip-path:url(#SVGID_00000102508542344591606620000003759906075900824752_);}\r\n\t.st458{clip-path:url(#SVGID_00000124874257904881550720000010866656434657826223_);}\r\n\t.st459{clip-path:url(#SVGID_00000174596175781242424120000010459834783499724430_);}\r\n\t.st460{clip-path:url(#SVGID_00000129187991448691752950000007067761871545375159_);}\r\n\t.st461{clip-path:url(#SVGID_00000049923499753652503160000016093303664025043383_);}\r\n\t.st462{clip-path:url(#SVGID_00000152251859837855016420000013771564768468780462_);}\r\n\t.st463{clip-path:url(#SVGID_00000134242817004102390690000004446700563787423638_);}\r\n\t.st464{clip-path:url(#SVGID_00000065066139842183727390000009104477184903771828_);}\r\n\t.st465{clip-path:url(#SVGID_00000049208499386144135940000004080332773737478827_);}\r\n\t\r\n\t\t.st466{clip-path:url(#SVGID_00000090277766826176569220000003731290517923514004_);fill:url(#SVGID_00000148647891973222840640000002991508494270242478_);}\r\n\t\r\n\t\t.st467{clip-path:url(#SVGID_00000000914524143288224950000013118254051293543340_);mask:url(#SVGID_00000036942736869524975570000015055153701206070972_);fill:url(#SVGID_00000054978002698518063610000005820666422304404371_);}\r\n\t.st468{opacity:0.48;fill:url(#SVGID_00000009591852837711378340000012201750069386664377_);enable-background:new    ;}\r\n\t.st469{clip-path:url(#SVGID_00000170999711345603799610000002551201363779900059_);}\r\n\t.st470{filter:url(#Adobe_OpacityMaskFilter_00000080906552008464722390000013578738768289025708_);}\r\n\t.st471{clip-path:url(#SVGID_00000094601657649161464690000005610901090207935910_);}\r\n\t.st472{clip-path:url(#SVGID_00000083057511218690410200000005898511897254480266_);}\r\n\t.st473{clip-path:url(#SVGID_00000134221770212794783220000006511291374317443001_);}\r\n\t.st474{clip-path:url(#SVGID_00000011734950114740299040000005304688845068449978_);}\r\n\t.st475{clip-path:url(#SVGID_00000133516692841086868180000009105430790532812950_);}\r\n\t.st476{clip-path:url(#SVGID_00000033356664575990282510000017734586352879031449_);}\r\n\t.st477{clip-path:url(#SVGID_00000107584154669610250140000017134437748307675287_);}\r\n\t.st478{clip-path:url(#SVGID_00000103954179859416904780000010400107977227722144_);}\r\n\t.st479{clip-path:url(#SVGID_00000159428924599277891840000016818239781707407256_);}\r\n\t.st480{clip-path:url(#SVGID_00000179638154606100166940000005079578221839311794_);}\r\n\t.st481{clip-path:url(#SVGID_00000060009746760695347980000016507931612924624792_);}\r\n\t.st482{clip-path:url(#SVGID_00000016760286440774621070000015209622777613073590_);}\r\n\t.st483{clip-path:url(#SVGID_00000051376008314274002280000002049044955974009517_);}\r\n\t.st484{clip-path:url(#SVGID_00000131362065032977278320000013058236979392847288_);}\r\n\t.st485{clip-path:url(#SVGID_00000001626646174151791730000001726812405483687591_);}\r\n\t.st486{clip-path:url(#SVGID_00000178912891083969718810000006985127883107972003_);}\r\n\t.st487{clip-path:url(#SVGID_00000177453671463115254190000004626025376810831775_);}\r\n\t.st488{clip-path:url(#SVGID_00000147923122647762714420000016636277545604397208_);}\r\n\t.st489{clip-path:url(#SVGID_00000012441785538912691280000008037228907340138129_);}\r\n\t.st490{clip-path:url(#SVGID_00000142176841171652403480000012499530659009760164_);}\r\n\t.st491{clip-path:url(#SVGID_00000162353350689835741690000002097813885539672975_);}\r\n\t.st492{clip-path:url(#SVGID_00000004538615509611925500000006256036953972225467_);}\r\n\t.st493{clip-path:url(#SVGID_00000036944094609304800700000017839104539348148655_);}\r\n\t.st494{clip-path:url(#SVGID_00000166672196894681954740000013431032827660125077_);}\r\n\t.st495{clip-path:url(#SVGID_00000025412622743614046260000007122849783681968792_);}\r\n\t\r\n\t\t.st496{clip-path:url(#SVGID_00000165915140587876240250000001649415168822654342_);fill:url(#SVGID_00000114784297257438914940000010836292566434216109_);}\r\n\t\r\n\t\t.st497{clip-path:url(#SVGID_00000094601657649161464690000005610901090207935910_);mask:url(#SVGID_00000083804382630307500360000015418305472531482532_);fill:url(#SVGID_00000174571800098351627260000014077484808769012158_);}\r\n\t.st498{opacity:0.48;fill:url(#SVGID_00000118374277519393226160000016053661448013339818_);enable-background:new    ;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -559.8526,
    y1: -842.786,
    x2: -559.8526,
    y2: -810.1401,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00193075,
    style: {
      stopColor: "#F9EF8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5A017"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.2,100.4c0,0,2.4,13.2-6.2,33.1c0,0-7.6-12.6-6-33.1H93.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000170986890687869353390000000615974006996389807_",
    cx: -275.8561,
    cy: 193.6703,
    r: 0,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    style: {
      stopColor: "#FE7316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14161C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170986890687869353390000000615974006996389807_)"
    },
    d: "M78.2,27.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015348007782076373590000010327100289899134093_",
    gradientUnits: "userSpaceOnUse",
    x1: -577.4593,
    y1: -781.8186,
    x2: -577.4593,
    y2: -811.9578,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000015348007782076373590000010327100289899134093_)"
    },
    points: "97.7,92.2 111.8,104.4  106.2,74.2 101.3,71.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092452777799813462450000009366923180663393939_",
    gradientUnits: "userSpaceOnUse",
    x1: -542.0593,
    y1: -781.8186,
    x2: -542.0593,
    y2: -811.9578,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000092452777799813462450000009366923180663393939_)"
    },
    points: "76.3,92.2 62.2,104.4  67.8,74.2 72.8,71.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000170978681326642245690000005947611057953209530_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000164482518192679630190000018059224638145242269_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170978681326642245690000005947611057953209530_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127004687772816283910000009827556048635270529_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000129921213482845333140000009148580362147437718_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178199194163890967890000017593941574441126039_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127004687772816283910000009827556048635270529_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161590434992332123810000000335790872300992912_",
    style: {
      clipPath: "url(#SVGID_00000178199194163890967890000017593941574441126039_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129921213482845333140000009148580362147437718_",
    style: {
      overflow: "visible"
    }
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 67.2,
    y: 72.7,
    width: 7.8,
    height: 27.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 67.2,
    y: 72.7,
    width: 7.8,
    height: 27.4,
    id: "SVGID_00000155864389099146695010000010258589812684560829_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000077308660093322661740000011397564515795943071_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000132090243107915315600000001815059171797163682_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023240863746461368820000012756550523254267042_",
    style: {
      clipPath: "url(#SVGID_00000161590434992332123810000000335790872300992912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077308660093322661740000011397564515795943071_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054245168407447923970000015756856576780251286_",
    style: {
      clipPath: "url(#SVGID_00000023240863746461368820000012756550523254267042_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132090243107915315600000001815059171797163682_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000049902018245542667810000007989150573509457842_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000160177057631604807910000001664458553082739896_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000008837462680612341250000011644217036081928383_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034768842920119838850000014295841090074789303_",
    style: {
      clipPath: "url(#SVGID_00000161590434992332123810000000335790872300992912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049902018245542667810000007989150573509457842_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000191321365687054320000006462073859637031589_",
    style: {
      clipPath: "url(#SVGID_00000034768842920119838850000014295841090074789303_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160177057631604807910000001664458553082739896_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071522578571668004410000017755293681603914934_",
    style: {
      clipPath: "url(#SVGID_00000000191321365687054320000006462073859637031589_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008837462680612341250000011644217036081928383_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000054263220848111073460000013179086941867174058_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000080187820830375225650000000307506973798225548_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100348729306831652200000010883258225268183204_",
    style: {
      clipPath: "url(#SVGID_00000161590434992332123810000000335790872300992912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054263220848111073460000013179086941867174058_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180327687643870878480000012565479814755374504_",
    style: {
      clipPath: "url(#SVGID_00000100348729306831652200000010883258225268183204_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080187820830375225650000000307506973798225548_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000083771912260538297760000012674654345110390407_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000091006159557475083240000013128979453454017456_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000011019225833612185550000009028353373248612001_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147937932765463331410000016651143986270988953_",
    style: {
      clipPath: "url(#SVGID_00000161590434992332123810000000335790872300992912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083771912260538297760000012674654345110390407_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050658488369814018920000009172908421841176764_",
    style: {
      clipPath: "url(#SVGID_00000147937932765463331410000016651143986270988953_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091006159557475083240000013128979453454017456_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052105065121475225390000010231558575797361556_",
    style: {
      clipPath: "url(#SVGID_00000050658488369814018920000009172908421841176764_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011019225833612185550000009028353373248612001_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000121254481449921081130000014826081115164341127_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000150080696403810990070000003617296896108539552_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098210770393238324420000013113164093861557640_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000171716605731586128700000002398599596291493517_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163779502745920225940000010579679775496393344_",
    style: {
      clipPath: "url(#SVGID_00000161590434992332123810000000335790872300992912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121254481449921081130000014826081115164341127_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016060583808816557740000001805377626959009935_",
    style: {
      clipPath: "url(#SVGID_00000163779502745920225940000010579679775496393344_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150080696403810990070000003617296896108539552_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134932351139696860830000015255656333922396336_",
    style: {
      clipPath: "url(#SVGID_00000016060583808816557740000001805377626959009935_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098210770393238324420000013113164093861557640_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129208216038382074910000017869710885389177754_",
    style: {
      clipPath: "url(#SVGID_00000134932351139696860830000015255656333922396336_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171716605731586128700000002398599596291493517_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000163062081356574596240000002469622907398354588_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000020378981647562461530000009033566164840151942_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000172411579229283366130000016967184073968887683_",
    style: {
      clipPath: "url(#SVGID_00000161590434992332123810000000335790872300992912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163062081356574596240000002469622907398354588_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000126284441363328156120000000207166418368250009_",
    style: {
      clipPath: "url(#SVGID_00000172411579229283366130000016967184073968887683_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020378981647562461530000009033566164840151942_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000168081020564801858180000005212846592206330797_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096027103411651609090000003838997867423486084_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000062150693140623700060000005614100009961327543_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124124851004882424360000012556913567134877322_",
    style: {
      clipPath: "url(#SVGID_00000161590434992332123810000000335790872300992912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168081020564801858180000005212846592206330797_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062176446002389255570000016074621116006196367_",
    style: {
      clipPath: "url(#SVGID_00000124124851004882424360000012556913567134877322_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096027103411651609090000003838997867423486084_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147939876010153669400000016235134801275232900_",
    style: {
      clipPath: "url(#SVGID_00000062176446002389255570000016074621116006196367_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062150693140623700060000005614100009961327543_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000046315275150099907320000007001223236843521178_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000082363963547222313200000011998326107296665251_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000036943935461304106880000009937999871559248276_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000172415534897034158560000005106889952010624956_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163788402225856109200000008497706126031484817_",
    style: {
      clipPath: "url(#SVGID_00000161590434992332123810000000335790872300992912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000046315275150099907320000007001223236843521178_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134937925996133038630000000355127044034759065_",
    style: {
      clipPath: "url(#SVGID_00000163788402225856109200000008497706126031484817_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000082363963547222313200000011998326107296665251_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000095331873241879476930000000884815008500841891_",
    style: {
      clipPath: "url(#SVGID_00000134937925996133038630000000355127044034759065_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036943935461304106880000009937999871559248276_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181054214382145534870000015090415630969747608_",
    style: {
      clipPath: "url(#SVGID_00000095331873241879476930000000884815008500841891_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172415534897034158560000005106889952010624956_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000135682882866059505870000001900993568001135280_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000060004720594749025670000007552094388542322349_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000065754485625993921290000010695476483516557475_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000008827678513694899100000010284557181308706704_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000095325788448101616910000012837230447197140621_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081631818169257160700000016498485614944371607_",
    style: {
      clipPath: "url(#SVGID_00000161590434992332123810000000335790872300992912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000135682882866059505870000001900993568001135280_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000135684868117470456130000016497901925222291381_",
    style: {
      clipPath: "url(#SVGID_00000081631818169257160700000016498485614944371607_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060004720594749025670000007552094388542322349_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000169552234800110196610000004723770293671967616_",
    style: {
      clipPath: "url(#SVGID_00000135684868117470456130000016497901925222291381_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065754485625993921290000010695476483516557475_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150079511808330143890000008361757198348003508_",
    style: {
      clipPath: "url(#SVGID_00000169552234800110196610000004723770293671967616_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008827678513694899100000010284557181308706704_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091717845713829397300000002144235668558444963_",
    style: {
      clipPath: "url(#SVGID_00000150079511808330143890000008361757198348003508_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095325788448101616910000012837230447197140621_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000062194374631058972360000004233905937806681253_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000072272297903146910130000006663118482204576398_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000054986382782888009220000005500938390170275491_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000115494737293113703650000008485026571609037201_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000039821194261488005580000010172211599915509921_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116932240727154420250000004816747173023489666_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152956406152621761060000012292125272828211644_",
    style: {
      clipPath: "url(#SVGID_00000161590434992332123810000000335790872300992912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062194374631058972360000004233905937806681253_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000156557765654330900210000007203198518174691248_",
    style: {
      clipPath: "url(#SVGID_00000152956406152621761060000012292125272828211644_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072272297903146910130000006663118482204576398_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092454114942677850430000013156220101779554484_",
    style: {
      clipPath: "url(#SVGID_00000156557765654330900210000007203198518174691248_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054986382782888009220000005500938390170275491_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000055669819897102094320000001369445981106290056_",
    style: {
      clipPath: "url(#SVGID_00000092454114942677850430000013156220101779554484_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115494737293113703650000008485026571609037201_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034790121834787319690000013065664167672433309_",
    style: {
      clipPath: "url(#SVGID_00000055669819897102094320000001369445981106290056_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039821194261488005580000010172211599915509921_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000037689727990411919430000001748775396122540721_",
    style: {
      clipPath: "url(#SVGID_00000034790121834787319690000013065664167672433309_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116932240727154420250000004816747173023489666_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029003902238690469670000006621474585696760449_",
    gradientUnits: "userSpaceOnUse",
    x1: -261.3947,
    y1: 133.6122,
    x2: -295.2533,
    y2: 143.0853,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000037689727990411919430000001748775396122540721_)",
      fill: "url(#SVGID_00000029003902238690469670000006621474585696760449_)"
    },
    points: " 70.7,72.7 69.6,73.3 67.2,100.1 75,93.5  "
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021801226757099071110000006623220711809599121_",
    gradientUnits: "userSpaceOnUse",
    x1: -261.3947,
    y1: 133.6122,
    x2: -295.2533,
    y2: 143.0853,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000161590434992332123810000000335790872300992912_)",
      mask: "url(#SVGID_00000155864389099146695010000010258589812684560829_)",
      fill: "url(#SVGID_00000021801226757099071110000006623220711809599121_)"
    },
    points: " 70.7,72.7 69.6,73.3 67.2,100.1 75,93.5  "
  }))))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "70.7,72.7 69.6,73.3 67.2,100.1 75,93.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000010274775441125966810000010533905354225218238_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000130629172583958683970000010611649635231936167_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000010274775441125966810000010533905354225218238_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000108289349373500630770000001778291802499704980_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000051352570830366876960000001024219904605863598_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000169525907792694614590000013507990806955305887_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108289349373500630770000001778291802499704980_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039114430470232260450000010725962009806786705_",
    style: {
      clipPath: "url(#SVGID_00000169525907792694614590000013507990806955305887_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000051352570830366876960000001024219904605863598_",
    style: {
      overflow: "visible"
    }
  })), _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000163040481674757862990000006658302782703737007_",
    filterUnits: "userSpaceOnUse",
    x: 99.1,
    y: 72.7,
    width: 7.8,
    height: 27.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 99.1,
    y: 72.7,
    width: 7.8,
    height: 27.4,
    id: "SVGID_00000098934027997011458060000011905611488815384453_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000163040481674757862990000006658302782703737007_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000039821331981788490020000013264745568524551614_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000150796586978141988100000014079931999840914069_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071535146115961417930000015124167634873348264_",
    style: {
      clipPath: "url(#SVGID_00000039114430470232260450000010725962009806786705_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039821331981788490020000013264745568524551614_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000046300103071352070990000002754044671585138363_",
    style: {
      clipPath: "url(#SVGID_00000071535146115961417930000015124167634873348264_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150796586978141988100000014079931999840914069_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000033341921315873379190000002680899113770497969_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000163066622617844207850000004427899543163096730_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000134248717213210680090000014827181358245924796_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038397514662423878180000011889092492309373864_",
    style: {
      clipPath: "url(#SVGID_00000039114430470232260450000010725962009806786705_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033341921315873379190000002680899113770497969_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083066890182331253060000013256500721463889306_",
    style: {
      clipPath: "url(#SVGID_00000038397514662423878180000011889092492309373864_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163066622617844207850000004427899543163096730_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016052230169026999480000006866360326254463659_",
    style: {
      clipPath: "url(#SVGID_00000083066890182331253060000013256500721463889306_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134248717213210680090000014827181358245924796_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000024003736130976714780000010656893667390831521_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000170264219445914206480000013117336869478172344_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171721630163692571830000012712694001716710579_",
    style: {
      clipPath: "url(#SVGID_00000039114430470232260450000010725962009806786705_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000024003736130976714780000010656893667390831521_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044140095566331405510000004282327367443529604_",
    style: {
      clipPath: "url(#SVGID_00000171721630163692571830000012712694001716710579_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170264219445914206480000013117336869478172344_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000069373049865419873070000002410741137149563577_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000165231666667638832500000015217710182830897851_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098918922953638585570000011970500592766882746_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163064635406010432060000012535866952289496765_",
    style: {
      clipPath: "url(#SVGID_00000039114430470232260450000010725962009806786705_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069373049865419873070000002410741137149563577_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014603325565112968890000010301309187796081578_",
    style: {
      clipPath: "url(#SVGID_00000163064635406010432060000012535866952289496765_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165231666667638832500000015217710182830897851_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044175940617684979860000017719606486117814953_",
    style: {
      clipPath: "url(#SVGID_00000014603325565112968890000010301309187796081578_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098918922953638585570000011970500592766882746_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000111168945129047939970000013767060348948294297_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000150096034840723722750000010135159892872613525_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000142864829397061600050000010421507982755782566_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000124855754764368369060000001884162513529533627_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057126188409939441370000009428229251834893967_",
    style: {
      clipPath: "url(#SVGID_00000039114430470232260450000010725962009806786705_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111168945129047939970000013767060348948294297_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038412407451253463730000002193171016232002454_",
    style: {
      clipPath: "url(#SVGID_00000057126188409939441370000009428229251834893967_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150096034840723722750000010135159892872613525_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038404518620241450390000005416248171342088114_",
    style: {
      clipPath: "url(#SVGID_00000038412407451253463730000002193171016232002454_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142864829397061600050000010421507982755782566_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073721271084612025240000015782489160726346642_",
    style: {
      clipPath: "url(#SVGID_00000038404518620241450390000005416248171342088114_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124855754764368369060000001884162513529533627_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096036504635569993650000015952835405196800686_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000022555402771755242410000011106829557050708894_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052807430627764605570000004115222774032103306_",
    style: {
      clipPath: "url(#SVGID_00000039114430470232260450000010725962009806786705_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096036504635569993650000015952835405196800686_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013874457734181533010000016313048506803667344_",
    style: {
      clipPath: "url(#SVGID_00000052807430627764605570000004115222774032103306_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000022555402771755242410000011106829557050708894_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000094602908385489575810000003219333964747087532_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000084502336096632617130000006347255235810223239_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000005985563510416638100000012284200093710856629_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165211527849265967280000008186138545007730351_",
    style: {
      clipPath: "url(#SVGID_00000039114430470232260450000010725962009806786705_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094602908385489575810000003219333964747087532_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000079480099438478575310000008232426425567457434_",
    style: {
      clipPath: "url(#SVGID_00000165211527849265967280000008186138545007730351_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000084502336096632617130000006347255235810223239_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131334828078865444520000002063086562477690297_",
    style: {
      clipPath: "url(#SVGID_00000079480099438478575310000008232426425567457434_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005985563510416638100000012284200093710856629_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000092442466427556633100000016667915213163403708_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000134957392065191114340000013474926932274201738_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs64 || (_defs64 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000145742242581677030700000008595007683878303409_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs65 || (_defs65 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000124120593699521934280000015285592830016370623_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063617932197372929670000007449267564991987372_",
    style: {
      clipPath: "url(#SVGID_00000039114430470232260450000010725962009806786705_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000092442466427556633100000016667915213163403708_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021840208633077579160000016826857582090477737_",
    style: {
      clipPath: "url(#SVGID_00000063617932197372929670000007449267564991987372_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134957392065191114340000013474926932274201738_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077296381913048423100000006204563378866461355_",
    style: {
      clipPath: "url(#SVGID_00000021840208633077579160000016826857582090477737_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145742242581677030700000008595007683878303409_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080180526057414375940000003208657096029604256_",
    style: {
      clipPath: "url(#SVGID_00000077296381913048423100000006204563378866461355_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124120593699521934280000015285592830016370623_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs66 || (_defs66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000114060772879799847930000001873425161565670569_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs67 || (_defs67 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052804550993797727150000005503496507688368311_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs68 || (_defs68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000019657359745435154640000005316033242283914129_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs69 || (_defs69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000038397309678426974990000003800646677185002893_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs70 || (_defs70 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000074438869729265527460000014275081525390450846_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176002503126525921530000006293029130586259853_",
    style: {
      clipPath: "url(#SVGID_00000039114430470232260450000010725962009806786705_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114060772879799847930000001873425161565670569_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054969339402105452210000017595256406218016692_",
    style: {
      clipPath: "url(#SVGID_00000176002503126525921530000006293029130586259853_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052804550993797727150000005503496507688368311_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021119348860725751390000004588720055104136081_",
    style: {
      clipPath: "url(#SVGID_00000054969339402105452210000017595256406218016692_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019657359745435154640000005316033242283914129_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105402498546879894810000006947592227164082589_",
    style: {
      clipPath: "url(#SVGID_00000021119348860725751390000004588720055104136081_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000038397309678426974990000003800646677185002893_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000130641066955313074940000016711418584770387881_",
    style: {
      clipPath: "url(#SVGID_00000105402498546879894810000006947592227164082589_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000074438869729265527460000014275081525390450846_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs71 || (_defs71 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000016790409025129506660000017463573944502238623_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs72 || (_defs72 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000139991326263928834800000012537336986969930382_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs73 || (_defs73 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000099642193421480394250000005406792967759285665_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs74 || (_defs74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000183225588330387782060000013606708252479990663_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs75 || (_defs75 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013152435185070709840000002005719607557244844_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs76 || (_defs76 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052080580204671605290000009938896754455853185_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034791800071157397750000010083244386840084904_",
    style: {
      clipPath: "url(#SVGID_00000039114430470232260450000010725962009806786705_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016790409025129506660000017463573944502238623_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018232914798807136730000005746748770467347877_",
    style: {
      clipPath: "url(#SVGID_00000034791800071157397750000010083244386840084904_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139991326263928834800000012537336986969930382_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000162351082637799526920000006713342683816077983_",
    style: {
      clipPath: "url(#SVGID_00000018232914798807136730000005746748770467347877_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099642193421480394250000005406792967759285665_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028298344436981976210000003483822148421547691_",
    style: {
      clipPath: "url(#SVGID_00000162351082637799526920000006713342683816077983_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183225588330387782060000013606708252479990663_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000020393478008293925700000006925213277286827931_",
    style: {
      clipPath: "url(#SVGID_00000028298344436981976210000003483822148421547691_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013152435185070709840000002005719607557244844_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111871436671697217120000017647096089202192557_",
    style: {
      clipPath: "url(#SVGID_00000020393478008293925700000006925213277286827931_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052080580204671605290000009938896754455853185_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035523805383644916200000008534232356159278782_",
    gradientUnits: "userSpaceOnUse",
    x1: -301.052,
    y1: 130.4505,
    x2: -304.9579,
    y2: 187.477,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000111871436671697217120000017647096089202192557_)",
      fill: "url(#SVGID_00000035523805383644916200000008534232356159278782_)"
    },
    points: " 103.2,72.7 104.4,73.3 106.8,100.1 99.1,93.5  "
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044886058094367886350000008547756438290680459_",
    gradientUnits: "userSpaceOnUse",
    x1: -301.052,
    y1: 130.4505,
    x2: -304.9579,
    y2: 187.477,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000039114430470232260450000010725962009806786705_)",
      mask: "url(#SVGID_00000098934027997011458060000011905611488815384453_)",
      fill: "url(#SVGID_00000044886058094367886350000008547756438290680459_)"
    },
    points: " 103.2,72.7 104.4,73.3 106.8,100.1 99.1,93.5  "
  }))))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "103.2,72.7 104.4,73.3 106.8,100.1 99.1,93.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169539293163818345320000016553606036079049881_",
    gradientUnits: "userSpaceOnUse",
    x1: -559.8093,
    y1: -808.3766,
    x2: -559.8093,
    y2: -804.1418,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000169539293163818345320000016553606036079049881_)"
    },
    points: "77,99.3 97.2,99.3  97.2,93.9 77,93.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs77 || (_defs77 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000057145080519085307920000011272305259693380256_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099661779867586332690000001900093275766832282_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057145080519085307920000011272305259693380256_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs78 || (_defs78 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013873368633648483320000010112702779906232706_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs79 || (_defs79 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000143603125272498264920000006818300709902601647_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063621309775477345940000006606395297220311174_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013873368633648483320000010112702779906232706_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075856527222212809390000017331319684985497230_",
    style: {
      clipPath: "url(#SVGID_00000063621309775477345940000006606395297220311174_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000143603125272498264920000006818300709902601647_",
    style: {
      overflow: "visible"
    }
  })), _defs80 || (_defs80 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000019660754703700319920000000162471036091042454_",
    filterUnits: "userSpaceOnUse",
    x: 77,
    y: 93.9,
    width: 20.2,
    height: 5.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 93.9,
    width: 20.2,
    height: 5.4,
    id: "SVGID_00000011715747011461143480000018083028915282923952_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000019660754703700319920000000162471036091042454_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs81 || (_defs81 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000181783984038759339420000005964213678770836149_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs82 || (_defs82 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000137115951864089360790000008669069599238188198_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146482971094908947550000013757769711812741800_",
    style: {
      clipPath: "url(#SVGID_00000075856527222212809390000017331319684985497230_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181783984038759339420000005964213678770836149_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071519367149793925750000013533071987054371231_",
    style: {
      clipPath: "url(#SVGID_00000146482971094908947550000013757769711812741800_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137115951864089360790000008669069599238188198_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs83 || (_defs83 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000074424034618450788010000011810886356280098993_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs84 || (_defs84 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000138554298052352854450000003942308267774374328_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs85 || (_defs85 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000074407610994752110240000012552743536644605350_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118399192600211870650000014728924986713356460_",
    style: {
      clipPath: "url(#SVGID_00000075856527222212809390000017331319684985497230_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000074424034618450788010000011810886356280098993_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104670802138653409550000006090317328035878294_",
    style: {
      clipPath: "url(#SVGID_00000118399192600211870650000014728924986713356460_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138554298052352854450000003942308267774374328_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174599477974172669930000006762276766959405449_",
    style: {
      clipPath: "url(#SVGID_00000104670802138653409550000006090317328035878294_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000074407610994752110240000012552743536644605350_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs86 || (_defs86 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000071531879395719986090000013168329938939050645_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs87 || (_defs87 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000093870751576480053100000007436237384659141302_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150798266006952084100000000056777994895162811_",
    style: {
      clipPath: "url(#SVGID_00000075856527222212809390000017331319684985497230_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071531879395719986090000013168329938939050645_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170982173046770396910000007667072825980873362_",
    style: {
      clipPath: "url(#SVGID_00000150798266006952084100000000056777994895162811_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093870751576480053100000007436237384659141302_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs88 || (_defs88 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000140729431372776482070000009505495440306537396_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs89 || (_defs89 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000134218618100823329980000002856285746839785366_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs90 || (_defs90 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000128484605038431689810000008458822559682921659_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168083755635291469690000011464808994019697315_",
    style: {
      clipPath: "url(#SVGID_00000075856527222212809390000017331319684985497230_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000140729431372776482070000009505495440306537396_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000166660744440397388280000017092946694433949859_",
    style: {
      clipPath: "url(#SVGID_00000168083755635291469690000011464808994019697315_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134218618100823329980000002856285746839785366_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161615525977796417670000006567342626977208727_",
    style: {
      clipPath: "url(#SVGID_00000166660744440397388280000017092946694433949859_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128484605038431689810000008458822559682921659_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs91 || (_defs91 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000006676030681972466830000017493940904991761074_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs92 || (_defs92 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000118360047869062135400000013729907799891637947_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs93 || (_defs93 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000080917261179976477420000007999359304810942893_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs94 || (_defs94 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000150824369162856718190000008267122332772160401_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137849754505390572640000001689378748095583639_",
    style: {
      clipPath: "url(#SVGID_00000075856527222212809390000017331319684985497230_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006676030681972466830000017493940904991761074_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000126316752001771228390000010727317357819668405_",
    style: {
      clipPath: "url(#SVGID_00000137849754505390572640000001689378748095583639_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118360047869062135400000013729907799891637947_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137833927376867926250000001891458643580043655_",
    style: {
      clipPath: "url(#SVGID_00000126316752001771228390000010727317357819668405_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080917261179976477420000007999359304810942893_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078019556541744977410000017333962628583147424_",
    style: {
      clipPath: "url(#SVGID_00000137833927376867926250000001891458643580043655_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150824369162856718190000008267122332772160401_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs95 || (_defs95 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000019646076742023376940000008852659824621198758_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs96 || (_defs96 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000178887807808862657930000005167814607826163099_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000076598205265797396090000002762922194639557517_",
    style: {
      clipPath: "url(#SVGID_00000075856527222212809390000017331319684985497230_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019646076742023376940000008852659824621198758_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160889685121802411880000016569699957320520835_",
    style: {
      clipPath: "url(#SVGID_00000076598205265797396090000002762922194639557517_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178887807808862657930000005167814607826163099_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs97 || (_defs97 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000047750153118235135600000015420100509337957567_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs98 || (_defs98 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000112606786325186040930000006755116374039880607_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs99 || (_defs99 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000173842012518034646100000013838232182217826982_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036946827493814594090000013348255682019396259_",
    style: {
      clipPath: "url(#SVGID_00000075856527222212809390000017331319684985497230_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047750153118235135600000015420100509337957567_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000043451070775265277040000003475454233838282391_",
    style: {
      clipPath: "url(#SVGID_00000036946827493814594090000013348255682019396259_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000112606786325186040930000006755116374039880607_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029742300112431522820000001310373961627151772_",
    style: {
      clipPath: "url(#SVGID_00000043451070775265277040000003475454233838282391_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173842012518034646100000013838232182217826982_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs100 || (_defs100 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000157268588811774940670000015807981384187243680_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs101 || (_defs101 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000033361137212522396700000014413133907634985644_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs102 || (_defs102 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000121253424172351072090000015065532329578170006_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs103 || (_defs103 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000156550325813312572140000010160565893905706672_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096770979748222975710000000035095142068444342_",
    style: {
      clipPath: "url(#SVGID_00000075856527222212809390000017331319684985497230_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157268588811774940670000015807981384187243680_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149369742525854558310000001496363473374941324_",
    style: {
      clipPath: "url(#SVGID_00000096770979748222975710000000035095142068444342_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033361137212522396700000014413133907634985644_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010290864825938799110000013674682854663922049_",
    style: {
      clipPath: "url(#SVGID_00000149369742525854558310000001496363473374941324_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121253424172351072090000015065532329578170006_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139283444332751738850000007505151908046597527_",
    style: {
      clipPath: "url(#SVGID_00000010290864825938799110000013674682854663922049_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000156550325813312572140000010160565893905706672_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs104 || (_defs104 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000183215729793127795400000005696214788137266605_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs105 || (_defs105 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000165941963539196635030000005333197951569011846_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs106 || (_defs106 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000020397116670853787340000000860616980973427076_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs107 || (_defs107 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000132076813028334562760000003299096459946987707_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs108 || (_defs108 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000019647163844941581990000008219801026811166638_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060004249616294635080000015607467028073563832_",
    style: {
      clipPath: "url(#SVGID_00000075856527222212809390000017331319684985497230_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183215729793127795400000005696214788137266605_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147217508892125434590000014296920492042137239_",
    style: {
      clipPath: "url(#SVGID_00000060004249616294635080000015607467028073563832_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165941963539196635030000005333197951569011846_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042006702106355412160000009999314423896842394_",
    style: {
      clipPath: "url(#SVGID_00000147217508892125434590000014296920492042137239_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020397116670853787340000000860616980973427076_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034050169685192616990000005336208285009441419_",
    style: {
      clipPath: "url(#SVGID_00000042006702106355412160000009999314423896842394_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132076813028334562760000003299096459946987707_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000102517494518890998680000012277021641877004677_",
    style: {
      clipPath: "url(#SVGID_00000034050169685192616990000005336208285009441419_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019647163844941581990000008219801026811166638_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs109 || (_defs109 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000178197948917341402800000004427465474958257589_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs110 || (_defs110 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000015348812297427594760000001345099979393523622_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs111 || (_defs111 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000173856048390129703660000007688579479379734676_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs112 || (_defs112 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000064345229442293673290000017244347027061059761_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs113 || (_defs113 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000020368822320026834430000017927232850395232191_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs114 || (_defs114 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000034081508372616113050000007804682655876105353_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090267174938871858970000010529881983407052724_",
    style: {
      clipPath: "url(#SVGID_00000075856527222212809390000017331319684985497230_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178197948917341402800000004427465474958257589_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066474014123292314690000005427379690907620760_",
    style: {
      clipPath: "url(#SVGID_00000090267174938871858970000010529881983407052724_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000015348812297427594760000001345099979393523622_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137109564583343763190000010243919227523790739_",
    style: {
      clipPath: "url(#SVGID_00000066474014123292314690000005427379690907620760_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173856048390129703660000007688579479379734676_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145038074555599749010000014769082483356652976_",
    style: {
      clipPath: "url(#SVGID_00000137109564583343763190000010243919227523790739_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000064345229442293673290000017244347027061059761_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000012434512973104689270000010171931934340756360_",
    style: {
      clipPath: "url(#SVGID_00000145038074555599749010000014769082483356652976_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020368822320026834430000017927232850395232191_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142149165874443312290000002528002991455719351_",
    style: {
      clipPath: "url(#SVGID_00000012434512973104689270000010171931934340756360_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034081508372616113050000007804682655876105353_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155145716345242712640000005296281145279712171_",
    gradientUnits: "userSpaceOnUse",
    x1: -284.4539,
    y1: 120.7452,
    x2: -286.4707,
    y2: 160.6239,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000142149165874443312290000002528002991455719351_)",
      fill: "url(#SVGID_00000155145716345242712640000005296281145279712171_)"
    },
    points: " 97.2,93.9 77,93.9 77,99.3 78.5,99.3 78.5,95.6 97.2,95.6  "
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124870703520788833880000001259509348063627676_",
    gradientUnits: "userSpaceOnUse",
    x1: -284.4539,
    y1: 120.7452,
    x2: -286.4707,
    y2: 160.6239,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000075856527222212809390000017331319684985497230_)",
      mask: "url(#SVGID_00000011715747011461143480000018083028915282923952_)",
      fill: "url(#SVGID_00000124870703520788833880000001259509348063627676_)"
    },
    points: " 97.2,93.9 77,93.9 77,99.3 78.5,99.3 78.5,95.6 97.2,95.6  "
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027572600512574322190000004620901622704864160_",
    gradientUnits: "userSpaceOnUse",
    x1: -284.4539,
    y1: 120.7452,
    x2: -286.4707,
    y2: 160.6239,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000027572600512574322190000004620901622704864160_)"
    },
    points: "97.2,93.9 77,93.9 77,99.3  78.5,99.3 78.5,95.6 97.2,95.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024682306641767532890000003490961913143682960_",
    gradientUnits: "userSpaceOnUse",
    x1: -568.4093,
    y1: -809.1886,
    x2: -551.2093,
    y2: -809.1886,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000024682306641767532890000003490961913143682960_)"
    },
    points: "78.5,100.4 95.7,100.4  95.7,99.3 78.5,99.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097465874031233953150000010725598630325852581_",
    gradientUnits: "userSpaceOnUse",
    x1: -559.8093,
    y1: -799.6982,
    x2: -559.8093,
    y2: -754.8248,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097465874031233953150000010725598630325852581_)"
    },
    d: "M71.3,37.4 C75.8,18.9,86.8,5.9,87.1,5.6l0,0l0,0c0,0,11.1,13.2,15.6,31.9c1.2,4.7,1.9,9.7,1.9,15c0,4.6-0.1,8.9-0.4,12.9 c-1.3,18.2-5.1,28.5-5.1,28.5h-12l0,0h-12c0,0-3.8-10.3-5.1-28.6c-0.2-3.9-0.4-8.2-0.4-12.9C69.6,47.1,70.2,42.1,71.3,37.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155112456215744581390000005379616771548214405_",
    gradientUnits: "userSpaceOnUse",
    x1: -266.1208,
    y1: 200.5574,
    x2: -316.5071,
    y2: 195.4796,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155112456215744581390000005379616771548214405_)"
    },
    d: "M71.3,37.4c5,1.5,10.2,2.3,15.7,2.3 s10.7-0.8,15.7-2.3C98.2,18.8,87.1,5.6,87.1,5.6S75.8,18.8,71.3,37.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs115 || (_defs115 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000010308671594630887580000000997255889308094904_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022544346130345491580000005733807809504471475_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000010308671594630887580000000997255889308094904_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs116 || (_defs116 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000117638063466936040450000017127546200575948978_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs117 || (_defs117 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000182520972994412923590000002145953284800363691_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022523970503815025940000001646908478015828633_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117638063466936040450000017127546200575948978_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000012452065621270282530000011421924083187922874_",
    style: {
      clipPath: "url(#SVGID_00000022523970503815025940000001646908478015828633_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000182520972994412923590000002145953284800363691_",
    style: {
      overflow: "visible"
    }
  })), _defs118 || (_defs118 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000059303381397616518830000007616853329357695116_",
    filterUnits: "userSpaceOnUse",
    x: 69.6,
    y: 5.6,
    width: 17.5,
    height: 88.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 69.6,
    y: 5.6,
    width: 17.5,
    height: 88.3,
    id: "SVGID_00000104693901887507485390000004424371879515449267_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000059303381397616518830000007616853329357695116_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs119 || (_defs119 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000018209781091236664360000017113146827787410604_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs120 || (_defs120 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000156556744942640415270000006072208612470220176_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062180342292573312210000017682108959629426105_",
    style: {
      clipPath: "url(#SVGID_00000012452065621270282530000011421924083187922874_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018209781091236664360000017113146827787410604_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000130605676468496061910000012734642844086585482_",
    style: {
      clipPath: "url(#SVGID_00000062180342292573312210000017682108959629426105_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000156556744942640415270000006072208612470220176_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs121 || (_defs121 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000070797868138936115100000007676633016908908165_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs122 || (_defs122 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000176004440622588621960000000569779906736015490_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs123 || (_defs123 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000075159879700422133190000006332076087771939736_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000040567639767228783940000002562508525133030276_",
    style: {
      clipPath: "url(#SVGID_00000012452065621270282530000011421924083187922874_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070797868138936115100000007676633016908908165_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139978443551313298600000011495160630303404199_",
    style: {
      clipPath: "url(#SVGID_00000040567639767228783940000002562508525133030276_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176004440622588621960000000569779906736015490_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002363756744454683820000009360409859302483849_",
    style: {
      clipPath: "url(#SVGID_00000139978443551313298600000011495160630303404199_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075159879700422133190000006332076087771939736_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs124 || (_defs124 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000057852445994892773220000017297267475809673372_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs125 || (_defs125 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000111170799442302904240000016304646050229451904_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173134922731735299800000000380892245422315676_",
    style: {
      clipPath: "url(#SVGID_00000012452065621270282530000011421924083187922874_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057852445994892773220000017297267475809673372_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000167374101927657308860000003762625820039052680_",
    style: {
      clipPath: "url(#SVGID_00000173134922731735299800000000380892245422315676_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111170799442302904240000016304646050229451904_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs126 || (_defs126 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052068765212821268070000017602261452876559280_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs127 || (_defs127 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000160162328301869724790000012861502687114329234_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs128 || (_defs128 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000065035679226522824050000017181443583815603337_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000166648211232021170460000005663436914314921857_",
    style: {
      clipPath: "url(#SVGID_00000012452065621270282530000011421924083187922874_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052068765212821268070000017602261452876559280_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063610934349096965750000002189184505013157767_",
    style: {
      clipPath: "url(#SVGID_00000166648211232021170460000005663436914314921857_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160162328301869724790000012861502687114329234_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022549839512171722160000015653142373565641618_",
    style: {
      clipPath: "url(#SVGID_00000063610934349096965750000002189184505013157767_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065035679226522824050000017181443583815603337_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs129 || (_defs129 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013888621402784119040000012226490026614381733_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs130 || (_defs130 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000071534199670744750100000013327900158509800073_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs131 || (_defs131 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000147203028270534569190000012852432006690608549_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs132 || (_defs132 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000027596290499901905120000002725269531394643093_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115494566012973346440000006617932123843501958_",
    style: {
      clipPath: "url(#SVGID_00000012452065621270282530000011421924083187922874_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013888621402784119040000012226490026614381733_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105404976362216661490000008215962607717487492_",
    style: {
      clipPath: "url(#SVGID_00000115494566012973346440000006617932123843501958_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071534199670744750100000013327900158509800073_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080177162102196170380000014983768963312241828_",
    style: {
      clipPath: "url(#SVGID_00000105404976362216661490000008215962607717487492_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147203028270534569190000012852432006690608549_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080927087323793140320000014237188756123078030_",
    style: {
      clipPath: "url(#SVGID_00000080177162102196170380000014983768963312241828_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000027596290499901905120000002725269531394643093_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs133 || (_defs133 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000075842034013541409180000014741870359597195145_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs134 || (_defs134 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000177468742704731366330000003735597480573868991_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057851730923330699970000002378528569227780281_",
    style: {
      clipPath: "url(#SVGID_00000012452065621270282530000011421924083187922874_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075842034013541409180000014741870359597195145_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000133489849869331226970000008337024687774353557_",
    style: {
      clipPath: "url(#SVGID_00000057851730923330699970000002378528569227780281_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177468742704731366330000003735597480573868991_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs135 || (_defs135 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116192994811672886020000018019855110984010900_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs136 || (_defs136 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000168105183289430104930000006665154191878013829_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs137 || (_defs137 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000107558770591208641280000002042569409223023546_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010281107080000974910000017240541556328039332_",
    style: {
      clipPath: "url(#SVGID_00000012452065621270282530000011421924083187922874_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116192994811672886020000018019855110984010900_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098927063950522747570000015412635951047413414_",
    style: {
      clipPath: "url(#SVGID_00000010281107080000974910000017240541556328039332_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168105183289430104930000006665154191878013829_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000135669979541906008060000000052167249952436644_",
    style: {
      clipPath: "url(#SVGID_00000098927063950522747570000015412635951047413414_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107558770591208641280000002042569409223023546_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs138 || (_defs138 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000154413286663727918380000006716960752506129293_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs139 || (_defs139 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000120520324752865727040000012149078344099197339_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs140 || (_defs140 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000022554738519123617050000005693057620073485748_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs141 || (_defs141 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000148661258906807715490000010886324992078729368_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129910903900849005060000003593361953636788159_",
    style: {
      clipPath: "url(#SVGID_00000012452065621270282530000011421924083187922874_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000154413286663727918380000006716960752506129293_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000141415812061139494810000005997104940253037236_",
    style: {
      clipPath: "url(#SVGID_00000129910903900849005060000003593361953636788159_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120520324752865727040000012149078344099197339_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155864408100189097760000014662064456564251056_",
    style: {
      clipPath: "url(#SVGID_00000141415812061139494810000005997104940253037236_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000022554738519123617050000005693057620073485748_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000143613646977066913470000010820361420495738517_",
    style: {
      clipPath: "url(#SVGID_00000155864408100189097760000014662064456564251056_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148661258906807715490000010886324992078729368_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs142 || (_defs142 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000032649592138321205080000010549204966666834355_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs143 || (_defs143 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000126304246207856471550000016732602392334588574_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs144 || (_defs144 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000168079377553938596740000000137456408687648150_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs145 || (_defs145 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000183935262374512408070000007556132661956353673_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs146 || (_defs146 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000067938893906185456260000014210967997756472207_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018201643185287124750000006483287979615328955_",
    style: {
      clipPath: "url(#SVGID_00000012452065621270282530000011421924083187922874_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000032649592138321205080000010549204966666834355_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168837239847604804070000016335951486732206483_",
    style: {
      clipPath: "url(#SVGID_00000018201643185287124750000006483287979615328955_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000126304246207856471550000016732602392334588574_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145037398464400255390000015449036328637281705_",
    style: {
      clipPath: "url(#SVGID_00000168837239847604804070000016335951486732206483_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168079377553938596740000000137456408687648150_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104664422953621694000000002716510711704868272_",
    style: {
      clipPath: "url(#SVGID_00000145037398464400255390000015449036328637281705_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183935262374512408070000007556132661956353673_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059268372937665554670000007981009563209243547_",
    style: {
      clipPath: "url(#SVGID_00000104664422953621694000000002716510711704868272_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067938893906185456260000014210967997756472207_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs147 || (_defs147 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000033339032123459074830000001228599201766092929_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs148 || (_defs148 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116224982260980407020000008319782185948175035_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs149 || (_defs149 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000042002919284222517800000000738326404367548580_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs150 || (_defs150 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000117662121870126351970000001395502083897277365_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs151 || (_defs151 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000060021201590693202280000013523078666117505705_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs152 || (_defs152 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000054958261746210782420000009716299506575720351_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085229732152381927390000018232789821497016974_",
    style: {
      clipPath: "url(#SVGID_00000012452065621270282530000011421924083187922874_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033339032123459074830000001228599201766092929_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163072486810399452450000015965166984204632993_",
    style: {
      clipPath: "url(#SVGID_00000085229732152381927390000018232789821497016974_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116224982260980407020000008319782185948175035_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134949645326205016780000016763749495872749454_",
    style: {
      clipPath: "url(#SVGID_00000163072486810399452450000015965166984204632993_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042002919284222517800000000738326404367548580_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000154407845299602679870000005431455412309329825_",
    style: {
      clipPath: "url(#SVGID_00000134949645326205016780000016763749495872749454_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117662121870126351970000001395502083897277365_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177459521889052256460000002081409574748819352_",
    style: {
      clipPath: "url(#SVGID_00000154407845299602679870000005431455412309329825_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060021201590693202280000013523078666117505705_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155825884793479619210000001885726157157021830_",
    style: {
      clipPath: "url(#SVGID_00000177459521889052256460000002081409574748819352_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054958261746210782420000009716299506575720351_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171708532917174207500000006114036228056930190_",
    gradientUnits: "userSpaceOnUse",
    x1: -294.2216,
    y1: 182.5019,
    x2: -139.1082,
    y2: 53.5155,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000155825884793479619210000001885726157157021830_)",
      fill: "url(#SVGID_00000171708532917174207500000006114036228056930190_)"
    },
    d: " M69.6,52.5c0,4.6,0.1,8.9,0.4,12.9c1.3,18.2,5.1,28.5,5.1,28.5h5C67,47.4,86.8,6.1,87.1,5.6 c-0.3,0.3-11.2,13.3-15.7,31.8C70.2,42.1,69.6,47.1,69.6,52.5z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100367757150102723430000010684941952435193774_",
    gradientUnits: "userSpaceOnUse",
    x1: -294.2216,
    y1: 182.5019,
    x2: -139.1082,
    y2: 53.5155,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000012452065621270282530000011421924083187922874_)",
      mask: "url(#SVGID_00000104693901887507485390000004424371879515449267_)",
      fill: "url(#SVGID_00000100367757150102723430000010684941952435193774_)"
    },
    d: " M69.6,52.5c0,4.6,0.1,8.9,0.4,12.9c1.3,18.2,5.1,28.5,5.1,28.5h5C67,47.4,86.8,6.1,87.1,5.6c-0.3,0.3-11.2,13.3-15.7,31.8 C70.2,42.1,69.6,47.1,69.6,52.5z"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M69.6,52.5c0,4.6,0.1,8.9,0.4,12.9c1.3,18.2,5.1,28.5,5.1,28.5h5C67,47.4,86.8,6.1,87.1,5.6 c-0.3,0.3-11.2,13.3-15.7,31.8C70.2,42.1,69.6,47.1,69.6,52.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs153 || (_defs153 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000012467118493121690150000008720894448275572395_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114753050258996857730000014994571029942114176_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000012467118493121690150000008720894448275572395_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs154 || (_defs154 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000142858181277922256990000002168926105390335153_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs155 || (_defs155 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000145053906901352814390000016000940529566311331_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042734788446864807040000016832556572705201297_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142858181277922256990000002168926105390335153_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181768744144153276020000013327966543607366543_",
    style: {
      clipPath: "url(#SVGID_00000042734788446864807040000016832556572705201297_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145053906901352814390000016000940529566311331_",
    style: {
      overflow: "visible"
    }
  })), _defs156 || (_defs156 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000064347211462021958120000000937661134725532328_",
    filterUnits: "userSpaceOnUse",
    x: 86.9,
    y: 5.6,
    width: 17.4,
    height: 88.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 86.9,
    y: 5.6,
    width: 17.4,
    height: 88.3,
    id: "SVGID_00000156550305465845534640000001983637026585783710_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000064347211462021958120000000937661134725532328_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs157 || (_defs157 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000082346977775309028800000012186516583005853068_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs158 || (_defs158 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000115492088279276028940000005585294670579795857_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122681399334580682730000007770038762085646476_",
    style: {
      clipPath: "url(#SVGID_00000181768744144153276020000013327966543607366543_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000082346977775309028800000012186516583005853068_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116926889531572584910000012629566139160947333_",
    style: {
      clipPath: "url(#SVGID_00000122681399334580682730000007770038762085646476_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115492088279276028940000005585294670579795857_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs159 || (_defs159 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000137853326862873257070000003889989642890191768_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs160 || (_defs160 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000142164380610152693670000000106043430608462513_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs161 || (_defs161 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000072274637816667928880000008818789168848669329_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150780858107065723940000002974882348044393382_",
    style: {
      clipPath: "url(#SVGID_00000181768744144153276020000013327966543607366543_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137853326862873257070000003889989642890191768_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000135656740126248454940000017044605248124582030_",
    style: {
      clipPath: "url(#SVGID_00000150780858107065723940000002974882348044393382_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142164380610152693670000000106043430608462513_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142150613846798075990000018376053807059830166_",
    style: {
      clipPath: "url(#SVGID_00000135656740126248454940000017044605248124582030_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072274637816667928880000008818789168848669329_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs162 || (_defs162 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000145028910346454559940000004872514081705200030_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs163 || (_defs163 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000033348966364532386520000017632139083848950416_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129192551738431189190000014290977596911153030_",
    style: {
      clipPath: "url(#SVGID_00000181768744144153276020000013327966543607366543_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145028910346454559940000004872514081705200030_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039101174834977009580000007681600924608790201_",
    style: {
      clipPath: "url(#SVGID_00000129192551738431189190000014290977596911153030_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033348966364532386520000017632139083848950416_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs164 || (_defs164 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000181803261863874113450000001546954259921147324_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs165 || (_defs165 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000076586839622598093420000015826954117483918520_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs166 || (_defs166 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000107567833888326961980000009727015552901180312_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000058569797588084781010000007425150156614988723_",
    style: {
      clipPath: "url(#SVGID_00000181768744144153276020000013327966543607366543_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181803261863874113450000001546954259921147324_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128479981143748158770000017189381417585045401_",
    style: {
      clipPath: "url(#SVGID_00000058569797588084781010000007425150156614988723_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000076586839622598093420000015826954117483918520_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091732074635189746470000013142777313434659730_",
    style: {
      clipPath: "url(#SVGID_00000128479981143748158770000017189381417585045401_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107567833888326961980000009727015552901180312_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs167 || (_defs167 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000016776138827664145030000011693580806204819118_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs168 || (_defs168 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000002384094465480142220000013837806946076832176_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs169 || (_defs169 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000066477613064606625720000009301666825239885736_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs170 || (_defs170 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000054263116479284878500000010642971995184598174_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013880192703474668920000010401319780738832790_",
    style: {
      clipPath: "url(#SVGID_00000181768744144153276020000013327966543607366543_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016776138827664145030000011693580806204819118_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145770823451692753740000001282800465255713703_",
    style: {
      clipPath: "url(#SVGID_00000013880192703474668920000010401319780738832790_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000002384094465480142220000013837806946076832176_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056406930907460217970000018051342169972074430_",
    style: {
      clipPath: "url(#SVGID_00000145770823451692753740000001282800465255713703_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066477613064606625720000009301666825239885736_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155857160701926503160000014261994853541537200_",
    style: {
      clipPath: "url(#SVGID_00000056406930907460217970000018051342169972074430_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054263116479284878500000010642971995184598174_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs171 || (_defs171 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127026198406847381430000014237505034635703988_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs172 || (_defs172 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000111158777323659416550000017233635618737005747_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145049739056950021920000007528931721954045088_",
    style: {
      clipPath: "url(#SVGID_00000181768744144153276020000013327966543607366543_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127026198406847381430000014237505034635703988_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155861652856919303710000012610252902287459764_",
    style: {
      clipPath: "url(#SVGID_00000145049739056950021920000007528931721954045088_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111158777323659416550000017233635618737005747_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs173 || (_defs173 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000113342122994057130960000013137338716511357872_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs174 || (_defs174 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000144298958924942847480000012140535727332637605_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs175 || (_defs175 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000014608861343041708510000016947123816843686272_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168111805719563088330000002545083131392739499_",
    style: {
      clipPath: "url(#SVGID_00000181768744144153276020000013327966543607366543_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000113342122994057130960000013137338716511357872_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072990211705205033070000003660052512698346917_",
    style: {
      clipPath: "url(#SVGID_00000168111805719563088330000002545083131392739499_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000144298958924942847480000012140535727332637605_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000089539294378439498290000007856739296923240375_",
    style: {
      clipPath: "url(#SVGID_00000072990211705205033070000003660052512698346917_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014608861343041708510000016947123816843686272_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs176 || (_defs176 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000054986572007495297140000010217423837155209635_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs177 || (_defs177 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000125602883700168202990000001245830946171691144_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs178 || (_defs178 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000161604874546861626750000009436393616183410335_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs179 || (_defs179 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000069361967618238741430000001559150026217694140_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073699479574671157650000004488606353938171782_",
    style: {
      clipPath: "url(#SVGID_00000181768744144153276020000013327966543607366543_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054986572007495297140000010217423837155209635_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157309381150154051100000001744584389290752407_",
    style: {
      clipPath: "url(#SVGID_00000073699479574671157650000004488606353938171782_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000125602883700168202990000001245830946171691144_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101103249693275226750000005732206413179347103_",
    style: {
      clipPath: "url(#SVGID_00000157309381150154051100000001744584389290752407_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161604874546861626750000009436393616183410335_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180339000221992438540000011954186929484651436_",
    style: {
      clipPath: "url(#SVGID_00000101103249693275226750000005732206413179347103_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069361967618238741430000001559150026217694140_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs180 || (_defs180 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000167357163836888101420000005650850710445903258_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs181 || (_defs181 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000006709375021985658790000008306465374598365368_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs182 || (_defs182 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000174563642806746934580000008776572225637894063_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs183 || (_defs183 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096750151988973870270000006338710586637111985_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs184 || (_defs184 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096038010965206522990000008683503765543501200_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083065777555981200840000013058528755729416591_",
    style: {
      clipPath: "url(#SVGID_00000181768744144153276020000013327966543607366543_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167357163836888101420000005650850710445903258_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029007168187619884710000007940777940567296435_",
    style: {
      clipPath: "url(#SVGID_00000083065777555981200840000013058528755729416591_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006709375021985658790000008306465374598365368_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016796067892548581280000003171725470581655432_",
    style: {
      clipPath: "url(#SVGID_00000029007168187619884710000007940777940567296435_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174563642806746934580000008776572225637894063_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000136403249274675190790000000502715824406355589_",
    style: {
      clipPath: "url(#SVGID_00000016796067892548581280000003171725470581655432_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096750151988973870270000006338710586637111985_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005230590681428361120000007301786665703316107_",
    style: {
      clipPath: "url(#SVGID_00000136403249274675190790000000502715824406355589_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096038010965206522990000008683503765543501200_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs185 || (_defs185 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000070827421347159761730000018305022564430315192_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs186 || (_defs186 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000021120209974837845390000009276370313053725857_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs187 || (_defs187 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000142861395036871917200000007742470804714601607_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs188 || (_defs188 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000055694889538095913590000014597359283804338561_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs189 || (_defs189 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000153696679770160009820000007670440337131156131_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs190 || (_defs190 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000019648715031640885590000007345246512526743731_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039813757395089453070000008874548480227013795_",
    style: {
      clipPath: "url(#SVGID_00000181768744144153276020000013327966543607366543_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070827421347159761730000018305022564430315192_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163055975516548692360000010235217631694930079_",
    style: {
      clipPath: "url(#SVGID_00000039813757395089453070000008874548480227013795_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021120209974837845390000009276370313053725857_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178188881561316838830000011118273968343992988_",
    style: {
      clipPath: "url(#SVGID_00000163055975516548692360000010235217631694930079_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142861395036871917200000007742470804714601607_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080193562534691662930000004210347720348651923_",
    style: {
      clipPath: "url(#SVGID_00000178188881561316838830000011118273968343992988_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055694889538095913590000014597359283804338561_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140709151409267272730000008078676458530503867_",
    style: {
      clipPath: "url(#SVGID_00000080193562534691662930000004210347720348651923_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000153696679770160009820000007670440337131156131_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116207840457313403020000004164673963237685687_",
    style: {
      clipPath: "url(#SVGID_00000140709151409267272730000008078676458530503867_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019648715031640885590000007345246512526743731_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025424126312250940560000008765820131516606132_",
    gradientUnits: "userSpaceOnUse",
    x1: -283.7096,
    y1: 157.3732,
    x2: -327.8358,
    y2: 249.1705,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000116207840457313403020000004164673963237685687_)",
      fill: "url(#SVGID_00000025424126312250940560000008765820131516606132_)"
    },
    d: " M104.3,52.5c0,4.6-0.1,8.9-0.4,12.9c-1.3,18.2-5.1,28.5-5.1,28.5h-4.9c13.1-46.5-6.7-87.8-7-88.3 c0.2,0.3,11.1,13.3,15.6,31.8C103.7,42.1,104.3,47.1,104.3,52.5z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106829068410433639480000002629834395674073524_",
    gradientUnits: "userSpaceOnUse",
    x1: -283.7096,
    y1: 157.3732,
    x2: -327.8358,
    y2: 249.1705,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000181768744144153276020000013327966543607366543_)",
      mask: "url(#SVGID_00000156550305465845534640000001983637026585783710_)",
      fill: "url(#SVGID_00000106829068410433639480000002629834395674073524_)"
    },
    d: " M104.3,52.5c0,4.6-0.1,8.9-0.4,12.9c-1.3,18.2-5.1,28.5-5.1,28.5h-4.9c13.1-46.5-6.7-87.8-7-88.3 c0.2,0.3,11.1,13.3,15.6,31.8C103.7,42.1,104.3,47.1,104.3,52.5z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106845377221696020260000011432480246348532671_",
    gradientUnits: "userSpaceOnUse",
    x1: -283.9085,
    y1: 157.371,
    x2: -328.0347,
    y2: 249.1683,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000106845377221696020260000011432480246348532671_)",
      enableBackground: "new"
    },
    d: " M104.6,52.5c0,4.6-0.1,8.9-0.4,12.9c-1.3,18.2-5.1,28.5-5.1,28.5h-4.9c13.1-46.5-6.7-87.8-7-88.3c0.2,0.3,11.1,13.3,15.6,31.8 C103.8,42.1,104.6,47.1,104.6,52.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101802092899219541520000006326273674001325722_",
    gradientUnits: "userSpaceOnUse",
    x1: -560.4093,
    y1: -793.7906,
    x2: -560.4093,
    y2: -809.423,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000101802092899219541520000006326273674001325722_)"
    },
    points: "87.1,70.7 87.1,108.6  88.2,97.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009578072332964048650000001177969653814051474_",
    gradientUnits: "userSpaceOnUse",
    x1: -559.2093,
    y1: -810.1018,
    x2: -559.2093,
    y2: -798.0774,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000009578072332964048650000001177969653814051474_)"
    },
    points: "87.1,70.7 87.1,108.6  85.8,97.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs191 || (_defs191 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000111909547460404069510000005672867757548413084_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000084489701294727585860000007818631405578824370_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111909547460404069510000005672867757548413084_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs192 || (_defs192 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000011724010325482769750000001780532495591125659_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs193 || (_defs193 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000054962197686622378000000013922228702222416776_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000045602095323397539550000006236514230903624593_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011724010325482769750000001780532495591125659_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002371513448416613560000015728333244297795504_",
    style: {
      clipPath: "url(#SVGID_00000045602095323397539550000006236514230903624593_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054962197686622378000000013922228702222416776_",
    style: {
      overflow: "visible"
    }
  })), _defs194 || (_defs194 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000119117264277140409940000011467548890608832188_",
    filterUnits: "userSpaceOnUse",
    x: 79,
    y: 44.6,
    width: 15.2,
    height: 15.2
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 44.6,
    width: 15.2,
    height: 15.2,
    id: "SVGID_00000153681912159676113710000007698021000927925658_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000119117264277140409940000011467548890608832188_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs195 || (_defs195 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096055112715387252270000011938733749508184204_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs196 || (_defs196 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000005959675455232853670000014769797814609104032_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158016428497438112750000008085864903272522426_",
    style: {
      clipPath: "url(#SVGID_00000002371513448416613560000015728333244297795504_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096055112715387252270000011938733749508184204_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177452489944577374930000015269378542195425706_",
    style: {
      clipPath: "url(#SVGID_00000158016428497438112750000008085864903272522426_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005959675455232853670000014769797814609104032_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs197 || (_defs197 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000099623807470141824690000011169415114587816088_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs198 || (_defs198 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000044178883940748639700000016353366683337601943_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs199 || (_defs199 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000089548114144660674790000018133229365633396388_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000020391995868200441820000003618196652972069823_",
    style: {
      clipPath: "url(#SVGID_00000002371513448416613560000015728333244297795504_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099623807470141824690000011169415114587816088_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075842922853057766580000017495078666649997450_",
    style: {
      clipPath: "url(#SVGID_00000020391995868200441820000003618196652972069823_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044178883940748639700000016353366683337601943_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029764276541428008020000000910638527827395201_",
    style: {
      clipPath: "url(#SVGID_00000075842922853057766580000017495078666649997450_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089548114144660674790000018133229365633396388_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs200 || (_defs200 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000183957245353780904990000006492338038754542734_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs201 || (_defs201 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000060030063927377180260000000179945910247635332_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041279811559817312190000014387720695783344793_",
    style: {
      clipPath: "url(#SVGID_00000002371513448416613560000015728333244297795504_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183957245353780904990000006492338038754542734_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023988917813198195430000017594276771138262970_",
    style: {
      clipPath: "url(#SVGID_00000041279811559817312190000014387720695783344793_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060030063927377180260000000179945910247635332_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs202 || (_defs202 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000165918883210834773580000016361286931767612573_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs203 || (_defs203 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000029725565755724304110000015614196537257356961_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs204 || (_defs204 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000178172820941356975250000017323763424168848304_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000107546293363380666090000000368469325491554486_",
    style: {
      clipPath: "url(#SVGID_00000002371513448416613560000015728333244297795504_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165918883210834773580000016361286931767612573_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105400741974768978440000009795119467608359058_",
    style: {
      clipPath: "url(#SVGID_00000107546293363380666090000000368469325491554486_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029725565755724304110000015614196537257356961_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000143615085431039140250000012904764447325157804_",
    style: {
      clipPath: "url(#SVGID_00000105400741974768978440000009795119467608359058_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178172820941356975250000017323763424168848304_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs205 || (_defs205 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052818739144176334270000011027838040974248607_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs206 || (_defs206 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000113321661553503039110000014658780687722055305_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs207 || (_defs207 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000141415704690700377720000000403248141902596791_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs208 || (_defs208 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000147195881030939960610000008416936807836395966_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000045593459349354699890000012023598054924917428_",
    style: {
      clipPath: "url(#SVGID_00000002371513448416613560000015728333244297795504_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052818739144176334270000011027838040974248607_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176749092030812494220000017148612672590818703_",
    style: {
      clipPath: "url(#SVGID_00000045593459349354699890000012023598054924917428_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000113321661553503039110000014658780687722055305_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070822026573331079450000003133849857280996021_",
    style: {
      clipPath: "url(#SVGID_00000176749092030812494220000017148612672590818703_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000141415704690700377720000000403248141902596791_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150083734949002595400000014735851827389155763_",
    style: {
      clipPath: "url(#SVGID_00000070822026573331079450000003133849857280996021_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147195881030939960610000008416936807836395966_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs209 || (_defs209 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000090286828910772175260000004470446196822473092_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs210 || (_defs210 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000137127218054855023030000002929538235439349685_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032618501588464371840000012079396016604181694_",
    style: {
      clipPath: "url(#SVGID_00000002371513448416613560000015728333244297795504_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090286828910772175260000004470446196822473092_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103979119963444871080000010588132551978110338_",
    style: {
      clipPath: "url(#SVGID_00000032618501588464371840000012079396016604181694_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137127218054855023030000002929538235439349685_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs211 || (_defs211 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096040500348174509040000008502583566357991089_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs212 || (_defs212 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000082364007254657584270000014789149094590033816_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs213 || (_defs213 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155118723600104203870000003440668618862576308_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125601164141435013510000015787050008423911315_",
    style: {
      clipPath: "url(#SVGID_00000002371513448416613560000015728333244297795504_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096040500348174509040000008502583566357991089_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183943508268385528820000014870124421021309853_",
    style: {
      clipPath: "url(#SVGID_00000125601164141435013510000015787050008423911315_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000082364007254657584270000014789149094590033816_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176733926529093362310000004787840340648409264_",
    style: {
      clipPath: "url(#SVGID_00000183943508268385528820000014870124421021309853_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155118723600104203870000003440668618862576308_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs214 || (_defs214 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000178907787475719874090000015614001937317424262_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs215 || (_defs215 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052067502845698176000000011254502530348389771_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs216 || (_defs216 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000001626928526728952850000010020737968613723542_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs217 || (_defs217 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000138565397833774085070000005698917371772371585_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106146417810491984260000010056437441808045221_",
    style: {
      clipPath: "url(#SVGID_00000002371513448416613560000015728333244297795504_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178907787475719874090000015614001937317424262_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063620505891578551600000005436763728383695286_",
    style: {
      clipPath: "url(#SVGID_00000106146417810491984260000010056437441808045221_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052067502845698176000000011254502530348389771_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155128634054525433610000016014332644339051710_",
    style: {
      clipPath: "url(#SVGID_00000063620505891578551600000005436763728383695286_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000001626928526728952850000010020737968613723542_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083807931958662482990000006310957795191971227_",
    style: {
      clipPath: "url(#SVGID_00000155128634054525433610000016014332644339051710_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138565397833774085070000005698917371772371585_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs218 || (_defs218 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000039133798668671438660000012758462161602199726_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs219 || (_defs219 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000036954742558715485200000007155623234441583278_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs220 || (_defs220 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000143619737513715668080000000439213511191542454_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs221 || (_defs221 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000088132210127654487750000007889200667182951357_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs222 || (_defs222 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000177460155485687606780000010129215670492218502_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127766462508052605070000017176217049416471171_",
    style: {
      clipPath: "url(#SVGID_00000002371513448416613560000015728333244297795504_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039133798668671438660000012758462161602199726_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000087373734405996637340000015239260450484492952_",
    style: {
      clipPath: "url(#SVGID_00000127766462508052605070000017176217049416471171_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036954742558715485200000007155623234441583278_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000203016221781960440000007459749507525446063_",
    style: {
      clipPath: "url(#SVGID_00000087373734405996637340000015239260450484492952_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000143619737513715668080000000439213511191542454_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023975984476961134150000007058863070637461128_",
    style: {
      clipPath: "url(#SVGID_00000000203016221781960440000007459749507525446063_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088132210127654487750000007889200667182951357_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000141431441700454926940000007520496533922350245_",
    style: {
      clipPath: "url(#SVGID_00000023975984476961134150000007058863070637461128_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177460155485687606780000010129215670492218502_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs223 || (_defs223 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000020370875479237052150000000109138661911146160_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs224 || (_defs224 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127040779592854224680000017816256298368185243_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs225 || (_defs225 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000162325647589060541030000002487150818511038100_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs226 || (_defs226 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000010278937407011031080000004831626622115972786_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs227 || (_defs227 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000171692838577822305680000007911856680029195936_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs228 || (_defs228 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000167381716761236658640000010663611588453379460_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000933104753544030700000004237086767627600564_",
    style: {
      clipPath: "url(#SVGID_00000002371513448416613560000015728333244297795504_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020370875479237052150000000109138661911146160_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139286077098396358470000016387396590382834582_",
    style: {
      clipPath: "url(#SVGID_00000000933104753544030700000004237086767627600564_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127040779592854224680000017816256298368185243_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038410259091864342290000014751880598618434482_",
    style: {
      clipPath: "url(#SVGID_00000139286077098396358470000016387396590382834582_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000162325647589060541030000002487150818511038100_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101809319527498617420000011834986815411135136_",
    style: {
      clipPath: "url(#SVGID_00000038410259091864342290000014751880598618434482_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000010278937407011031080000004831626622115972786_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147212541439089724920000011219568373218897286_",
    style: {
      clipPath: "url(#SVGID_00000101809319527498617420000011834986815411135136_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171692838577822305680000007911856680029195936_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145745569731710001300000007621260106635891853_",
    style: {
      clipPath: "url(#SVGID_00000147212541439089724920000011219568373218897286_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167381716761236658640000010663611588453379460_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081622374011929612240000018310123546892269757_",
    gradientUnits: "userSpaceOnUse",
    x1: -279.5814,
    y1: 166.1556,
    x2: -319.689,
    y2: 192.8788,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000145745569731710001300000007621260106635891853_)",
      fill: "url(#SVGID_00000081622374011929612240000018310123546892269757_)"
    },
    cx: 86.6,
    cy: 52.2,
    r: 7.6
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070807008825571232650000016715340872335896707_",
    gradientUnits: "userSpaceOnUse",
    x1: -279.5814,
    y1: 166.1556,
    x2: -319.689,
    y2: 192.8788,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000002371513448416613560000015728333244297795504_)",
      mask: "url(#SVGID_00000153681912159676113710000007698021000927925658_)",
      fill: "url(#SVGID_00000070807008825571232650000016715340872335896707_)"
    },
    cx: 86.6,
    cy: 52.2,
    r: 7.6
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115515616804147205420000004154146509954801062_",
    gradientUnits: "userSpaceOnUse",
    x1: -279.5814,
    y1: 166.1556,
    x2: -319.689,
    y2: 192.8788,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000115515616804147205420000004154146509954801062_)"
    },
    cx: 86.6,
    cy: 52.2,
    r: 7.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097478321080349945810000000937397482643560893_",
    gradientUnits: "userSpaceOnUse",
    x1: -559.8093,
    y1: -754.0059,
    x2: -559.8093,
    y2: -765.2059,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#3A2317"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000097478321080349945810000000937397482643560893_)"
    },
    cx: 87.1,
    cy: 51.8,
    r: 7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027599045376260642660000003555702177486354583_",
    gradientUnits: "userSpaceOnUse",
    x1: -557.3572,
    y1: -765.0106,
    x2: -560.9645,
    y2: -759.3646,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#3A2317"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027599045376260642660000003555702177486354583_)"
    },
    d: "M82.1,51.7c0,2.8,2.3,5,5,5 c0.5,0,1-0.1,1.5-0.2c0.6-0.2,1.2-0.5,1.7-0.9c0.4-0.3,0.7-0.7,1-1.1c0.5-0.7,0.8-1.7,0.8-2.7c0-2.8-2.3-5-5-5 c-1,0-1.9,0.3-2.7,0.8c-0.4,0.3-0.8,0.6-1.1,1c-0.4,0.5-0.7,1-0.9,1.7C82.2,50.7,82.1,51.2,82.1,51.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs229 || (_defs229 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116196038374442077750000004317718616020784799_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000053509594767362184510000001699734898817657747_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116196038374442077750000004317718616020784799_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs230 || (_defs230 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000005954894363295106800000004291558805915541649_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs231 || (_defs231 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000025402643684672104590000002797373300567588272_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041275571975114055650000004266076737676074125_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005954894363295106800000004291558805915541649_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000123398817827190363820000011810029000067959726_",
    style: {
      clipPath: "url(#SVGID_00000041275571975114055650000004266076737676074125_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000025402643684672104590000002797373300567588272_",
    style: {
      overflow: "visible"
    }
  })), _defs232 || (_defs232 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000162326902695519623440000010952659819422374056_",
    filterUnits: "userSpaceOnUse",
    x: 84.3,
    y: 46.8,
    width: 7.7,
    height: 7.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 84.3,
    y: 46.8,
    width: 7.7,
    height: 7.7,
    id: "SVGID_00000098199997547800096570000018231079392689272997_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000162326902695519623440000010952659819422374056_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs233 || (_defs233 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127728804147447678390000014524323054960119207_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs234 || (_defs234 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000138542933835564250230000000232264776149688472_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067219295732173599130000014349701467250115469_",
    style: {
      clipPath: "url(#SVGID_00000123398817827190363820000011810029000067959726_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127728804147447678390000014524323054960119207_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011030315017885945440000008209715764243126187_",
    style: {
      clipPath: "url(#SVGID_00000067219295732173599130000014349701467250115469_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138542933835564250230000000232264776149688472_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs235 || (_defs235 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000095306891431570799490000003611928448136240791_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs236 || (_defs236 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000124155612116531846480000012111322419749474235_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs237 || (_defs237 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000153692347624577037410000000923744690454246058_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000097475345471175962990000005828169534444572338_",
    style: {
      clipPath: "url(#SVGID_00000123398817827190363820000011810029000067959726_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095306891431570799490000003611928448136240791_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036213783608063309540000000661026689196183443_",
    style: {
      clipPath: "url(#SVGID_00000097475345471175962990000005828169534444572338_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124155612116531846480000012111322419749474235_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060738205304462940340000013524431443692838312_",
    style: {
      clipPath: "url(#SVGID_00000036213783608063309540000000661026689196183443_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000153692347624577037410000000923744690454246058_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs238 || (_defs238 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000112620554583282870310000003436803877490167989_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs239 || (_defs239 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000023247775669490712990000005136205313872579969_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096752524543639200700000016056811070836664990_",
    style: {
      clipPath: "url(#SVGID_00000123398817827190363820000011810029000067959726_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000112620554583282870310000003436803877490167989_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071531303108884393020000015399430297295374488_",
    style: {
      clipPath: "url(#SVGID_00000096752524543639200700000016056811070836664990_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023247775669490712990000005136205313872579969_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs240 || (_defs240 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000106838836848598708080000009513861908326555789_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs241 || (_defs241 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000031179517853685684940000001651370620329805985_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs242 || (_defs242 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000058568265034719945030000017925279099595341736_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121991962259770239290000009182368323248981134_",
    style: {
      clipPath: "url(#SVGID_00000123398817827190363820000011810029000067959726_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106838836848598708080000009513861908326555789_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006677348635066006030000017098208781066671792_",
    style: {
      clipPath: "url(#SVGID_00000121991962259770239290000009182368323248981134_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031179517853685684940000001651370620329805985_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001624061311156926730000003828337393802536616_",
    style: {
      clipPath: "url(#SVGID_00000006677348635066006030000017098208781066671792_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058568265034719945030000017925279099595341736_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs243 || (_defs243 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000090984869651919235890000011948488831824846477_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs244 || (_defs244 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000094597854003424391760000011853052848267438214_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs245 || (_defs245 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000141421385770492545230000005995243267849020576_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs246 || (_defs246 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000020357757822573836380000009295402703954348443_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142864427800889379470000008899888438469020294_",
    style: {
      clipPath: "url(#SVGID_00000123398817827190363820000011810029000067959726_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090984869651919235890000011948488831824846477_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075884607415203501220000011786284368560116891_",
    style: {
      clipPath: "url(#SVGID_00000142864427800889379470000008899888438469020294_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094597854003424391760000011853052848267438214_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067930231867027940170000007274713258548214941_",
    style: {
      clipPath: "url(#SVGID_00000075884607415203501220000011786284368560116891_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000141421385770492545230000005995243267849020576_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114071587281180489040000012281483298747390095_",
    style: {
      clipPath: "url(#SVGID_00000067930231867027940170000007274713258548214941_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020357757822573836380000009295402703954348443_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs247 || (_defs247 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000028325003653860918220000009833409145982614957_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs248 || (_defs248 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000105404764895397384790000002619704714620058785_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000130646323825796873670000005154633532513105291_",
    style: {
      clipPath: "url(#SVGID_00000123398817827190363820000011810029000067959726_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000028325003653860918220000009833409145982614957_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096780033611794270140000001424231905247998369_",
    style: {
      clipPath: "url(#SVGID_00000130646323825796873670000005154633532513105291_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000105404764895397384790000002619704714620058785_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs249 || (_defs249 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000000918487377661476770000000771809219285328033_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs250 || (_defs250 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000137854186782528212600000001737953191288374422_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs251 || (_defs251 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000168111291401864161900000012943525831072962232_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075852443966289539040000010630482510973481856_",
    style: {
      clipPath: "url(#SVGID_00000123398817827190363820000011810029000067959726_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000918487377661476770000000771809219285328033_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005236581438726694010000003476069474081441442_",
    style: {
      clipPath: "url(#SVGID_00000075852443966289539040000010630482510973481856_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137854186782528212600000001737953191288374422_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014610290555378759050000012107044617689880989_",
    style: {
      clipPath: "url(#SVGID_00000005236581438726694010000003476069474081441442_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168111291401864161900000012943525831072962232_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs252 || (_defs252 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000026144009640796722920000014132753070483774110_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs253 || (_defs253 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000130631507285491820730000006478808432395408520_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs254 || (_defs254 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000125602246408746053420000005251666413794259617_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs255 || (_defs255 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000006703679761532253310000003978025158720150658_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000126311550391958355870000001342977889629294979_",
    style: {
      clipPath: "url(#SVGID_00000123398817827190363820000011810029000067959726_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026144009640796722920000014132753070483774110_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112611463759846617540000012867268636735648421_",
    style: {
      clipPath: "url(#SVGID_00000126311550391958355870000001342977889629294979_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130631507285491820730000006478808432395408520_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067917086934225804050000007809142822710430902_",
    style: {
      clipPath: "url(#SVGID_00000112611463759846617540000012867268636735648421_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000125602246408746053420000005251666413794259617_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171711086426766319080000013952288008206191017_",
    style: {
      clipPath: "url(#SVGID_00000067917086934225804050000007809142822710430902_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006703679761532253310000003978025158720150658_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs256 || (_defs256 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000034087618526728435450000006624460462719740349_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs257 || (_defs257 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000032621071767178134770000012957107004618027179_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs258 || (_defs258 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000147922578611873172620000016348074600785248187_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs259 || (_defs259 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000075140049025131049380000000977351495608898193_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs260 || (_defs260 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152985044057535974740000012876081508179219887_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121985247109580796380000012845645397655832216_",
    style: {
      clipPath: "url(#SVGID_00000123398817827190363820000011810029000067959726_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034087618526728435450000006624460462719740349_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096778753345852498450000004611932523000210617_",
    style: {
      clipPath: "url(#SVGID_00000121985247109580796380000012845645397655832216_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000032621071767178134770000012957107004618027179_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032606263372445443440000015316704900173627552_",
    style: {
      clipPath: "url(#SVGID_00000096778753345852498450000004611932523000210617_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147922578611873172620000016348074600785248187_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091698065950728995350000009161679950844177307_",
    style: {
      clipPath: "url(#SVGID_00000032606263372445443440000015316704900173627552_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075140049025131049380000000977351495608898193_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000017480398009939179000000013460435296573780106_",
    style: {
      clipPath: "url(#SVGID_00000091698065950728995350000009161679950844177307_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152985044057535974740000012876081508179219887_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs261 || (_defs261 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000183230851692657206730000014851316118680104611_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs262 || (_defs262 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000018945832421990459760000014338851296604180649_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs263 || (_defs263 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052093392417473306840000013381835575096528550_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs264 || (_defs264 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096038831522891506240000014800843061462307752_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs265 || (_defs265 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000142859171182551157430000000112171245830105771_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs266 || (_defs266 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000015345696600144888670000004328749493754589886_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038413591066039634180000002763216582381612721_",
    style: {
      clipPath: "url(#SVGID_00000123398817827190363820000011810029000067959726_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183230851692657206730000014851316118680104611_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139255737719541867950000009038236122598959489_",
    style: {
      clipPath: "url(#SVGID_00000038413591066039634180000002763216582381612721_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018945832421990459760000014338851296604180649_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080917210745885720780000003509703502824999061_",
    style: {
      clipPath: "url(#SVGID_00000139255737719541867950000009038236122598959489_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052093392417473306840000013381835575096528550_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114051471524746683750000015479026664896601018_",
    style: {
      clipPath: "url(#SVGID_00000080917210745885720780000003509703502824999061_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096038831522891506240000014800843061462307752_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132065678234311301750000003712651616201946029_",
    style: {
      clipPath: "url(#SVGID_00000114051471524746683750000015479026664896601018_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142859171182551157430000000112171245830105771_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000007425814611656246540000007444491340439681933_",
    style: {
      clipPath: "url(#SVGID_00000132065678234311301750000003712651616201946029_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000015345696600144888670000004328749493754589886_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075134582992568077440000017179522150968904613_",
    gradientUnits: "userSpaceOnUse",
    x1: -280.2714,
    y1: 177.446,
    x2: -307.407,
    y2: 153.5496,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000007425814611656246540000007444491340439681933_)",
      fill: "url(#SVGID_00000075134582992568077440000017179522150968904613_)"
    },
    d: " M84.3,47.6l6.9,6.9c0.5-0.7,0.8-1.7,0.8-2.7c0-2.8-2.3-5-5-5C86.1,46.8,85.2,47.1,84.3,47.6z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114074536720751441260000016942276474408358548_",
    gradientUnits: "userSpaceOnUse",
    x1: -280.2714,
    y1: 177.446,
    x2: -307.407,
    y2: 153.5496,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000123398817827190363820000011810029000067959726_)",
      mask: "url(#SVGID_00000098199997547800096570000018231079392689272997_)",
      fill: "url(#SVGID_00000114074536720751441260000016942276474408358548_)"
    },
    d: " M84.3,47.6l6.9,6.9c0.5-0.7,0.8-1.7,0.8-2.7c0-2.8-2.3-5-5-5C86.1,46.8,85.2,47.1,84.3,47.6z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102510462481971226030000016982164209667971730_",
    gradientUnits: "userSpaceOnUse",
    x1: -280.2714,
    y1: 177.446,
    x2: -307.407,
    y2: 153.5496,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000102510462481971226030000016982164209667971730_)",
      enableBackground: "new"
    },
    d: " M84.3,47.6l6.9,6.9c0.5-0.7,0.8-1.7,0.8-2.7c0-2.8-2.3-5-5-5C86.1,46.8,85.2,47.1,84.3,47.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs267 || (_defs267 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000021091570713451821620000013508349720346449057_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049933627822323838020000012124510694357451421_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021091570713451821620000013508349720346449057_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs268 || (_defs268 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000009591765058098178930000013936380925968589724_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs269 || (_defs269 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000134227513057833204360000005450799875238601880_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105428151499801041850000005534410568718687412_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009591765058098178930000013936380925968589724_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070117301240599893190000009422341669120673929_",
    style: {
      clipPath: "url(#SVGID_00000105428151499801041850000005534410568718687412_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134227513057833204360000005450799875238601880_",
    style: {
      overflow: "visible"
    }
  })), _defs270 || (_defs270 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000150821341653753887530000006395801311767624115_",
    filterUnits: "userSpaceOnUse",
    x: 82.2,
    y: 48.6,
    width: 7.9,
    height: 7.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 82.2,
    y: 48.6,
    width: 7.9,
    height: 7.8,
    id: "SVGID_00000130613883181478670430000004946521245461151376_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000150821341653753887530000006395801311767624115_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs271 || (_defs271 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000101817653958151920680000005802462777852244117_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs272 || (_defs272 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000144325129608379457840000006243577293923902389_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109738329095788316870000016768025545817125282_",
    style: {
      clipPath: "url(#SVGID_00000070117301240599893190000009422341669120673929_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101817653958151920680000005802462777852244117_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000107547916846111790320000010960920967006760105_",
    style: {
      clipPath: "url(#SVGID_00000109738329095788316870000016768025545817125282_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000144325129608379457840000006243577293923902389_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs273 || (_defs273 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155848079654972214690000004149570551107358634_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs274 || (_defs274 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000168828329058462974270000017813032288962878086_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs275 || (_defs275 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000050632721513473615980000001900955459420087726_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110460243945060681070000003837206922291646392_",
    style: {
      clipPath: "url(#SVGID_00000070117301240599893190000009422341669120673929_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155848079654972214690000004149570551107358634_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030471636864777368400000011173202223153237689_",
    style: {
      clipPath: "url(#SVGID_00000110460243945060681070000003837206922291646392_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168828329058462974270000017813032288962878086_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111190536510817775760000007122453761567304630_",
    style: {
      clipPath: "url(#SVGID_00000030471636864777368400000011173202223153237689_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050632721513473615980000001900955459420087726_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs276 || (_defs276 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000135654755385778029560000005010474309496601769_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs277 || (_defs277 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000147187029833943365520000001663231824614203795_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041995802029622314950000017705283597586576314_",
    style: {
      clipPath: "url(#SVGID_00000070117301240599893190000009422341669120673929_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000135654755385778029560000005010474309496601769_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000045619298272741657800000003477931415745277368_",
    style: {
      clipPath: "url(#SVGID_00000041995802029622314950000017705283597586576314_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147187029833943365520000001663231824614203795_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs278 || (_defs278 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000007422221214473551220000015579381184759426232_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs279 || (_defs279 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000113336321799634989840000017341038228334011051_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs280 || (_defs280 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000099650063253929282240000008522602963702052239_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098192663749870952500000003125812963260893329_",
    style: {
      clipPath: "url(#SVGID_00000070117301240599893190000009422341669120673929_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000007422221214473551220000015579381184759426232_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103236407852627745590000003325801182064320130_",
    style: {
      clipPath: "url(#SVGID_00000098192663749870952500000003125812963260893329_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000113336321799634989840000017341038228334011051_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091712834645762589650000005640629763161778050_",
    style: {
      clipPath: "url(#SVGID_00000103236407852627745590000003325801182064320130_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099650063253929282240000008522602963702052239_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs281 || (_defs281 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116957017514312327750000001438114163559819955_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs282 || (_defs282 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000119075481285392110150000003208495132926862012_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs283 || (_defs283 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000134216347622660322440000014563477476926432164_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs284 || (_defs284 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000046304437649536818850000006199617378295255969_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072281759654113740320000016804711363317058203_",
    style: {
      clipPath: "url(#SVGID_00000070117301240599893190000009422341669120673929_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116957017514312327750000001438114163559819955_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106856752613978114270000005242444445964548498_",
    style: {
      clipPath: "url(#SVGID_00000072281759654113740320000016804711363317058203_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119075481285392110150000003208495132926862012_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075842305460458201580000006981802796227976884_",
    style: {
      clipPath: "url(#SVGID_00000106856752613978114270000005242444445964548498_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134216347622660322440000014563477476926432164_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176042021524750235640000017403029440249926830_",
    style: {
      clipPath: "url(#SVGID_00000075842305460458201580000006981802796227976884_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000046304437649536818850000006199617378295255969_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs285 || (_defs285 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000104691968838432251620000010337695745448825509_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs286 || (_defs286 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000069386175043669008140000002052399370261096358_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178182103667821966900000002775316756390455205_",
    style: {
      clipPath: "url(#SVGID_00000070117301240599893190000009422341669120673929_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000104691968838432251620000010337695745448825509_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000113353731245678284250000011586463551531687828_",
    style: {
      clipPath: "url(#SVGID_00000178182103667821966900000002775316756390455205_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069386175043669008140000002052399370261096358_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs287 || (_defs287 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000170999889208062705810000010770356966657564064_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs288 || (_defs288 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000005947516050635140040000014192069769900510613_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs289 || (_defs289 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000078734195898397813600000009369614266819061950_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120523539761003613450000008510906031066424999_",
    style: {
      clipPath: "url(#SVGID_00000070117301240599893190000009422341669120673929_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170999889208062705810000010770356966657564064_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000017498075092023008230000009832212062733306031_",
    style: {
      clipPath: "url(#SVGID_00000120523539761003613450000008510906031066424999_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005947516050635140040000014192069769900510613_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103222871843152480530000012911090653573325490_",
    style: {
      clipPath: "url(#SVGID_00000017498075092023008230000009832212062733306031_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078734195898397813600000009369614266819061950_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs290 || (_defs290 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000041979016739518895000000006495479353007098779_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs291 || (_defs291 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000015353190396514791640000011699537830334941093_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs292 || (_defs292 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000036243724117175944270000017201956311457673390_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs293 || (_defs293 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000175300301196644438500000004013910831303189382_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018220111496733821040000015515010533306805945_",
    style: {
      clipPath: "url(#SVGID_00000070117301240599893190000009422341669120673929_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041979016739518895000000006495479353007098779_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029037587784737645390000010246939156526749351_",
    style: {
      clipPath: "url(#SVGID_00000018220111496733821040000015515010533306805945_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000015353190396514791640000011699537830334941093_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163045990284586202610000009052271644397877144_",
    style: {
      clipPath: "url(#SVGID_00000029037587784737645390000010246939156526749351_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036243724117175944270000017201956311457673390_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104670419275382130350000010709403692076605829_",
    style: {
      clipPath: "url(#SVGID_00000163045990284586202610000009052271644397877144_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175300301196644438500000004013910831303189382_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs294 || (_defs294 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000150070512873891762180000000707090363575392429_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs295 || (_defs295 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116935431126452439610000010689457511388798380_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs296 || (_defs296 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000068653375317919336560000001691149276730161064_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs297 || (_defs297 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000137116794560801635800000005678781720993430155_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs298 || (_defs298 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000101080814349361919730000014323933989772693428_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083080708784101253030000012057769991662240407_",
    style: {
      clipPath: "url(#SVGID_00000070117301240599893190000009422341669120673929_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150070512873891762180000000707090363575392429_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157294678289457681810000007319931288303945379_",
    style: {
      clipPath: "url(#SVGID_00000083080708784101253030000012057769991662240407_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116935431126452439610000010689457511388798380_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151535492596769233880000009216351334029542049_",
    style: {
      clipPath: "url(#SVGID_00000157294678289457681810000007319931288303945379_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000068653375317919336560000001691149276730161064_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119083574590227966320000012625489330801755327_",
    style: {
      clipPath: "url(#SVGID_00000151535492596769233880000009216351334029542049_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137116794560801635800000005678781720993430155_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000095332376212666726300000011277718419598127242_",
    style: {
      clipPath: "url(#SVGID_00000119083574590227966320000012625489330801755327_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101080814349361919730000014323933989772693428_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs299 || (_defs299 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000057869108820943514220000007195579623961426364_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs300 || (_defs300 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096776910150289071200000017742011822034184340_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs301 || (_defs301 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000150818356474239920280000000863776693970673577_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs302 || (_defs302 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000077305939432827433340000005327338301319036860_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), _defs303 || (_defs303 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116927645386622073440000000711849038142528436_",
    points: "60.5,2.9 61,2.9 60.5,3.4  "
  }))), _defs304 || (_defs304 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000173153495094501527820000013060703512598102425_",
    points: "59.3,1.8 58.8,1.8 59.3,1.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078014270649473749780000008310328673908392126_",
    style: {
      clipPath: "url(#SVGID_00000070117301240599893190000009422341669120673929_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057869108820943514220000007195579623961426364_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168827631538117412230000014970868668348314287_",
    style: {
      clipPath: "url(#SVGID_00000078014270649473749780000008310328673908392126_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096776910150289071200000017742011822034184340_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000133527553276497209300000016692037998661803452_",
    style: {
      clipPath: "url(#SVGID_00000168827631538117412230000014970868668348314287_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150818356474239920280000000863776693970673577_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139286863471151023540000000689968990322039985_",
    style: {
      clipPath: "url(#SVGID_00000133527553276497209300000016692037998661803452_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077305939432827433340000005327338301319036860_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000097484000511777825400000007252711425416584091_",
    style: {
      clipPath: "url(#SVGID_00000139286863471151023540000000689968990322039985_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116927645386622073440000000711849038142528436_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003071084850004997540000007374267527553537416_",
    style: {
      clipPath: "url(#SVGID_00000097484000511777825400000007252711425416584091_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173153495094501527820000013060703512598102425_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116924537261074264000000017890568084601668486_",
    gradientUnits: "userSpaceOnUse",
    x1: -284.5926,
    y1: 175.2752,
    x2: -282.3924,
    y2: 153.9455,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000003071084850004997540000007374267527553537416_)",
      fill: "url(#SVGID_00000116924537261074264000000017890568084601668486_)"
    },
    d: " M82.2,50.2l6.2,6.2c0.6-0.2,1.2-0.5,1.7-0.9l-7-6.9C82.8,49.1,82.4,49.7,82.2,50.2z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142884588626585188390000002485616716234016918_",
    gradientUnits: "userSpaceOnUse",
    x1: -284.5926,
    y1: 175.2752,
    x2: -282.3924,
    y2: 153.9455,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000070117301240599893190000009422341669120673929_)",
      mask: "url(#SVGID_00000130613883181478670430000004946521245461151376_)",
      fill: "url(#SVGID_00000142884588626585188390000002485616716234016918_)"
    },
    d: " M82.2,50.2l6.2,6.2c0.6-0.2,1.2-0.5,1.7-0.9l-7-6.9C82.8,49.1,82.4,49.7,82.2,50.2z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023969953532455207120000003452840816865821578_",
    gradientUnits: "userSpaceOnUse",
    x1: -284.5926,
    y1: 175.2752,
    x2: -282.3924,
    y2: 153.9455,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000023969953532455207120000003452840816865821578_)",
      enableBackground: "new"
    },
    d: " M82.2,50.2l6.2,6.2c0.6-0.2,1.2-0.5,1.7-0.9l-7-6.9C82.8,49.1,82.4,49.7,82.2,50.2z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011745155688377837010000015544842891011590543_",
    gradientUnits: "userSpaceOnUse",
    x1: -521.9324,
    y1: -952.0424,
    x2: -521.9324,
    y2: -892.2373,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00193075,
    style: {
      stopColor: "#F9EF8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5A017"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011745155688377837010000015544842891011590543_)"
    },
    d: "M60.2,182.1c0,0,4.4,24.2-11.3,60.7 c0,0-14-23.1-11-60.7H60.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000116197537300929691820000001263571877384721291_",
    cx: -230.4561,
    cy: 172.3703,
    r: 0,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    style: {
      stopColor: "#FE7316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14161C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116197537300929691820000001263571877384721291_)"
    },
    d: "M32.7,49.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047058228062547299580000004311424944705200546_",
    gradientUnits: "userSpaceOnUse",
    x1: -554.2593,
    y1: -840.354,
    x2: -554.2593,
    y2: -895.5669,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000047058228062547299580000004311424944705200546_)"
    },
    points: "68.6,167.2 94.4,189.4  84.3,134.1 75.2,129.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183218347131354292240000018068374677413505448_",
    gradientUnits: "userSpaceOnUse",
    x1: -489.3593,
    y1: -840.354,
    x2: -489.3593,
    y2: -895.5669,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000183218347131354292240000018068374677413505448_)"
    },
    points: "29.5,167.2 3.6,189.4  13.7,134.1 22.9,129.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs305 || (_defs305 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013894023668320655890000004409245643623828904_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030487860897504517350000011569093417236928926_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013894023668320655890000004409245643623828904_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs306 || (_defs306 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000005975227176059605870000017198772677196087433_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs307 || (_defs307 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000018955971634371546790000005588843243599676842_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044873431859103689220000006195630401172356010_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005975227176059605870000017198772677196087433_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054253486563997179530000003117951692690115204_",
    style: {
      clipPath: "url(#SVGID_00000044873431859103689220000006195630401172356010_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018955971634371546790000005588843243599676842_",
    style: {
      overflow: "visible"
    }
  })), _defs308 || (_defs308 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000069360958406306152800000012752947132305836700_",
    filterUnits: "userSpaceOnUse",
    x: 12.6,
    y: 131.4,
    width: 14.3,
    height: 50.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 12.6,
    y: 131.4,
    width: 14.3,
    height: 50.3,
    id: "SVGID_00000002369941424631335940000013350243553805384086_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000069360958406306152800000012752947132305836700_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs309 || (_defs309 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000176761411681646056440000011496738278960867774_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs310 || (_defs310 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098187970233809744360000011072630238688566415_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000082352110198268608150000000981571209983694487_",
    style: {
      clipPath: "url(#SVGID_00000054253486563997179530000003117951692690115204_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176761411681646056440000011496738278960867774_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103985003077043867290000017029296159007686815_",
    style: {
      clipPath: "url(#SVGID_00000082352110198268608150000000981571209983694487_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098187970233809744360000011072630238688566415_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs311 || (_defs311 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000170973100443114634500000007340967956488108725_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs312 || (_defs312 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000122691549237252242820000010776170493138944424_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs313 || (_defs313 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000160175564808402821490000012245426869393988277_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000169517089856175979370000007748298421203674254_",
    style: {
      clipPath: "url(#SVGID_00000054253486563997179530000003117951692690115204_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170973100443114634500000007340967956488108725_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158000913813553185420000017246068190657097918_",
    style: {
      clipPath: "url(#SVGID_00000169517089856175979370000007748298421203674254_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000122691549237252242820000010776170493138944424_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111163602744677748320000017173777905141274804_",
    style: {
      clipPath: "url(#SVGID_00000158000913813553185420000017246068190657097918_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160175564808402821490000012245426869393988277_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs314 || (_defs314 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000065073442661364184040000016160787692548948867_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs315 || (_defs315 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000006695854351567340130000012004023003256852102_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067223431272549001070000017865640214569428157_",
    style: {
      clipPath: "url(#SVGID_00000054253486563997179530000003117951692690115204_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065073442661364184040000016160787692548948867_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016779276831636197010000017481255908950950301_",
    style: {
      clipPath: "url(#SVGID_00000067223431272549001070000017865640214569428157_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006695854351567340130000012004023003256852102_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs316 || (_defs316 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000141443749452128108610000007959384466306021292_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs317 || (_defs317 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000137837168079590841580000017596943999874084225_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs318 || (_defs318 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000147932290696559846010000004864337885719195805_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106829709698848771740000007515444509213845175_",
    style: {
      clipPath: "url(#SVGID_00000054253486563997179530000003117951692690115204_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000141443749452128108610000007959384466306021292_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034061197944033119590000007887546615779460226_",
    style: {
      clipPath: "url(#SVGID_00000106829709698848771740000007515444509213845175_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137837168079590841580000017596943999874084225_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083777266357348401050000012419817826746313115_",
    style: {
      clipPath: "url(#SVGID_00000034061197944033119590000007887546615779460226_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147932290696559846010000004864337885719195805_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs319 || (_defs319 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000026127834685329811990000013789023898888567941_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs320 || (_defs320 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000082340791095544058350000012399830847026457235_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs321 || (_defs321 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000104690354843820876810000010007573971102535078_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs322 || (_defs322 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000065774336733638578270000016560829084915445183_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115474311120282749410000017455685990215720602_",
    style: {
      clipPath: "url(#SVGID_00000054253486563997179530000003117951692690115204_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026127834685329811990000013789023898888567941_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075123804114405954170000014072411602455471788_",
    style: {
      clipPath: "url(#SVGID_00000115474311120282749410000017455685990215720602_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000082340791095544058350000012399830847026457235_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000126318045382180378330000017519325688148585393_",
    style: {
      clipPath: "url(#SVGID_00000075123804114405954170000014072411602455471788_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000104690354843820876810000010007573971102535078_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008827628293973210350000015487450037610684579_",
    style: {
      clipPath: "url(#SVGID_00000126318045382180378330000017519325688148585393_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065774336733638578270000016560829084915445183_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs323 || (_defs323 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000067210052952701642220000001332826328912379782_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs324 || (_defs324 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000175296449849767944000000015850595086644826277_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039835025294499766420000008646918441978619061_",
    style: {
      clipPath: "url(#SVGID_00000054253486563997179530000003117951692690115204_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067210052952701642220000001332826328912379782_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044151739736608430550000017411670597589585309_",
    style: {
      clipPath: "url(#SVGID_00000039835025294499766420000008646918441978619061_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175296449849767944000000015850595086644826277_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs325 || (_defs325 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000021088040970618812870000007429325519289976448_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs326 || (_defs326 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096766255562976939610000003166009065588394416_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs327 || (_defs327 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000177477889459902097750000012853664998367396756_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000166647876061152951120000001963263659195673777_",
    style: {
      clipPath: "url(#SVGID_00000054253486563997179530000003117951692690115204_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021088040970618812870000007429325519289976448_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000097476132799499760870000004497550685804380046_",
    style: {
      clipPath: "url(#SVGID_00000166647876061152951120000001963263659195673777_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096766255562976939610000003166009065588394416_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180330614935931146320000017327932867403411102_",
    style: {
      clipPath: "url(#SVGID_00000097476132799499760870000004497550685804380046_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177477889459902097750000012853664998367396756_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs328 || (_defs328 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116937424877311493510000003556529149647463560_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs329 || (_defs329 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000170250474574573275510000018012236383398509738_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs330 || (_defs330 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000121959411728297237110000004449960688033706139_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs331 || (_defs331 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000072239988039624659990000014758889768549919934_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047060124109504891310000012672840883910715575_",
    style: {
      clipPath: "url(#SVGID_00000054253486563997179530000003117951692690115204_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116937424877311493510000003556529149647463560_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170992715577688858090000004183285728274722489_",
    style: {
      clipPath: "url(#SVGID_00000047060124109504891310000012672840883910715575_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170250474574573275510000018012236383398509738_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029732736245082624270000017875926405821533070_",
    style: {
      clipPath: "url(#SVGID_00000170992715577688858090000004183285728274722489_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121959411728297237110000004449960688033706139_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132083731093038415150000001947178736813063304_",
    style: {
      clipPath: "url(#SVGID_00000029732736245082624270000017875926405821533070_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072239988039624659990000014758889768549919934_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs332 || (_defs332 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000018955127336106786830000002339429252166686900_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs333 || (_defs333 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000074436684015855548440000017464855038876847799_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs334 || (_defs334 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000064328934433239821170000009716346664041054377_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs335 || (_defs335 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000021085347966252817390000018400243654526004353_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs336 || (_defs336 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000107549713732964187120000011900885395187875516_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011739900723121573820000004503487920767763133_",
    style: {
      clipPath: "url(#SVGID_00000054253486563997179530000003117951692690115204_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018955127336106786830000002339429252166686900_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161604077137828147930000001057235797848433843_",
    style: {
      clipPath: "url(#SVGID_00000011739900723121573820000004503487920767763133_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000074436684015855548440000017464855038876847799_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119814780187406519220000010680260917622559410_",
    style: {
      clipPath: "url(#SVGID_00000161604077137828147930000001057235797848433843_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000064328934433239821170000009716346664041054377_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104665775561029989210000018042295547436296877_",
    style: {
      clipPath: "url(#SVGID_00000119814780187406519220000010680260917622559410_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021085347966252817390000018400243654526004353_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124867309199104580510000010640750262770444674_",
    style: {
      clipPath: "url(#SVGID_00000104665775561029989210000018042295547436296877_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107549713732964187120000011900885395187875516_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs337 || (_defs337 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000163768717606614525700000016175664655971530381_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs338 || (_defs338 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000175319918938594451200000016496471682234871941_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs339 || (_defs339 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000122715692522330628270000002756712985525304490_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs340 || (_defs340 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000123439491718641991050000007212845991681265038_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs341 || (_defs341 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000035498744361447544360000010642453084823394696_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs342 || (_defs342 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000090295284311272526660000004115359643501087136_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140729424411815626630000011936920645948167082_",
    style: {
      clipPath: "url(#SVGID_00000054253486563997179530000003117951692690115204_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163768717606614525700000016175664655971530381_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000156548519351252748930000000842966538771196601_",
    style: {
      clipPath: "url(#SVGID_00000140729424411815626630000011936920645948167082_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175319918938594451200000016496471682234871941_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182498970839571509260000009731835654852959888_",
    style: {
      clipPath: "url(#SVGID_00000156548519351252748930000000842966538771196601_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000122715692522330628270000002756712985525304490_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116213472809368576330000004791960011695850428_",
    style: {
      clipPath: "url(#SVGID_00000182498970839571509260000009731835654852959888_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123439491718641991050000007212845991681265038_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000058587364608532067410000010087469181342843055_",
    style: {
      clipPath: "url(#SVGID_00000116213472809368576330000004791960011695850428_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035498744361447544360000010642453084823394696_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155123912033402240470000006680646122613676721_",
    style: {
      clipPath: "url(#SVGID_00000058587364608532067410000010087469181342843055_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090295284311272526660000004115359643501087136_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077298701395143850490000003865669923080637582_",
    gradientUnits: "userSpaceOnUse",
    x1: -204.008,
    y1: 62.2349,
    x2: -266.0348,
    y2: 79.5888,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000155123912033402240470000006680646122613676721_)",
      fill: "url(#SVGID_00000077298701395143850490000003865669923080637582_)"
    },
    points: " 19.1,131.4 17,132.5 12.6,181.7 27,169.5  "
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052813034281814095470000005350156843788246716_",
    gradientUnits: "userSpaceOnUse",
    x1: -204.008,
    y1: 62.2349,
    x2: -266.0348,
    y2: 79.5888,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000054253486563997179530000003117951692690115204_)",
      mask: "url(#SVGID_00000002369941424631335940000013350243553805384086_)",
      fill: "url(#SVGID_00000052813034281814095470000005350156843788246716_)"
    },
    points: " 19.1,131.4 17,132.5 12.6,181.7 27,169.5  "
  }))))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "19.1,131.4 17,132.5 12.6,181.7 27,169.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs343 || (_defs343 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000044178238900113981520000013069860194368744073_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120551866217306879670000006459206264401427618_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044178238900113981520000013069860194368744073_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs344 || (_defs344 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000025440765763488262490000013589040502273652097_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs345 || (_defs345 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013164712568471163920000017773737138539955637_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067225234572034743860000012255075602481470128_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000025440765763488262490000013589040502273652097_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054969713739372275190000007275459412298680201_",
    style: {
      clipPath: "url(#SVGID_00000067225234572034743860000012255075602481470128_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013164712568471163920000017773737138539955637_",
    style: {
      overflow: "visible"
    }
  })), _defs346 || (_defs346 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000026154336567135817640000012226431501072206469_",
    filterUnits: "userSpaceOnUse",
    x: 71.1,
    y: 131.4,
    width: 14.3,
    height: 50.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 71.1,
    y: 131.4,
    width: 14.3,
    height: 50.3,
    id: "SVGID_00000048481163058850548400000004791441506120399253_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000026154336567135817640000012226431501072206469_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs347 || (_defs347 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000090989192322325427170000008427892697926635921_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs348 || (_defs348 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000148633073797814924630000000890677036192063127_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090994889091145324390000011492526276825099942_",
    style: {
      clipPath: "url(#SVGID_00000054969713739372275190000007275459412298680201_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090989192322325427170000008427892697926635921_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070108336940432170440000016499016268083726994_",
    style: {
      clipPath: "url(#SVGID_00000090994889091145324390000011492526276825099942_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148633073797814924630000000890677036192063127_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs349 || (_defs349 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000065075871038643609100000007256385007141208983_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs350 || (_defs350 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000153676616214391571420000016854172679468948923_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs351 || (_defs351 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000174567884381492275790000002133634248992331912_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165205686879864782370000002381175093412851081_",
    style: {
      clipPath: "url(#SVGID_00000054969713739372275190000007275459412298680201_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065075871038643609100000007256385007141208983_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057835752758290310940000010386417003804313474_",
    style: {
      clipPath: "url(#SVGID_00000165205686879864782370000002381175093412851081_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000153676616214391571420000016854172679468948923_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052809958629127359860000011751869587431935654_",
    style: {
      clipPath: "url(#SVGID_00000057835752758290310940000010386417003804313474_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174567884381492275790000002133634248992331912_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs352 || (_defs352 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000090268963259090601700000013825741592885013943_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs353 || (_defs353 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000084519693326243588820000009657706169929275804_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023996755079493966000000012105080298132580030_",
    style: {
      clipPath: "url(#SVGID_00000054969713739372275190000007275459412298680201_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090268963259090601700000013825741592885013943_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065786623756882311450000008747219185449911724_",
    style: {
      clipPath: "url(#SVGID_00000023996755079493966000000012105080298132580030_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000084519693326243588820000009657706169929275804_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs354 || (_defs354 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000009567495502546269290000014611782154106363017_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs355 || (_defs355 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000139270488147804531450000017185191027280870817_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs356 || (_defs356 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000093860920920338391860000000615418559722598078_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054245650394805773530000008058039489904526726_",
    style: {
      clipPath: "url(#SVGID_00000054969713739372275190000007275459412298680201_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009567495502546269290000014611782154106363017_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021822634809665689660000005922760110312730806_",
    style: {
      clipPath: "url(#SVGID_00000054245650394805773530000008058039489904526726_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139270488147804531450000017185191027280870817_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142151703174407256600000016388133453230241416_",
    style: {
      clipPath: "url(#SVGID_00000021822634809665689660000005922760110312730806_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093860920920338391860000000615418559722598078_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs357 || (_defs357 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000051349086031050750580000011977994895103556238_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs358 || (_defs358 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152241789586551740320000009776413514043295159_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs359 || (_defs359 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000183947274698709546540000010116483089344415419_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs360 || (_defs360 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098938831680110176420000016512108903688879266_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090267020587543964860000002839405246059971759_",
    style: {
      clipPath: "url(#SVGID_00000054969713739372275190000007275459412298680201_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000051349086031050750580000011977994895103556238_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011012201932695881690000011719581121354526636_",
    style: {
      clipPath: "url(#SVGID_00000090267020587543964860000002839405246059971759_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152241789586551740320000009776413514043295159_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071517319258018721870000002667866962475451305_",
    style: {
      clipPath: "url(#SVGID_00000011012201932695881690000011719581121354526636_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183947274698709546540000010116483089344415419_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000126315128251073635810000012492224327278664584_",
    style: {
      clipPath: "url(#SVGID_00000071517319258018721870000002667866962475451305_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098938831680110176420000016512108903688879266_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs361 || (_defs361 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000037665081918468331940000016234839943021787071_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs362 || (_defs362 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152247172829609441530000008946551359706880171_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000037651614041441109800000015376110847346716094_",
    style: {
      clipPath: "url(#SVGID_00000054969713739372275190000007275459412298680201_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000037665081918468331940000016234839943021787071_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052793610428051855950000005974748239280354476_",
    style: {
      clipPath: "url(#SVGID_00000037651614041441109800000015376110847346716094_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152247172829609441530000008946551359706880171_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs363 || (_defs363 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000134239555902607619180000009247186176772098194_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs364 || (_defs364 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000117641477461755819980000001812359351875326097_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs365 || (_defs365 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000122680266719635255660000004240815019289423288_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176014803310638118470000003077061000347063706_",
    style: {
      clipPath: "url(#SVGID_00000054969713739372275190000007275459412298680201_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134239555902607619180000009247186176772098194_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062179639318739483500000013382546044370409097_",
    style: {
      clipPath: "url(#SVGID_00000176014803310638118470000003077061000347063706_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117641477461755819980000001812359351875326097_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070076389041910797370000004131945726152840847_",
    style: {
      clipPath: "url(#SVGID_00000062179639318739483500000013382546044370409097_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000122680266719635255660000004240815019289423288_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs366 || (_defs366 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000158007600475602709870000009768604426522749092_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs367 || (_defs367 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000142872283608588059280000015826706671902930362_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs368 || (_defs368 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000171719123570728424560000006883768342321079723_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs369 || (_defs369 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152975039655928309660000009306243324181837483_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010299059689865978270000018374905246468491155_",
    style: {
      clipPath: "url(#SVGID_00000054969713739372275190000007275459412298680201_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158007600475602709870000009768604426522749092_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148660117321854709020000012392076143374735499_",
    style: {
      clipPath: "url(#SVGID_00000010299059689865978270000018374905246468491155_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142872283608588059280000015826706671902930362_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003104587431585173270000009335631999488873905_",
    style: {
      clipPath: "url(#SVGID_00000148660117321854709020000012392076143374735499_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171719123570728424560000006883768342321079723_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003088055712162933170000001491920875470664124_",
    style: {
      clipPath: "url(#SVGID_00000003104587431585173270000009335631999488873905_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152975039655928309660000009306243324181837483_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs370 || (_defs370 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000054976533683563681310000013642149149689331619_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs371 || (_defs371 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000090291532778329819580000006028843639723824003_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs372 || (_defs372 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000010286347510301457050000013012538821139855497_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs373 || (_defs373 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098213052089141154010000000146867592407895198_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs374 || (_defs374 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000151542261600799864890000003128832167814454690_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149368335999440925960000000536901409495280257_",
    style: {
      clipPath: "url(#SVGID_00000054969713739372275190000007275459412298680201_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054976533683563681310000013642149149689331619_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120551375522655465510000007169635024113754512_",
    style: {
      clipPath: "url(#SVGID_00000149368335999440925960000000536901409495280257_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090291532778329819580000006028843639723824003_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085969974163089616980000000482507135367994247_",
    style: {
      clipPath: "url(#SVGID_00000120551375522655465510000007169635024113754512_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000010286347510301457050000013012538821139855497_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065766584958633692020000017411037575112274589_",
    style: {
      clipPath: "url(#SVGID_00000085969974163089616980000000482507135367994247_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098213052089141154010000000146867592407895198_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111885995167563129620000013526903046913406645_",
    style: {
      clipPath: "url(#SVGID_00000065766584958633692020000017411037575112274589_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151542261600799864890000003128832167814454690_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs375 || (_defs375 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000178904539644205184450000012848364804009371008_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs376 || (_defs376 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000062882486058727143950000003826541255155812268_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs377 || (_defs377 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000138557992186200936020000016861132065704319663_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs378 || (_defs378 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052807201740431550780000008883162248162920111_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs379 || (_defs379 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000104685566200010681180000002658433931950745477_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs380 || (_defs380 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000099633725319434240420000006443655491175518857_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125588364144999338480000010522534232457759380_",
    style: {
      clipPath: "url(#SVGID_00000054969713739372275190000007275459412298680201_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178904539644205184450000012848364804009371008_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111873784821530402550000015317614395373689278_",
    style: {
      clipPath: "url(#SVGID_00000125588364144999338480000010522534232457759380_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062882486058727143950000003826541255155812268_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052796787229202334160000011677406601225458589_",
    style: {
      clipPath: "url(#SVGID_00000111873784821530402550000015317614395373689278_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138557992186200936020000016861132065704319663_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106123677144939928970000018364988362373541034_",
    style: {
      clipPath: "url(#SVGID_00000052796787229202334160000011677406601225458589_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052807201740431550780000008883162248162920111_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005245122751932114350000017649937799968888978_",
    style: {
      clipPath: "url(#SVGID_00000106123677144939928970000018364988362373541034_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000104685566200010681180000002658433931950745477_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000164511822279805698840000007544171493778035840_",
    style: {
      clipPath: "url(#SVGID_00000005245122751932114350000017649937799968888978_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099633725319434240420000006443655491175518857_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016767597696962937420000013043677731111115168_",
    gradientUnits: "userSpaceOnUse",
    x1: -276.6336,
    y1: 56.4919,
    x2: -283.7889,
    y2: 160.9607,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000164511822279805698840000007544171493778035840_)",
      fill: "url(#SVGID_00000016767597696962937420000013043677731111115168_)"
    },
    points: " 78.8,131.4 80.9,132.5 85.3,181.7 71.1,169.5  "
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016056473511441174690000014951562089322163898_",
    gradientUnits: "userSpaceOnUse",
    x1: -276.6336,
    y1: 56.4919,
    x2: -283.7889,
    y2: 160.9607,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000054969713739372275190000007275459412298680201_)",
      mask: "url(#SVGID_00000048481163058850548400000004791441506120399253_)",
      fill: "url(#SVGID_00000016056473511441174690000014951562089322163898_)"
    },
    points: " 78.8,131.4 80.9,132.5 85.3,181.7 71.1,169.5  "
  }))))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "78.8,131.4 80.9,132.5 85.3,181.7 71.1,169.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065035565405693764310000003673769750077333658_",
    gradientUnits: "userSpaceOnUse",
    x1: -521.9093,
    y1: -889.0065,
    x2: -521.9093,
    y2: -881.2489,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000065035565405693764310000003673769750077333658_)"
    },
    points: "30.6,180.2 67.7,180.2  67.7,170.2 30.6,170.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs381 || (_defs381 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000129890244377765306920000016530707122026627714_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163754456988554137980000018330323521414622337_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129890244377765306920000016530707122026627714_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs382 || (_defs382 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000011747422003416378790000010215665942606894752_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs383 || (_defs383 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000082328686659554744000000009712010599242850215_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059286332921806986720000009432576718222651530_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011747422003416378790000010215665942606894752_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000164515188954030003030000017300346467309966520_",
    style: {
      clipPath: "url(#SVGID_00000059286332921806986720000009432576718222651530_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000082328686659554744000000009712010599242850215_",
    style: {
      overflow: "visible"
    }
  })), _defs384 || (_defs384 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000125587665317151511930000017194239615797576891_",
    filterUnits: "userSpaceOnUse",
    x: 30.6,
    y: 170.2,
    width: 37,
    height: 10
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 30.6,
    y: 170.2,
    width: 37,
    height: 10,
    id: "SVGID_00000128472331744325682430000005425003044528915878_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000125587665317151511930000017194239615797576891_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs385 || (_defs385 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000143587097328078975480000017077836517801954690_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs386 || (_defs386 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000178907682539333521610000017032564383040418193_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023271421380104237630000015210343243568557198_",
    style: {
      clipPath: "url(#SVGID_00000164515188954030003030000017300346467309966520_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000143587097328078975480000017077836517801954690_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096046193650927004050000005028589225836920465_",
    style: {
      clipPath: "url(#SVGID_00000023271421380104237630000015210343243568557198_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178907682539333521610000017032564383040418193_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs387 || (_defs387 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000012430434225328387950000014404136889352451761_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs388 || (_defs388 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000027564888058396273590000014146596761633404316_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs389 || (_defs389 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000151542212354613801280000005566535482060427963_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158740827390461808570000002001743870866618518_",
    style: {
      clipPath: "url(#SVGID_00000164515188954030003030000017300346467309966520_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000012430434225328387950000014404136889352451761_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033334944561542717580000004108906450327985305_",
    style: {
      clipPath: "url(#SVGID_00000158740827390461808570000002001743870866618518_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000027564888058396273590000014146596761633404316_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002362999173649353630000002442038234253263757_",
    style: {
      clipPath: "url(#SVGID_00000033334944561542717580000004108906450327985305_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151542212354613801280000005566535482060427963_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs390 || (_defs390 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000146473973681055124200000018139212831721972877_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs391 || (_defs391 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000164479669279578436560000004447558299701369021_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028319397457878805590000015666343257998270366_",
    style: {
      clipPath: "url(#SVGID_00000164515188954030003030000017300346467309966520_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146473973681055124200000018139212831721972877_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065794351551592991550000005537431243753347495_",
    style: {
      clipPath: "url(#SVGID_00000028319397457878805590000015666343257998270366_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000164479669279578436560000004447558299701369021_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs392 || (_defs392 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000083064552836044818930000006329065506012427196_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs393 || (_defs393 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000158718250394411028720000013616061148872220824_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs394 || (_defs394 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000006706579865727170200000003447732818124921498_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041293831600325247140000006804404395526881978_",
    style: {
      clipPath: "url(#SVGID_00000164515188954030003030000017300346467309966520_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083064552836044818930000006329065506012427196_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103959396240200133150000015586804771754444425_",
    style: {
      clipPath: "url(#SVGID_00000041293831600325247140000006804404395526881978_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158718250394411028720000013616061148872220824_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119840292787405741420000018245883611646179774_",
    style: {
      clipPath: "url(#SVGID_00000103959396240200133150000015586804771754444425_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006706579865727170200000003447732818124921498_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs395 || (_defs395 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000066492602591719451930000002004300005841306755_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs396 || (_defs396 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000047782928510324279150000003725916578799473817_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs397 || (_defs397 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000162327819011421628950000008538856496736062903_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs398 || (_defs398 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000125565297948020654790000007285212548869882759_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112615964020722471360000011011864600933893810_",
    style: {
      clipPath: "url(#SVGID_00000164515188954030003030000017300346467309966520_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066492602591719451930000002004300005841306755_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028318900852516605120000015035818626382695065_",
    style: {
      clipPath: "url(#SVGID_00000112615964020722471360000011011864600933893810_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047782928510324279150000003725916578799473817_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000007414407942751857410000006350281868456940471_",
    style: {
      clipPath: "url(#SVGID_00000028318900852516605120000015035818626382695065_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000162327819011421628950000008538856496736062903_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093144613196928327670000007902684544477934983_",
    style: {
      clipPath: "url(#SVGID_00000007414407942751857410000006350281868456940471_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000125565297948020654790000007285212548869882759_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs399 || (_defs399 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000041978329167168219930000008314799508514407102_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs400 || (_defs400 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000001628037541429966600000016645503339707821960_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003812919938597623380000011475212781927466666_",
    style: {
      clipPath: "url(#SVGID_00000164515188954030003030000017300346467309966520_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041978329167168219930000008314799508514407102_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137109163965789156060000009688913466680192951_",
    style: {
      clipPath: "url(#SVGID_00000003812919938597623380000011475212781927466666_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000001628037541429966600000016645503339707821960_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs401 || (_defs401 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000107574717614754927110000000036499736339472527_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs402 || (_defs402 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000126281827541257769570000000636298229902280617_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs403 || (_defs403 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000000189062441536095130000008298043240557676202_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158010367392848453490000009856811980979572895_",
    style: {
      clipPath: "url(#SVGID_00000164515188954030003030000017300346467309966520_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107574717614754927110000000036499736339472527_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065757934380186508860000012343372521004600977_",
    style: {
      clipPath: "url(#SVGID_00000158010367392848453490000009856811980979572895_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000126281827541257769570000000636298229902280617_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120538863056140519170000006365658834089187204_",
    style: {
      clipPath: "url(#SVGID_00000065757934380186508860000012343372521004600977_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000189062441536095130000008298043240557676202_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs404 || (_defs404 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000177453000037835617990000009031648053340659587_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs405 || (_defs405 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152943443234965600460000009561510287769235632_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs406 || (_defs406 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155139876435100658510000013804455166674408071_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs407 || (_defs407 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000083053324631712422890000004927408258530318475_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085973661912998791640000002975467003485926792_",
    style: {
      clipPath: "url(#SVGID_00000164515188954030003030000017300346467309966520_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177453000037835617990000009031648053340659587_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181791756885502228220000016948631749499407029_",
    style: {
      clipPath: "url(#SVGID_00000085973661912998791640000002975467003485926792_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152943443234965600460000009561510287769235632_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078036209126008349300000013278993480758980233_",
    style: {
      clipPath: "url(#SVGID_00000181791756885502228220000016948631749499407029_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155139876435100658510000013804455166674408071_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014604415181371492550000005370712415863186835_",
    style: {
      clipPath: "url(#SVGID_00000078036209126008349300000013278993480758980233_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083053324631712422890000004927408258530318475_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs408 || (_defs408 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000182504249039454139980000000874663140339632056_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs409 || (_defs409 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000158745349373015644680000010403370194952634550_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs410 || (_defs410 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000107550920662871454970000016409165745136792213_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs411 || (_defs411 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000049918560398736785330000009448226091934445979_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs412 || (_defs412 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000159459740041202659690000017526139077089685936_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125569217793783460570000001532139232229936301_",
    style: {
      clipPath: "url(#SVGID_00000164515188954030003030000017300346467309966520_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000182504249039454139980000000874663140339632056_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139254820360570348650000009793184217153456006_",
    style: {
      clipPath: "url(#SVGID_00000125569217793783460570000001532139232229936301_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158745349373015644680000010403370194952634550_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121261481278698454950000008760251195357960879_",
    style: {
      clipPath: "url(#SVGID_00000139254820360570348650000009793184217153456006_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107550920662871454970000016409165745136792213_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183961068479828485560000011613323841503904164_",
    style: {
      clipPath: "url(#SVGID_00000121261481278698454950000008760251195357960879_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049918560398736785330000009448226091934445979_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032621014779923877200000009829972710595147668_",
    style: {
      clipPath: "url(#SVGID_00000183961068479828485560000011613323841503904164_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000159459740041202659690000017526139077089685936_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs413 || (_defs413 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000118376410368734435950000012758355511868720008_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs414 || (_defs414 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000148655589935825768570000000148038544826243239_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs415 || (_defs415 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000050648837386719328780000007198687894355323530_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs416 || (_defs416 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000058572595418085485610000017996113172101384835_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs417 || (_defs417 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000068657182684030831470000002974640574880400831_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs418 || (_defs418 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000016055648178025936610000012243729103698644877_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181078346975499028230000001324149854424485049_",
    style: {
      clipPath: "url(#SVGID_00000164515188954030003030000017300346467309966520_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118376410368734435950000012758355511868720008_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181766330742792958770000012042879303749159102_",
    style: {
      clipPath: "url(#SVGID_00000181078346975499028230000001324149854424485049_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148655589935825768570000000148038544826243239_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083806785411440596670000000225576420780502700_",
    style: {
      clipPath: "url(#SVGID_00000181766330742792958770000012042879303749159102_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050648837386719328780000007198687894355323530_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013895647659762353400000014555330031861013384_",
    style: {
      clipPath: "url(#SVGID_00000083806785411440596670000000225576420780502700_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058572595418085485610000017996113172101384835_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120533855338653657740000001052300147899726013_",
    style: {
      clipPath: "url(#SVGID_00000013895647659762353400000014555330031861013384_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000068657182684030831470000002974640574880400831_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099657733598411057530000010766003994583039625_",
    style: {
      clipPath: "url(#SVGID_00000120533855338653657740000001052300147899726013_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016055648178025936610000012243729103698644877_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181784286035455531030000008258690308351777940_",
    gradientUnits: "userSpaceOnUse",
    x1: -246.3017,
    y1: 38.7085,
    x2: -249.9965,
    y2: 111.7636,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000099657733598411057530000010766003994583039625_)",
      fill: "url(#SVGID_00000181784286035455531030000008258690308351777940_)"
    },
    points: " 67.7,170.2 30.6,170.2 30.6,180.2 33.4,180.2 33.4,173.4 67.7,173.4  "
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004529720372026576570000014344492417633250181_",
    gradientUnits: "userSpaceOnUse",
    x1: -246.3017,
    y1: 38.7085,
    x2: -249.9965,
    y2: 111.7636,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000164515188954030003030000017300346467309966520_)",
      mask: "url(#SVGID_00000128472331744325682430000005425003044528915878_)",
      fill: "url(#SVGID_00000004529720372026576570000014344492417633250181_)"
    },
    points: " 67.7,170.2 30.6,170.2 30.6,180.2 33.4,180.2 33.4,173.4 67.7,173.4  "
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053505949524091355660000003407750680504970625_",
    gradientUnits: "userSpaceOnUse",
    x1: -246.3017,
    y1: 38.7085,
    x2: -249.9965,
    y2: 111.7636,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000053505949524091355660000003407750680504970625_)"
    },
    points: "67.7,170.2 30.6,170.2  30.6,180.2 33.4,180.2 33.4,173.4 67.7,173.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029743049209228780570000006584804561438532539_",
    gradientUnits: "userSpaceOnUse",
    x1: -537.6093,
    y1: -890.4886,
    x2: -506.0726,
    y2: -890.4886,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000029743049209228780570000006584804561438532539_)"
    },
    points: "33.4,182.1 64.8,182.1  64.8,180.2 33.4,180.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132770993325649740880000015412490592181298062_",
    gradientUnits: "userSpaceOnUse",
    x1: -521.8593,
    y1: -873.1083,
    x2: -521.8593,
    y2: -790.9031,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132770993325649740880000015412490592181298062_)"
    },
    d: "M20.4,66.7C28.5,32.9,48.6,9,49,8.5 l0,0l0,0c0,0,20.4,24.1,28.7,58.2c2.1,8.6,3.4,17.8,3.4,27.5c0,8.5-0.3,16.4-0.8,23.7c-2.4,33.4-9.3,52.3-9.3,52.3H49l0,0 H27.2c0,0-6.9-18.9-9.3-52.3c-0.5-7.2-0.8-15.1-0.8-23.7C17,84.6,18.4,75.3,20.4,66.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063600875178980337890000003006876883976594101_",
    gradientUnits: "userSpaceOnUse",
    x1: -212.6513,
    y1: 184.9117,
    x2: -304.9558,
    y2: 175.6095,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063600875178980337890000003006876883976594101_)"
    },
    d: "M20.5,66.7 c9.1,2.8,18.7,4.3,28.7,4.3s19.6-1.5,28.7-4.3C69.5,32.6,49,8.5,49,8.5S28.6,32.6,20.5,66.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs419 || (_defs419 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000044867577791946969520000016549528569278531004_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168095547281752652380000005874031740761180573_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044867577791946969520000016549528569278531004_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs420 || (_defs420 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000127749660384540473470000004033622089514825346_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs421 || (_defs421 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000050648120048474683770000013193356974053721487_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078741060313946250230000003243998015237107613_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127749660384540473470000004033622089514825346_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078755586527706025570000001391944886441707957_",
    style: {
      clipPath: "url(#SVGID_00000078741060313946250230000003243998015237107613_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050648120048474683770000013193356974053721487_",
    style: {
      overflow: "visible"
    }
  })), _defs422 || (_defs422 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000132075171442004574930000003646956640367241863_",
    filterUnits: "userSpaceOnUse",
    x: 17,
    y: 8.5,
    width: 32,
    height: 161.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 8.5,
    width: 32,
    height: 161.7,
    id: "SVGID_00000021104860421671030910000015996740854946434979_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000132075171442004574930000003646956640367241863_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs423 || (_defs423 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000048481003881270211680000003144529839584384400_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs424 || (_defs424 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000163074614537714618300000009967290058267429017_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181776028776513310350000016337776515957732235_",
    style: {
      clipPath: "url(#SVGID_00000078755586527706025570000001391944886441707957_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000048481003881270211680000003144529839584384400_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098928914229512024400000000328767813344503220_",
    style: {
      clipPath: "url(#SVGID_00000181776028776513310350000016337776515957732235_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163074614537714618300000009967290058267429017_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs425 || (_defs425 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000078030288223693507570000001643724974746525606_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs426 || (_defs426 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000147204435035773775910000015919676679101262227_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs427 || (_defs427 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000168819930190605802510000011633221613680505774_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013176114271479084030000016319154266758645140_",
    style: {
      clipPath: "url(#SVGID_00000078755586527706025570000001391944886441707957_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078030288223693507570000001643724974746525606_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081642864800574229420000008211054517349231251_",
    style: {
      clipPath: "url(#SVGID_00000013176114271479084030000016319154266758645140_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147204435035773775910000015919676679101262227_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174563077543576333440000008217933482495396483_",
    style: {
      clipPath: "url(#SVGID_00000081642864800574229420000008211054517349231251_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168819930190605802510000011633221613680505774_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs428 || (_defs428 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000134217151918810504690000001495581358739157899_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs429 || (_defs429 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000106837133608617235970000015013978007385612678_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016772915177287311970000008739324260398502579_",
    style: {
      clipPath: "url(#SVGID_00000078755586527706025570000001391944886441707957_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134217151918810504690000001495581358739157899_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148652210071544186750000005779900776093436823_",
    style: {
      clipPath: "url(#SVGID_00000016772915177287311970000008739324260398502579_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106837133608617235970000015013978007385612678_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs430 || (_defs430 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000117676364600884577100000014525013135954225823_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs431 || (_defs431 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000003097905384582057280000014588222472288501378_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs432 || (_defs432 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000059297996682362967830000003225341510024369542_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142878910579061522700000001676870080956453006_",
    style: {
      clipPath: "url(#SVGID_00000078755586527706025570000001391944886441707957_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117676364600884577100000014525013135954225823_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000082327840644148004620000010449046442410971812_",
    style: {
      clipPath: "url(#SVGID_00000142878910579061522700000001676870080956453006_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003097905384582057280000014588222472288501378_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041984415023508843680000011764503554662896825_",
    style: {
      clipPath: "url(#SVGID_00000082327840644148004620000010449046442410971812_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059297996682362967830000003225341510024369542_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs433 || (_defs433 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000004523323849989874260000005051281468049763205_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs434 || (_defs434 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000121976775867990045460000002191493535334872243_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs435 || (_defs435 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000095336452438731328680000001593213929091393433_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs436 || (_defs436 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000106130345427561786710000005355042340460687493_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181777285052668039660000011357538901959547041_",
    style: {
      clipPath: "url(#SVGID_00000078755586527706025570000001391944886441707957_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000004523323849989874260000005051281468049763205_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000937047709131114470000015884583688073613473_",
    style: {
      clipPath: "url(#SVGID_00000181777285052668039660000011357538901959547041_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121976775867990045460000002191493535334872243_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093867215992414869670000001540293224718421892_",
    style: {
      clipPath: "url(#SVGID_00000000937047709131114470000015884583688073613473_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095336452438731328680000001593213929091393433_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000154404295355943347350000016150193947492355229_",
    style: {
      clipPath: "url(#SVGID_00000093867215992414869670000001540293224718421892_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106130345427561786710000005355042340460687493_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs437 || (_defs437 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000097478243145985383610000002399616878897806782_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs438 || (_defs438 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116914466269723715010000014012815098668532920_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004514370455000263760000000640580017379473802_",
    style: {
      clipPath: "url(#SVGID_00000078755586527706025570000001391944886441707957_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000097478243145985383610000002399616878897806782_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098921039841605224490000004049141349793912980_",
    style: {
      clipPath: "url(#SVGID_00000004514370455000263760000000640580017379473802_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116914466269723715010000014012815098668532920_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs439 || (_defs439 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000056395208222673073540000008300123395080932524_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs440 || (_defs440 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000160173285605355092870000003429162593927977874_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs441 || (_defs441 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000043446098644542231830000017526855775261065914_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103965301701408678630000003603725124684151974_",
    style: {
      clipPath: "url(#SVGID_00000078755586527706025570000001391944886441707957_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056395208222673073540000008300123395080932524_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039824246755375185550000001308165511602371730_",
    style: {
      clipPath: "url(#SVGID_00000103965301701408678630000003603725124684151974_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160173285605355092870000003429162593927977874_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078758387234651842290000016668798241492314017_",
    style: {
      clipPath: "url(#SVGID_00000039824246755375185550000001308165511602371730_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000043446098644542231830000017526855775261065914_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs442 || (_defs442 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000158708399114160256430000014145749075991283642_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs443 || (_defs443 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000132045810294118845950000001443449479286012806_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs444 || (_defs444 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000150074029629767087700000001075779261292333757_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs445 || (_defs445 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000018927872577456902970000005683636514506906794_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147920203109541192240000016489438492905425073_",
    style: {
      clipPath: "url(#SVGID_00000078755586527706025570000001391944886441707957_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158708399114160256430000014145749075991283642_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080176010548578134860000004941738165310355634_",
    style: {
      clipPath: "url(#SVGID_00000147920203109541192240000016489438492905425073_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132045810294118845950000001443449479286012806_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132810277836420901920000018252689391730514820_",
    style: {
      clipPath: "url(#SVGID_00000080176010548578134860000004941738165310355634_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150074029629767087700000001075779261292333757_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171720971521190162750000006677994710534882972_",
    style: {
      clipPath: "url(#SVGID_00000132810277836420901920000018252689391730514820_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018927872577456902970000005683636514506906794_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs446 || (_defs446 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000029048157080109375190000003046394888307824809_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs447 || (_defs447 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000176754322647157775930000003819457230311294616_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs448 || (_defs448 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000046326567451957591490000006837382724965089455_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs449 || (_defs449 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155831154016376557160000000219290751030920888_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs450 || (_defs450 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000072984598479238201140000005237986876305917875_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021096995782195137370000006091685762005320371_",
    style: {
      clipPath: "url(#SVGID_00000078755586527706025570000001391944886441707957_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029048157080109375190000003046394888307824809_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036222453966487615400000005130820009863967378_",
    style: {
      clipPath: "url(#SVGID_00000021096995782195137370000006091685762005320371_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176754322647157775930000003819457230311294616_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171706522368458886020000001189343017047074470_",
    style: {
      clipPath: "url(#SVGID_00000036222453966487615400000005130820009863967378_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000046326567451957591490000006837382724965089455_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083057689378230038060000014573216324985481918_",
    style: {
      clipPath: "url(#SVGID_00000171706522368458886020000001189343017047074470_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155831154016376557160000000219290751030920888_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103956913018534702310000008056574451318338237_",
    style: {
      clipPath: "url(#SVGID_00000083057689378230038060000014573216324985481918_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072984598479238201140000005237986876305917875_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs451 || (_defs451 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000090277866220792294630000004484105304834617759_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs452 || (_defs452 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000100371857063863561900000010334567352422450052_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs453 || (_defs453 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155853656988762731700000018314026147790324645_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs454 || (_defs454 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000003823965773475454940000014194396404159607707_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs455 || (_defs455 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000049222664553229416660000018386182776634449321_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs456 || (_defs456 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000150061116077035925340000001507437966710859921_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056392053727921449670000003916388226278101915_",
    style: {
      clipPath: "url(#SVGID_00000078755586527706025570000001391944886441707957_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090277866220792294630000004484105304834617759_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173156216109186689610000001304829731994544530_",
    style: {
      clipPath: "url(#SVGID_00000056392053727921449670000003916388226278101915_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100371857063863561900000010334567352422450052_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078016973084317547360000003346815618016986280_",
    style: {
      clipPath: "url(#SVGID_00000173156216109186689610000001304829731994544530_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155853656988762731700000018314026147790324645_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150786628441140262590000009318134692481736577_",
    style: {
      clipPath: "url(#SVGID_00000078016973084317547360000003346815618016986280_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003823965773475454940000014194396404159607707_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011017673637688191330000005132174971410908065_",
    style: {
      clipPath: "url(#SVGID_00000150786628441140262590000009318134692481736577_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049222664553229416660000018386182776634449321_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000175284153807571327020000000794742709446575238_",
    style: {
      clipPath: "url(#SVGID_00000011017673637688191330000005132174971410908065_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150061116077035925340000001507437966710859921_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133514732124925256800000008757345132316632717_",
    gradientUnits: "userSpaceOnUse",
    x1: -264.0887,
    y1: 151.897,
    x2: 20.069,
    y2: -84.3977,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000175284153807571327020000000794742709446575238_)",
      fill: "url(#SVGID_00000133514732124925256800000008757345132316632717_)"
    },
    d: " M17,94.2c0,8.5,0.3,16.4,0.8,23.7c2.4,33.4,9.3,52.3,9.3,52.3h9C12.2,85,48.6,9.4,49,8.5C48.6,9,28.5,32.9,20.4,66.7 C18.4,75.3,17,84.6,17,94.2z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098198172632874992570000016238620947775187336_",
    gradientUnits: "userSpaceOnUse",
    x1: -264.0887,
    y1: 151.897,
    x2: 20.069,
    y2: -84.3977,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000078755586527706025570000001391944886441707957_)",
      mask: "url(#SVGID_00000021104860421671030910000015996740854946434979_)",
      fill: "url(#SVGID_00000098198172632874992570000016238620947775187336_)"
    },
    d: " M17,94.2c0,8.5,0.3,16.4,0.8,23.7c2.4,33.4,9.3,52.3,9.3,52.3h9C12.2,85,48.6,9.4,49,8.5C48.6,9,28.5,32.9,20.4,66.7 C18.4,75.3,17,84.6,17,94.2z"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M17,94.2c0,8.5,0.3,16.4,0.8,23.7c2.4,33.4,9.3,52.3,9.3,52.3h9C12.2,85,48.6,9.4,49,8.5 C48.6,9,28.5,32.9,20.4,66.7C18.4,75.3,17,84.6,17,94.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs457 || (_defs457 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000118389444017958813220000006593001371941295766_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052083751361399433740000004249217021940092072_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118389444017958813220000006593001371941295766_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs458 || (_defs458 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000071522343918630677710000004488383948269462185_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs459 || (_defs459 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000167369335384661451790000017318216205944834462_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119083514295981570770000001592372271231550123_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071522343918630677710000004488383948269462185_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000197581192830977170000012587042406329556145_",
    style: {
      clipPath: "url(#SVGID_00000119083514295981570770000001592372271231550123_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167369335384661451790000017318216205944834462_",
    style: {
      overflow: "visible"
    }
  })), _defs460 || (_defs460 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000168110754177776368560000005800437076498237334_",
    filterUnits: "userSpaceOnUse",
    x: 48.8,
    y: 8.5,
    width: 32,
    height: 161.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 48.8,
    y: 8.5,
    width: 32,
    height: 161.7,
    id: "SVGID_00000150786087879712872890000004512831242216644746_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000168110754177776368560000005800437076498237334_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs461 || (_defs461 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000101067222942351683910000002618014709235733422_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs462 || (_defs462 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000173135107419434232240000005340216897204422061_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000166658566348667882680000018394339049629738410_",
    style: {
      clipPath: "url(#SVGID_00000000197581192830977170000012587042406329556145_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101067222942351683910000002618014709235733422_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070797124578432126700000003157259256006879899_",
    style: {
      clipPath: "url(#SVGID_00000166658566348667882680000018394339049629738410_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173135107419434232240000005340216897204422061_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs463 || (_defs463 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000008848495227953889370000016715433395207646112_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs464 || (_defs464 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000156559764753427095740000005778041382663964557_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs465 || (_defs465 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000060709863721035391880000005105165772202232965_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000089569924807854208200000014053282393774373024_",
    style: {
      clipPath: "url(#SVGID_00000000197581192830977170000012587042406329556145_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008848495227953889370000016715433395207646112_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023989445460367210910000002434910241468271251_",
    style: {
      clipPath: "url(#SVGID_00000089569924807854208200000014053282393774373024_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000156559764753427095740000005778041382663964557_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165950790148474933110000004116567982973736624_",
    style: {
      clipPath: "url(#SVGID_00000023989445460367210910000002434910241468271251_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060709863721035391880000005105165772202232965_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs466 || (_defs466 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000161590780687493631710000013666094266763528333_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs467 || (_defs467 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013164207382542504200000004126849341092102019_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000107574871397613529810000016218112639980396728_",
    style: {
      clipPath: "url(#SVGID_00000000197581192830977170000012587042406329556145_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161590780687493631710000013666094266763528333_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031913534163378796730000001780404633058256768_",
    style: {
      clipPath: "url(#SVGID_00000107574871397613529810000016218112639980396728_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013164207382542504200000004126849341092102019_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs468 || (_defs468 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000168115527195498906210000013122249842681712827_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs469 || (_defs469 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000029036874065608040480000005701176020788649145_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs470 || (_defs470 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052804501855543247990000018143834797731463333_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119090739962178200790000008976166919923816872_",
    style: {
      clipPath: "url(#SVGID_00000000197581192830977170000012587042406329556145_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168115527195498906210000013122249842681712827_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000076567709195899149100000008439352117632382854_",
    style: {
      clipPath: "url(#SVGID_00000119090739962178200790000008976166919923816872_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029036874065608040480000005701176020788649145_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080183383251898922950000008792919734961148038_",
    style: {
      clipPath: "url(#SVGID_00000076567709195899149100000008439352117632382854_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052804501855543247990000018143834797731463333_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs471 || (_defs471 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000000191667380101645800000005649243821952864915_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs472 || (_defs472 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000134962134200010776830000015843150269426367644_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs473 || (_defs473 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000107587760097780561170000004077002074239126197_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs474 || (_defs474 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000104699635924051462050000010888392582160993956_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026873681147420011250000006438408045738765244_",
    style: {
      clipPath: "url(#SVGID_00000000197581192830977170000012587042406329556145_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000191667380101645800000005649243821952864915_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070822382644120231890000012343713716813962412_",
    style: {
      clipPath: "url(#SVGID_00000026873681147420011250000006438408045738765244_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134962134200010776830000015843150269426367644_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005254420328145038660000016819613469315981698_",
    style: {
      clipPath: "url(#SVGID_00000070822382644120231890000012343713716813962412_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107587760097780561170000004077002074239126197_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127022534358686565800000015770596436197674159_",
    style: {
      clipPath: "url(#SVGID_00000005254420328145038660000016819613469315981698_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000104699635924051462050000010888392582160993956_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs475 || (_defs475 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000071556421977644063470000010032068176327313312_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs476 || (_defs476 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000014634081211504748030000011219814580628906673_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035514237481683744010000003465104680812625809_",
    style: {
      clipPath: "url(#SVGID_00000000197581192830977170000012587042406329556145_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071556421977644063470000010032068176327313312_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112599603024014401610000001335867649988804769_",
    style: {
      clipPath: "url(#SVGID_00000035514237481683744010000003465104680812625809_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014634081211504748030000011219814580628906673_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs477 || (_defs477 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000124884217629334347360000005110167984108080800_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs478 || (_defs478 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000094590140797401092460000015608708538643245995_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs479 || (_defs479 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000115503384413041974450000006582392099466975907_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103973425020442381540000016857766730691893429_",
    style: {
      clipPath: "url(#SVGID_00000000197581192830977170000012587042406329556145_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124884217629334347360000005110167984108080800_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168828916791692455680000000484041205654722688_",
    style: {
      clipPath: "url(#SVGID_00000103973425020442381540000016857766730691893429_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094590140797401092460000015608708538643245995_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157276359565973624310000008504310546917194161_",
    style: {
      clipPath: "url(#SVGID_00000168828916791692455680000000484041205654722688_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115503384413041974450000006582392099466975907_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs480 || (_defs480 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000134930187333191988140000004960345983343529879_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs481 || (_defs481 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013165518719262202530000011884068620735992210_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs482 || (_defs482 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000183952324512645381870000004278800779799946165_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs483 || (_defs483 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000119105105752157877750000015247589231890705065_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145751560672456493450000000250982978645076610_",
    style: {
      clipPath: "url(#SVGID_00000000197581192830977170000012587042406329556145_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134930187333191988140000004960345983343529879_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027573764147896655560000017306178390863408006_",
    style: {
      clipPath: "url(#SVGID_00000145751560672456493450000000250982978645076610_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013165518719262202530000011884068620735992210_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000025405872387699568850000014517260263209550736_",
    style: {
      clipPath: "url(#SVGID_00000027573764147896655560000017306178390863408006_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183952324512645381870000004278800779799946165_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032648521219791530690000012191184963451710592_",
    style: {
      clipPath: "url(#SVGID_00000025405872387699568850000014517260263209550736_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119105105752157877750000015247589231890705065_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs484 || (_defs484 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000088124249749016303490000013825989170368415650_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs485 || (_defs485 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000178182285598318126600000007828337661596509081_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs486 || (_defs486 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000118399114430567674800000009607681864871018394_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs487 || (_defs487 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000178200690511386094820000013985581715478061970_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs488 || (_defs488 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000003086412797306062130000013049531826973630624_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065776456448163399100000000726371310411224705_",
    style: {
      clipPath: "url(#SVGID_00000000197581192830977170000012587042406329556145_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088124249749016303490000013825989170368415650_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182507940756232890390000006543156164065099947_",
    style: {
      clipPath: "url(#SVGID_00000065776456448163399100000000726371310411224705_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178182285598318126600000007828337661596509081_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121968178386616346440000011821535673055742370_",
    style: {
      clipPath: "url(#SVGID_00000182507940756232890390000006543156164065099947_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118399114430567674800000009607681864871018394_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047745103821828597230000005292417259828173759_",
    style: {
      clipPath: "url(#SVGID_00000121968178386616346440000011821535673055742370_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178200690511386094820000013985581715478061970_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000024720795729932994270000010920928427522931625_",
    style: {
      clipPath: "url(#SVGID_00000047745103821828597230000005292417259828173759_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003086412797306062130000013049531826973630624_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs489 || (_defs489 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000100376100974009223920000004715783453630109081_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs490 || (_defs490 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000056407243654055852750000012429318017254579355_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs491 || (_defs491 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000021815423595080064320000000552573689791919747_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs492 || (_defs492 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000145041660491823503890000014615787934309665167_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs493 || (_defs493 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000049925922152891889450000012083200524837599418_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs494 || (_defs494 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000069394122365955133480000017300397386981587847_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052083337485908313790000002212647163081154970_",
    style: {
      clipPath: "url(#SVGID_00000000197581192830977170000012587042406329556145_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100376100974009223920000004715783453630109081_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163782729124767855970000016393964377959918753_",
    style: {
      clipPath: "url(#SVGID_00000052083337485908313790000002212647163081154970_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056407243654055852750000012429318017254579355_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022532355832820130800000010439115598816637322_",
    style: {
      clipPath: "url(#SVGID_00000163782729124767855970000016393964377959918753_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021815423595080064320000000552573689791919747_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038383483200421971730000009727817513906952859_",
    style: {
      clipPath: "url(#SVGID_00000022532355832820130800000010439115598816637322_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145041660491823503890000014615787934309665167_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035499055967900597170000006013715928028435887_",
    style: {
      clipPath: "url(#SVGID_00000038383483200421971730000009727817513906952859_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049925922152891889450000012083200524837599418_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032636915852821292110000004701504855373213061_",
    style: {
      clipPath: "url(#SVGID_00000035499055967900597170000006013715928028435887_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069394122365955133480000017300397386981587847_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113326414268932482270000000034223209238856344_",
    gradientUnits: "userSpaceOnUse",
    x1: -244.8625,
    y1: 105.8173,
    x2: -325.6987,
    y2: 273.9841,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000032636915852821292110000004701504855373213061_)",
      fill: "url(#SVGID_00000113326414268932482270000000034223209238856344_)"
    },
    d: " M80.8,94.2c0,8.5-0.3,16.4-0.8,23.7c-2.4,33.4-9.3,52.3-9.3,52.3h-9C85.7,85,49.3,9.4,48.8,8.5 C49.2,9,69.3,32.9,77.6,66.7C79.6,75.3,80.8,84.6,80.8,94.2z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013894669807501163160000000265304236476391862_",
    gradientUnits: "userSpaceOnUse",
    x1: -244.8625,
    y1: 105.8173,
    x2: -325.6987,
    y2: 273.9841,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000000197581192830977170000012587042406329556145_)",
      mask: "url(#SVGID_00000150786087879712872890000004512831242216644746_)",
      fill: "url(#SVGID_00000013894669807501163160000000265304236476391862_)"
    },
    d: " M80.8,94.2c0,8.5-0.3,16.4-0.8,23.7c-2.4,33.4-9.3,52.3-9.3,52.3h-9C85.7,85,49.3,9.4,48.8,8.5 C49.2,9,69.3,32.9,77.6,66.7C79.6,75.3,80.8,84.6,80.8,94.2z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175301471477006215550000005448428992986143916_",
    gradientUnits: "userSpaceOnUse",
    x1: -245.1583,
    y1: 105.8086,
    x2: -325.9946,
    y2: 273.9754,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000175301471477006215550000005448428992986143916_)",
      enableBackground: "new"
    },
    d: " M81.2,94.2c0,8.5-0.3,16.4-0.8,23.7c-2.4,33.4-9.3,52.3-9.3,52.3h-9C85.9,85,49.6,9.4,49.1,8.5C49.5,9,69.7,32.9,77.8,66.7 C79.8,75.3,81.2,84.6,81.2,94.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067206132907231745430000016925980477812453555_",
    gradientUnits: "userSpaceOnUse",
    x1: -522.9093,
    y1: -862.2859,
    x2: -522.9093,
    y2: -890.9233,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000067206132907231745430000016925980477812453555_)"
    },
    points: "49,127.8 49,197.1  51.2,176.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170259236656393872150000010705417715149290921_",
    gradientUnits: "userSpaceOnUse",
    x1: -520.7093,
    y1: -892.167,
    x2: -520.7093,
    y2: -870.1392,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E110E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000170259236656393872150000010705417715149290921_)"
    },
    points: "49,127.8 49,197.1  46.9,176.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs495 || (_defs495 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152974361881698333620000007109552759626684318_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000086685640952822036950000013130214561466822574_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152974361881698333620000007109552759626684318_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs496 || (_defs496 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000103944599133259570090000014764489436963047857_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs497 || (_defs497 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000123436453490345568170000017975563079553963147_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018941445117726956550000009504257503864764844_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103944599133259570090000014764489436963047857_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108273467280602698370000007857887197420505516_",
    style: {
      clipPath: "url(#SVGID_00000018941445117726956550000009504257503864764844_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123436453490345568170000017975563079553963147_",
    style: {
      overflow: "visible"
    }
  })), _defs498 || (_defs498 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000017518850585234211740000004661262328563932091_",
    filterUnits: "userSpaceOnUse",
    x: 34.2,
    y: 79.9,
    width: 28,
    height: 28
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 34.2,
    y: 79.9,
    width: 28,
    height: 28,
    id: "SVGID_00000078015630252786408590000006899207005368762791_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000017518850585234211740000004661262328563932091_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs499 || (_defs499 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152234489378141815040000010712857362070745264_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs500 || (_defs500 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000095318134869198804750000018330646055587763642_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078013361031445991240000007773760424829745024_",
    style: {
      clipPath: "url(#SVGID_00000108273467280602698370000007857887197420505516_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152234489378141815040000010712857362070745264_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128481523978082447220000018131106936634192014_",
    style: {
      clipPath: "url(#SVGID_00000078013361031445991240000007773760424829745024_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095318134869198804750000018330646055587763642_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs501 || (_defs501 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000008867029619492335360000005400987016889352858_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs502 || (_defs502 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000067204046962913258930000009223173401288460476_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs503 || (_defs503 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000148654320342807046620000014211812320914749831_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034086433815180361350000009316976756121498007_",
    style: {
      clipPath: "url(#SVGID_00000108273467280602698370000007857887197420505516_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008867029619492335360000005400987016889352858_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000045583715541036887520000009659453075900568248_",
    style: {
      clipPath: "url(#SVGID_00000034086433815180361350000009316976756121498007_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067204046962913258930000009223173401288460476_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085967139603138511200000010516603077811145863_",
    style: {
      clipPath: "url(#SVGID_00000045583715541036887520000009659453075900568248_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148654320342807046620000014211812320914749831_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs504 || (_defs504 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000039843043096048236610000013102853137925308050_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs505 || (_defs505 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000085231496631405547740000016943123063811893137_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026861386868573657110000003267903392361787783_",
    style: {
      clipPath: "url(#SVGID_00000108273467280602698370000007857887197420505516_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039843043096048236610000013102853137925308050_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000117668078102070418920000012022621206501286558_",
    style: {
      clipPath: "url(#SVGID_00000026861386868573657110000003267903392361787783_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085231496631405547740000016943123063811893137_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs506 || (_defs506 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000077287844528581284940000012332312964429022621_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs507 || (_defs507 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000108293812571326898790000017095920763161858705_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs508 || (_defs508 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000033332049870637715710000007598547585087007380_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044151123948049731830000013811193797635180971_",
    style: {
      clipPath: "url(#SVGID_00000108273467280602698370000007857887197420505516_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077287844528581284940000012332312964429022621_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128447782091735707960000013791206513025367945_",
    style: {
      clipPath: "url(#SVGID_00000044151123948049731830000013811193797635180971_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108293812571326898790000017095920763161858705_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101069612846165905320000000798859539754945667_",
    style: {
      clipPath: "url(#SVGID_00000128447782091735707960000013791206513025367945_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033332049870637715710000007598547585087007380_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs509 || (_defs509 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000117649336427877639180000006186265925197155500_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs510 || (_defs510 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000053543958983119879370000013245736606351505815_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs511 || (_defs511 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152257106466651588650000005749378943540121770_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs512 || (_defs512 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000134963540329562543820000016978567375102145929_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122699523588910847110000004775697365143743368_",
    style: {
      clipPath: "url(#SVGID_00000108273467280602698370000007857887197420505516_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117649336427877639180000006186265925197155500_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044883056886703707320000004790819302004171923_",
    style: {
      clipPath: "url(#SVGID_00000122699523588910847110000004775697365143743368_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053543958983119879370000013245736606351505815_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000048460731787400993340000018391813675110777780_",
    style: {
      clipPath: "url(#SVGID_00000044883056886703707320000004790819302004171923_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152257106466651588650000005749378943540121770_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174564828418217879950000018392238487106488196_",
    style: {
      clipPath: "url(#SVGID_00000048460731787400993340000018391813675110777780_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134963540329562543820000016978567375102145929_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs513 || (_defs513 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000070097536043734787110000015851629811034575490_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs514 || (_defs514 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000070809433398738839320000016623295431069053088_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000079460911668938457600000012778526193818946700_",
    style: {
      clipPath: "url(#SVGID_00000108273467280602698370000007857887197420505516_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070097536043734787110000015851629811034575490_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114054263987559229270000001466749977419245953_",
    style: {
      clipPath: "url(#SVGID_00000079460911668938457600000012778526193818946700_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070809433398738839320000016623295431069053088_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs515 || (_defs515 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096747134358867690740000005636504215947618456_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs516 || (_defs516 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000031917044192315426660000007486696206435487650_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs517 || (_defs517 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000065062696937922876990000007592821752489628596_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021077444139543209380000000691550060053659798_",
    style: {
      clipPath: "url(#SVGID_00000108273467280602698370000007857887197420505516_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096747134358867690740000005636504215947618456_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008129637678341409950000001493297135627625103_",
    style: {
      clipPath: "url(#SVGID_00000021077444139543209380000000691550060053659798_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031917044192315426660000007486696206435487650_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165233902851468733010000001941529962086754952_",
    style: {
      clipPath: "url(#SVGID_00000008129637678341409950000001493297135627625103_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065062696937922876990000007592821752489628596_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs518 || (_defs518 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000085252261176274408840000007390754492717700781_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs519 || (_defs519 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013183023326157154100000010182929630311722678_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs520 || (_defs520 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000154384890268058593350000006602114213343945663_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs521 || (_defs521 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000046298455682632456190000015935511844817121193_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000079459141853814381050000016607658443174797743_",
    style: {
      clipPath: "url(#SVGID_00000108273467280602698370000007857887197420505516_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085252261176274408840000007390754492717700781_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062870958679868561570000013132664077943066757_",
    style: {
      clipPath: "url(#SVGID_00000079459141853814381050000016607658443174797743_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013183023326157154100000010182929630311722678_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057830804140463132790000002123199112570662537_",
    style: {
      clipPath: "url(#SVGID_00000062870958679868561570000013132664077943066757_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000154384890268058593350000006602114213343945663_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096741293867116157160000017317201727325940900_",
    style: {
      clipPath: "url(#SVGID_00000057830804140463132790000002123199112570662537_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000046298455682632456190000015935511844817121193_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs522 || (_defs522 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000178176879857145342160000011332592121287073161_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs523 || (_defs523 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098943423311573577220000011791302112231629723_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs524 || (_defs524 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000031922255766836272090000017703604670149565082_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs525 || (_defs525 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000103256993597860680470000013160993969761265293_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs526 || (_defs526 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000072245870973135374360000013686083777782280832_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065759484154077527870000017461306841842263427_",
    style: {
      clipPath: "url(#SVGID_00000108273467280602698370000007857887197420505516_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178176879857145342160000011332592121287073161_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000143613673153729632780000007456878565939213460_",
    style: {
      clipPath: "url(#SVGID_00000065759484154077527870000017461306841842263427_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098943423311573577220000011791302112231629723_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072258128437473452990000001292564578545288585_",
    style: {
      clipPath: "url(#SVGID_00000143613673153729632780000007456878565939213460_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031922255766836272090000017703604670149565082_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009577959824283013940000000062307038069367171_",
    style: {
      clipPath: "url(#SVGID_00000072258128437473452990000001292564578545288585_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103256993597860680470000013160993969761265293_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004546522765604381780000010327269891747911576_",
    style: {
      clipPath: "url(#SVGID_00000009577959824283013940000000062307038069367171_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072245870973135374360000013686083777782280832_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs527 || (_defs527 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000181807481066300200090000012415952427309694392_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs528 || (_defs528 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000010280755336331241850000016719320820776448131_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs529 || (_defs529 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000053523937488043220430000003064752186049385111_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs530 || (_defs530 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000094616388433753518540000001514542966299031683_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs531 || (_defs531 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000018201835066592824700000003977627875869537429_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs532 || (_defs532 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000114060132683372116510000016082777398562841230_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098940123958184411570000005651816024359192480_",
    style: {
      clipPath: "url(#SVGID_00000108273467280602698370000007857887197420505516_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181807481066300200090000012415952427309694392_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103246296764388941850000011607335506153409707_",
    style: {
      clipPath: "url(#SVGID_00000098940123958184411570000005651816024359192480_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000010280755336331241850000016719320820776448131_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173854675871921752600000004061676661766306705_",
    style: {
      clipPath: "url(#SVGID_00000103246296764388941850000011607335506153409707_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053523937488043220430000003064752186049385111_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057843172545397309770000013257397887740716724_",
    style: {
      clipPath: "url(#SVGID_00000173854675871921752600000004061676661766306705_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094616388433753518540000001514542966299031683_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085244255634435096940000010124815824269022638_",
    style: {
      clipPath: "url(#SVGID_00000057843172545397309770000013257397887740716724_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018201835066592824700000003977627875869537429_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000087386136153217788010000011726033649872415678_",
    style: {
      clipPath: "url(#SVGID_00000085244255634435096940000010124815824269022638_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114060132683372116510000016082777398562841230_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063617381078286498450000015248505657482801829_",
    gradientUnits: "userSpaceOnUse",
    x1: -237.3528,
    y1: 121.8381,
    x2: -310.8275,
    y2: 170.7932,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000087386136153217788010000011726033649872415678_)",
      fill: "url(#SVGID_00000063617381078286498450000015248505657482801829_)"
    },
    cx: 48.2,
    cy: 93.9,
    r: 14
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037668531371768468930000004245842391605278907_",
    gradientUnits: "userSpaceOnUse",
    x1: -237.3528,
    y1: 121.8381,
    x2: -310.8275,
    y2: 170.7932,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000108273467280602698370000007857887197420505516_)",
      mask: "url(#SVGID_00000078015630252786408590000006899207005368762791_)",
      fill: "url(#SVGID_00000037668531371768468930000004245842391605278907_)"
    },
    cx: 48.2,
    cy: 93.9,
    r: 14
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154407418058463584830000017586412524166835621_",
    gradientUnits: "userSpaceOnUse",
    x1: -237.3528,
    y1: 121.8381,
    x2: -310.8275,
    y2: 170.7932,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000154407418058463584830000017586412524166835621_)"
    },
    cx: 48.2,
    cy: 93.9,
    r: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002384223474500421510000008644161091193903019_",
    gradientUnits: "userSpaceOnUse",
    x1: -521.8093,
    y1: -789.4028,
    x2: -521.8093,
    y2: -809.9207,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#3A2317"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000002384223474500421510000008644161091193903019_)"
    },
    cx: 49,
    cy: 93.1,
    r: 12.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008831215708466409600000001438331149680912014_",
    gradientUnits: "userSpaceOnUse",
    x1: -517.3647,
    y1: -809.5712,
    x2: -523.973,
    y2: -799.2278,
    gradientTransform: "matrix(-1 0 0 -1 -472.7593 -709.3386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#3A2317"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008831215708466409600000001438331149680912014_)"
    },
    d: "M40,93.1c0,5,4.1,9.1,9.1,9.1 c1,0,1.9-0.2,2.8-0.4c1.1-0.4,2.2-0.9,3.1-1.7c0.7-0.6,1.3-1.3,1.8-2c0.9-1.4,1.5-3.1,1.5-5c0-5-4.1-9.1-9.1-9.1 c-1.8,0-3.5,0.5-5,1.5c-0.8,0.5-1.4,1.1-2,1.8c-0.7,0.9-1.3,1.9-1.7,3.1C40.1,91.2,40,92.1,40,93.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs533 || (_defs533 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000177464190474163364980000000780676192013402298_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148629804502144004770000006294266525264987319_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177464190474163364980000000780676192013402298_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs534 || (_defs534 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000183953162668804694640000007283261366594649022_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs535 || (_defs535 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000147193523431835991950000018245167631653578123_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000133506002599996510000000008930040749793564568_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183953162668804694640000007283261366594649022_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014622496450002658890000002139921603594153912_",
    style: {
      clipPath: "url(#SVGID_00000133506002599996510000000008930040749793564568_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147193523431835991950000018245167631653578123_",
    style: {
      overflow: "visible"
    }
  })), _defs536 || (_defs536 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000062876911332474341730000011541958589953950874_",
    filterUnits: "userSpaceOnUse",
    x: 44,
    y: 84,
    width: 14.1,
    height: 14.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 84,
    width: 14.1,
    height: 14.1,
    id: "SVGID_00000036942736869524975570000015055153701206070972_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000062876911332474341730000011541958589953950874_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs537 || (_defs537 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000017500306360680997190000008504018251860141987_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs538 || (_defs538 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000093155037978221437300000018354090002770398380_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176758799820682038320000012867580493835065774_",
    style: {
      clipPath: "url(#SVGID_00000014622496450002658890000002139921603594153912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000017500306360680997190000008504018251860141987_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139292553555092928040000001864904393618770089_",
    style: {
      clipPath: "url(#SVGID_00000176758799820682038320000012867580493835065774_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093155037978221437300000018354090002770398380_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs539 || (_defs539 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000145736643816494357950000003141253586880903851_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs540 || (_defs540 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000055684672702619408340000000570031542707709084_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs541 || (_defs541 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000164507409803747246090000007999690982038103707_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176725896516407753390000004235981789537193892_",
    style: {
      clipPath: "url(#SVGID_00000014622496450002658890000002139921603594153912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145736643816494357950000003141253586880903851_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057134653819157364900000010311761756791050686_",
    style: {
      clipPath: "url(#SVGID_00000176725896516407753390000004235981789537193892_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055684672702619408340000000570031542707709084_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121966548120954503500000004357958094594214586_",
    style: {
      clipPath: "url(#SVGID_00000057134653819157364900000010311761756791050686_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000164507409803747246090000007999690982038103707_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs542 || (_defs542 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000034074047957693303070000010584975041034133892_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs543 || (_defs543 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000083051039746203150590000009340272531229804186_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035488760829183013450000006391486944139219631_",
    style: {
      clipPath: "url(#SVGID_00000014622496450002658890000002139921603594153912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034074047957693303070000010584975041034133892_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071540143498625818510000005711754075081274034_",
    style: {
      clipPath: "url(#SVGID_00000035488760829183013450000006391486944139219631_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083051039746203150590000009340272531229804186_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs544 || (_defs544 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000054235778749239729660000007955948011879727243_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs545 || (_defs545 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000163784212321830714300000017210150746157912229_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs546 || (_defs546 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000073687060832133852590000011586763687175762614_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110457853505853397640000016539701649503293616_",
    style: {
      clipPath: "url(#SVGID_00000014622496450002658890000002139921603594153912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054235778749239729660000007955948011879727243_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026156090129689923020000015352545579314723474_",
    style: {
      clipPath: "url(#SVGID_00000110457853505853397640000016539701649503293616_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163784212321830714300000017210150746157912229_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016077834135466034030000014364552765182017982_",
    style: {
      clipPath: "url(#SVGID_00000026156090129689923020000015352545579314723474_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000073687060832133852590000011586763687175762614_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs547 || (_defs547 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000057130405697901045340000011739843580303818640_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs548 || (_defs548 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000168106611775418420880000014787180879866053815_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs549 || (_defs549 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000004536828068240121230000007436865140194232980_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs550 || (_defs550 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000175280348689608492930000009373284799196703675_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105422307780779295520000008686634460809862065_",
    style: {
      clipPath: "url(#SVGID_00000014622496450002658890000002139921603594153912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057130405697901045340000011739843580303818640_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005971598346701587700000000086381989117428891_",
    style: {
      clipPath: "url(#SVGID_00000105422307780779295520000008686634460809862065_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168106611775418420880000014787180879866053815_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152231727217238443940000005191998577313475733_",
    style: {
      clipPath: "url(#SVGID_00000005971598346701587700000000086381989117428891_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000004536828068240121230000007436865140194232980_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101104411148523447360000013564243956791227270_",
    style: {
      clipPath: "url(#SVGID_00000152231727217238443940000005191998577313475733_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175280348689608492930000009373284799196703675_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs551 || (_defs551 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000121265162477910868640000017778995762019660205_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs552 || (_defs552 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000004541485838378302820000017071026414199389864_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065071350132728570890000010959667451919555474_",
    style: {
      clipPath: "url(#SVGID_00000014622496450002658890000002139921603594153912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121265162477910868640000017778995762019660205_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139995099481290246070000009248095827961700000_",
    style: {
      clipPath: "url(#SVGID_00000065071350132728570890000010959667451919555474_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000004541485838378302820000017071026414199389864_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs553 || (_defs553 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000156572873228776735640000014960288859244239772_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs554 || (_defs554 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000179622347746315416990000008672522021294674878_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs555 || (_defs555 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000173852415764358489870000007372700374896759730_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000141448618919618750830000013521361514130405286_",
    style: {
      clipPath: "url(#SVGID_00000014622496450002658890000002139921603594153912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000156572873228776735640000014960288859244239772_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060732083475106257320000002041461001934896827_",
    style: {
      clipPath: "url(#SVGID_00000141448618919618750830000013521361514130405286_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179622347746315416990000008672522021294674878_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063604061448942895540000017343882671461481091_",
    style: {
      clipPath: "url(#SVGID_00000060732083475106257320000002041461001934896827_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173852415764358489870000007372700374896759730_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs556 || (_defs556 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000009552455864980596140000007133571483696715449_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs557 || (_defs557 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000020358680787056042710000000297771089166453133_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs558 || (_defs558 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000018922064894767406190000016083176087047485333_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs559 || (_defs559 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000169532707042419365550000012105658251787885483_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137109836066331247320000005313804261342144692_",
    style: {
      clipPath: "url(#SVGID_00000014622496450002658890000002139921603594153912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009552455864980596140000007133571483696715449_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112595361153470776790000006173400421281537176_",
    style: {
      clipPath: "url(#SVGID_00000137109836066331247320000005313804261342144692_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020358680787056042710000000297771089166453133_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088091322092369865530000001794043765154522798_",
    style: {
      clipPath: "url(#SVGID_00000112595361153470776790000006173400421281537176_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018922064894767406190000016083176087047485333_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168806492646999962370000014116758818078049159_",
    style: {
      clipPath: "url(#SVGID_00000088091322092369865530000001794043765154522798_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169532707042419365550000012105658251787885483_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs560 || (_defs560 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000036243438024089374790000016251473590493359529_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs561 || (_defs561 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000047777176051157088590000005546906913412187828_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs562 || (_defs562 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000034796360268771492730000014414372769675086986_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs563 || (_defs563 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000094613908922201059290000013397849650117186990_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs564 || (_defs564 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000158748449065431886100000005173769471352755345_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000144295659386354288780000017025033447925183393_",
    style: {
      clipPath: "url(#SVGID_00000014622496450002658890000002139921603594153912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036243438024089374790000016251473590493359529_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101822292988050469690000011949951322564049309_",
    style: {
      clipPath: "url(#SVGID_00000144295659386354288780000017025033447925183393_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047777176051157088590000005546906913412187828_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122702845795374747090000006549034954028327564_",
    style: {
      clipPath: "url(#SVGID_00000101822292988050469690000011949951322564049309_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034796360268771492730000014414372769675086986_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104678159855109987030000010968572227790436252_",
    style: {
      clipPath: "url(#SVGID_00000122702845795374747090000006549034954028327564_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094613908922201059290000013397849650117186990_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000172439020041582163840000014451309197927895729_",
    style: {
      clipPath: "url(#SVGID_00000104678159855109987030000010968572227790436252_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158748449065431886100000005173769471352755345_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs565 || (_defs565 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000169557208040086251960000011103151268248369539_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs566 || (_defs566 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000031209215078691563310000015684131480951771012_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs567 || (_defs567 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000045579220316599777560000009554537469554274997_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs568 || (_defs568 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000167365148953294430510000014076460676425302933_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs569 || (_defs569 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000040535723482332426600000015639745560504795012_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs570 || (_defs570 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000129922391358511443150000001662955559096425401_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128444413650484315360000011309208083694536895_",
    style: {
      clipPath: "url(#SVGID_00000014622496450002658890000002139921603594153912_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169557208040086251960000011103151268248369539_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146500770933345340580000008931967046414950326_",
    style: {
      clipPath: "url(#SVGID_00000128444413650484315360000011309208083694536895_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031209215078691563310000015684131480951771012_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042723738414755377840000005934828571851835311_",
    style: {
      clipPath: "url(#SVGID_00000146500770933345340580000008931967046414950326_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045579220316599777560000009554537469554274997_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000175314216238631909200000006752236228100795566_",
    style: {
      clipPath: "url(#SVGID_00000042723738414755377840000005934828571851835311_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167365148953294430510000014076460676425302933_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101811030937289511150000005875801399322592177_",
    style: {
      clipPath: "url(#SVGID_00000175314216238631909200000006752236228100795566_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000040535723482332426600000015639745560504795012_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021119019787021339590000016836893487566619042_",
    style: {
      clipPath: "url(#SVGID_00000101811030937289511150000005875801399322592177_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129922391358511443150000001662955559096425401_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007390165096732012170000006748956311280669066_",
    gradientUnits: "userSpaceOnUse",
    x1: -238.5211,
    y1: 142.5226,
    x2: -288.232,
    y2: 98.7457,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000021119019787021339590000016836893487566619042_)",
      fill: "url(#SVGID_00000007390165096732012170000006748956311280669066_)"
    },
    d: " M44,85.5l12.6,12.6c0.9-1.4,1.5-3.1,1.5-5c0-5-4.1-9.1-9.1-9.1C47.2,84,45.5,84.5,44,85.5z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005948355601676410950000017774263856660500394_",
    gradientUnits: "userSpaceOnUse",
    x1: -238.5211,
    y1: 142.5226,
    x2: -288.232,
    y2: 98.7457,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000014622496450002658890000002139921603594153912_)",
      mask: "url(#SVGID_00000036942736869524975570000015055153701206070972_)",
      fill: "url(#SVGID_00000005948355601676410950000017774263856660500394_)"
    },
    d: " M44,85.5l12.6,12.6c0.9-1.4,1.5-3.1,1.5-5c0-5-4.1-9.1-9.1-9.1C47.2,84,45.5,84.5,44,85.5z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082365113573768380150000013763945755623629219_",
    gradientUnits: "userSpaceOnUse",
    x1: -238.5211,
    y1: 142.5226,
    x2: -288.232,
    y2: 98.7457,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000082365113573768380150000013763945755623629219_)",
      enableBackground: "new"
    },
    d: " M44,85.5l12.6,12.6c0.9-1.4,1.5-3.1,1.5-5c0-5-4.1-9.1-9.1-9.1C47.2,84,45.5,84.5,44,85.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs571 || (_defs571 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000132803726194432988390000012353954088272927145_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116194958712341889430000002494983130401009281_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132803726194432988390000012353954088272927145_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs572 || (_defs572 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152969652868803009570000008823532868262582930_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs573 || (_defs573 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098925888082423694210000013838138013289171619_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000102503954580855593280000000798567813888250260_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152969652868803009570000008823532868262582930_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003069037861088978690000018130353191035958456_",
    style: {
      clipPath: "url(#SVGID_00000102503954580855593280000000798567813888250260_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098925888082423694210000013838138013289171619_",
    style: {
      overflow: "visible"
    }
  })), _defs574 || (_defs574 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000072988499100398650150000015327636222052026528_",
    filterUnits: "userSpaceOnUse",
    x: 40.4,
    y: 87.3,
    width: 14.5,
    height: 14.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 40.4,
    y: 87.3,
    width: 14.5,
    height: 14.4,
    id: "SVGID_00000083804382630307500360000015418305472531482532_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000072988499100398650150000015327636222052026528_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs575 || (_defs575 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000130619871944948475760000001214816260466566278_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs576 || (_defs576 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000163072502390769833670000004920876514015353005_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034785363449679873120000013594078292086916737_",
    style: {
      clipPath: "url(#SVGID_00000003069037861088978690000018130353191035958456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130619871944948475760000001214816260466566278_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073717930960147311540000007566309070112736906_",
    style: {
      clipPath: "url(#SVGID_00000034785363449679873120000013594078292086916737_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163072502390769833670000004920876514015353005_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs577 || (_defs577 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000087414565769409628910000009896535530414559415_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs578 || (_defs578 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000094601080066736714180000000916979038135361927_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs579 || (_defs579 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000181796442513331927310000004793107064741403820_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000164515995472666537210000010938399385717458605_",
    style: {
      clipPath: "url(#SVGID_00000003069037861088978690000018130353191035958456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000087414565769409628910000009896535530414559415_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127763367368753544130000011312458554630206852_",
    style: {
      clipPath: "url(#SVGID_00000164515995472666537210000010938399385717458605_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094601080066736714180000000916979038135361927_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090992401957642107210000009641719307408509348_",
    style: {
      clipPath: "url(#SVGID_00000127763367368753544130000011312458554630206852_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181796442513331927310000004793107064741403820_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs580 || (_defs580 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000093140817209660554810000013026590730005731262_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs581 || (_defs581 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000042697303804276495250000014313885862738001328_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023989858835437563180000011037987650207319454_",
    style: {
      clipPath: "url(#SVGID_00000003069037861088978690000018130353191035958456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093140817209660554810000013026590730005731262_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124157824794854215970000005547989470638314419_",
    style: {
      clipPath: "url(#SVGID_00000023989858835437563180000011037987650207319454_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042697303804276495250000014313885862738001328_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs582 || (_defs582 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000129911297829782440020000007690610012497651854_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs583 || (_defs583 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098221350585529937990000011944719664644082859_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs584 || (_defs584 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000151506483823951173310000009991685491953221532_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116931350222393663840000016267028381103627446_",
    style: {
      clipPath: "url(#SVGID_00000003069037861088978690000018130353191035958456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129911297829782440020000007690610012497651854_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063593499113049022480000005447727650302089663_",
    style: {
      clipPath: "url(#SVGID_00000116931350222393663840000016267028381103627446_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098221350585529937990000011944719664644082859_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008127883270806795870000002218488810501346179_",
    style: {
      clipPath: "url(#SVGID_00000063593499113049022480000005447727650302089663_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151506483823951173310000009991685491953221532_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs585 || (_defs585 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000157293644993482244260000001809150653092617107_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs586 || (_defs586 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000124854552790405223480000018356004191714774680_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs587 || (_defs587 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000008114023834854064050000006944059568601486747_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs588 || (_defs588 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000063591378506333115260000012144764502219955103_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176727165080543716480000012134329097740223398_",
    style: {
      clipPath: "url(#SVGID_00000003069037861088978690000018130353191035958456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157293644993482244260000001809150653092617107_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000045578926423458047990000015369993115036760721_",
    style: {
      clipPath: "url(#SVGID_00000176727165080543716480000012134329097740223398_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124854552790405223480000018356004191714774680_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119821342463994305540000001936353207540913837_",
    style: {
      clipPath: "url(#SVGID_00000045578926423458047990000015369993115036760721_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008114023834854064050000006944059568601486747_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000153675915587328979010000005389967848617768832_",
    style: {
      clipPath: "url(#SVGID_00000119821342463994305540000001936353207540913837_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000063591378506333115260000012144764502219955103_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs589 || (_defs589 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000051350585214625123420000000133425146018741947_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs590 || (_defs590 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152980751161842491940000006285459310030518436_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072273906647893577550000009742544864507604137_",
    style: {
      clipPath: "url(#SVGID_00000003069037861088978690000018130353191035958456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000051350585214625123420000000133425146018741947_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121965695243984153420000002257095879915422123_",
    style: {
      clipPath: "url(#SVGID_00000072273906647893577550000009742544864507604137_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152980751161842491940000006285459310030518436_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs591 || (_defs591 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000144318005195782240700000005571698898640983736_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs592 || (_defs592 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000133514036314044596240000004450673547811163784_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs593 || (_defs593 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000132073699598936655990000002110392999140275127_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000164499404894481464320000010025836062322861720_",
    style: {
      clipPath: "url(#SVGID_00000003069037861088978690000018130353191035958456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000144318005195782240700000005571698898640983736_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168801831774129246870000007876938114520425125_",
    style: {
      clipPath: "url(#SVGID_00000164499404894481464320000010025836062322861720_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000133514036314044596240000004450673547811163784_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074440435280926156980000012058602270780129942_",
    style: {
      clipPath: "url(#SVGID_00000168801831774129246870000007876938114520425125_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132073699598936655990000002110392999140275127_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs594 || (_defs594 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000159460185448415586890000012301941471126980491_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs595 || (_defs595 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116930224259056189320000005984424215573636543_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs596 || (_defs596 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155120103272504258310000009145993830367367864_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs597 || (_defs597 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000145039140101332127350000006719747836469700521_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000089532664074416913960000006917337087602693776_",
    style: {
      clipPath: "url(#SVGID_00000003069037861088978690000018130353191035958456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000159460185448415586890000012301941471126980491_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088118134851227271160000016516550676774093970_",
    style: {
      clipPath: "url(#SVGID_00000089532664074416913960000006917337087602693776_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116930224259056189320000005984424215573636543_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008858560874161217280000000952149083450542480_",
    style: {
      clipPath: "url(#SVGID_00000088118134851227271160000016516550676774093970_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155120103272504258310000009145993830367367864_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000086681248373580390190000009643970218845910421_",
    style: {
      clipPath: "url(#SVGID_00000008858560874161217280000000952149083450542480_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145039140101332127350000006719747836469700521_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs598 || (_defs598 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000071535082844555461810000008662154450344786863_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs599 || (_defs599 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000181050282809331703210000002721892583247713947_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs600 || (_defs600 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000124847251094002639660000014248228080721602475_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs601 || (_defs601 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000142879403322977057900000016074426380293909427_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs602 || (_defs602 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000021091234784204233450000012740928087741898137_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100373397719004126790000013864436660254325917_",
    style: {
      clipPath: "url(#SVGID_00000003069037861088978690000018130353191035958456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071535082844555461810000008662154450344786863_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096033215540204643050000000990799652309942445_",
    style: {
      clipPath: "url(#SVGID_00000100373397719004126790000013864436660254325917_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181050282809331703210000002721892583247713947_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047035330167553532460000010713172780080188805_",
    style: {
      clipPath: "url(#SVGID_00000096033215540204643050000000990799652309942445_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124847251094002639660000014248228080721602475_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049181530181549353270000005633975865595811472_",
    style: {
      clipPath: "url(#SVGID_00000047035330167553532460000010713172780080188805_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142879403322977057900000016074426380293909427_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149375270610687932360000004906501093448596383_",
    style: {
      clipPath: "url(#SVGID_00000049181530181549353270000005633975865595811472_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021091234784204233450000012740928087741898137_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs603 || (_defs603 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000060725295213737665890000001150649774231893636_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs604 || (_defs604 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000060020874048686558440000015226491196139026575_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs605 || (_defs605 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000025413679307421809590000001816894035698802856_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs606 || (_defs606 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000060718196910975439880000000052706293275065261_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), _defs607 || (_defs607 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000058550227987997462580000014070264649807842748_",
    points: "0.5,3.5 1.5,3.5 0.5,4.5  "
  }))), _defs608 || (_defs608 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000124122315566561492500000012538390061476713108_",
    points: "-1.5,1.5 -2.5,1.5 -1.5,0.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101088407194928708000000014853031989806572222_",
    style: {
      clipPath: "url(#SVGID_00000003069037861088978690000018130353191035958456_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060725295213737665890000001150649774231893636_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122687409615970443780000018239590224174661012_",
    style: {
      clipPath: "url(#SVGID_00000101088407194928708000000014853031989806572222_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060020874048686558440000015226491196139026575_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009561107346951433450000011789618467794399375_",
    style: {
      clipPath: "url(#SVGID_00000122687409615970443780000018239590224174661012_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000025413679307421809590000001816894035698802856_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000051342659327918423310000002415185442158910643_",
    style: {
      clipPath: "url(#SVGID_00000009561107346951433450000011789618467794399375_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060718196910975439880000000052706293275065261_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000172400600469262430550000014286881689943382186_",
    style: {
      clipPath: "url(#SVGID_00000051342659327918423310000002415185442158910643_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058550227987997462580000014070264649807842748_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000138553064733891092660000012557417342233920906_",
    style: {
      clipPath: "url(#SVGID_00000172400600469262430550000014286881689943382186_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124122315566561492500000012538390061476713108_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065045669800428941750000015365691571693477265_",
    gradientUnits: "userSpaceOnUse",
    x1: -246.5726,
    y1: 138.5988,
    x2: -242.542,
    y2: 99.5241,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000138553064733891092660000012557417342233920906_)",
      fill: "url(#SVGID_00000065045669800428941750000015365691571693477265_)"
    },
    d: " M40.4,90.3l11.4,11.4c1.1-0.4,2.2-0.9,3.1-1.7L42,87.3C41.4,88.2,40.7,89.2,40.4,90.3z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047034059850097353780000007991111761315430044_",
    gradientUnits: "userSpaceOnUse",
    x1: -246.5726,
    y1: 138.5988,
    x2: -242.542,
    y2: 99.5241,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000003069037861088978690000018130353191035958456_)",
      mask: "url(#SVGID_00000083804382630307500360000015418305472531482532_)",
      fill: "url(#SVGID_00000047034059850097353780000007991111761315430044_)"
    },
    d: " M40.4,90.3l11.4,11.4c1.1-0.4,2.2-0.9,3.1-1.7L42,87.3C41.4,88.2,40.7,89.2,40.4,90.3z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060721283376189836750000015196517276620404880_",
    gradientUnits: "userSpaceOnUse",
    x1: -246.5726,
    y1: 138.5988,
    x2: -242.542,
    y2: 99.5241,
    gradientTransform: "matrix(-1 0 0 -1 -197.7061 221.4703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000060721283376189836750000015196517276620404880_)",
      enableBackground: "new"
    },
    d: " M40.4,90.3l11.4,11.4c1.1-0.4,2.2-0.9,3.1-1.7L42,87.3C41.4,88.2,40.7,89.2,40.4,90.3z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWidget1);
export default __webpack_public_path__ + "static/media/home-widget-1.8d4e3d58a6ba08cef4c9e44083457c1e.svg";
export { ForwardRef as ReactComponent };